/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.1.4 routes of TwelveApp::Application.
 * @version d1649ecf589f5d80fdd0085bcd97efa481f7bb8a7a73af4618713897a4cea0cf
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: true,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/abandon_oryx_extract
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abandonOryxExtractImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"abandon_oryx_extract"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammates/:id/absences(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const absencesRcmServicesTeammatePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"absences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/accept_all_snapshot_table_changes
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptAllSnapshotTableChangesImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"accept_all_snapshot_table_changes"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/language_suggestion/accept
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptLanguageSuggestionLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"language_suggestion"],[2,[7,"/"],[6,"accept"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_plans/:id/accept(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptLocationApiV1PatientTreatmentPlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/documents/:id/accept
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptLocationRcmDocumentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"accept"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/submissions/:id/accept(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptLocationReferralsSubmissionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/accept_snapshot_changes
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptSnapshotChangesImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"accept_snapshot_changes"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/settings/accept_suggestions(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptSuggestionsEnterpriseMarketingSettingsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"accept_suggestions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:account_id/invitations/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountAccountInvitationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:account_id/invitations(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountAccountInvitationsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:account_id/members/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountAccountUserPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:account_id/members(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountAccountUsersPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_invitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountInvitationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /link-setup/account/:token
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountLinkSetupPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"link-setup"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[3,"token"]]]]]]);

/**
 * Generates rails route to
 * /link-setup/account/:token/download
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountLinkSetupDownloadPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"link-setup"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[6,"download"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/account_merge_preflight
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountMergePreflightImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"account_merge_preflight"]]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/check_in/items/:key/acknowledge
 * @param {any} locationId
 * @param {any} id
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acknowledgeCheckInItemLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"key":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"key"],[2,[7,"/"],[6,"acknowledge"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/check_out/items/:key/acknowledge
 * @param {any} locationId
 * @param {any} id
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acknowledgeCheckOutItemLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"key":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_out"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"key"],[2,[7,"/"],[6,"acknowledge"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/acknowledge_claim_denial_notice(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acknowledgeClaimDenialNoticeLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"acknowledge_claim_denial_notice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/appointments/:id/acknowledge_guidance(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acknowledgeGuidanceLocationApiV1AppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"acknowledge_guidance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/faxes/:id/acknowledge(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acknowledgeRcmServicesFaxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"faxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"acknowledge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/email/activate(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateSettingsLocationEmailPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scorecards/:id/activate
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateTwelveTeamScorecardPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"activate"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/live_calls/active
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeLocationLiveCallsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"live_calls"],[2,[7,"/"],[6,"active"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks/:id/activity(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activityLocationTaskPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/activity(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activityRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/ada_form
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaFormLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"ada_form"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/ada_form
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaFormLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"ada_form"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/add_browser_line
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addBrowserLineInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"add_browser_line"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/add_claim
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addClaimLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"add_claim"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/add_claim
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addClaimRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"add_claim"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/add_comment
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addCommentImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"add_comment"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/documents/:id/add_comment
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addCommentLocationRcmDocumentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"add_comment"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/documents/:document_id/add_pages
 * @param {any} locationId
 * @param {any} id
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addDocumentPagesLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"document_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[6,"add_pages"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/add_files
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addFilesLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"add_files"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/add_insurance_coverage
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addInsuranceCoverageLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"add_insurance_coverage"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/add_insurance_request_comment(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addInsuranceRequestCommentRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_insurance_request_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/teams/:id/add_member(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addMemberEnterpriseTeamPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_member"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/families/:id/add_member
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addMemberLocationFamilyPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"families"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"add_member"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/medical_claims/:id/add_procedure
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addProcedureLocationPatientMedicalClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"medical_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"add_procedure"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/appointments/:id/add_recall_add_ons(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addRecallAddOnsLocationApiV1AppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_recall_add_ons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/add_station_note
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addStationNoteImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"add_station_note"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/daily/add_suggested_add_ons(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addSuggestedAddOnsLocationDailyIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"daily"],[2,[7,"/"],[2,[6,"add_suggested_add_ons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/add_supplemental_procedure
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addSupplementalProcedureLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"add_supplemental_procedure"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/add_supplemental_procedure
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addSupplementalProcedureRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"add_supplemental_procedure"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/roles/:id/add_user(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addUserEnterpriseRolePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/fee_schedules/:id/adjust_fees
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adjustFeesLocationFeeSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"fee_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"adjust_fees"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/treatments/adjustment_type_options
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adjustmentTypeOptionsLocationPatientOdontogramTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[6,"adjustment_type_options"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/adjustments_data(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adjustmentsDataEnterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"adjustments_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/adjustments_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adjustmentsDataReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"adjustments_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/adjustments(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adjustmentsEnterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"adjustments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/adjustments(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adjustmentsEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"adjustments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/adjustments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adjustmentsReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"adjustments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/adopt_a2p_registration(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adoptA2pRegistrationInternalAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"adopt_a2p_registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/migration_runs/adopt
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adoptImplementationImplementationMigrationRunsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"migration_runs"],[2,[7,"/"],[6,"adopt"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/adopt_pearl_organization
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adoptPearlOrganizationImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"adopt_pearl_organization"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/adopt_pearl_organization(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adoptPearlOrganizationInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"adopt_pearl_organization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/demos/advance_ambient_scenario(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const advanceAmbientScenarioInternalDemosPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[6,"advance_ambient_scenario"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/demos/advance_claim_documentation_scenario(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const advanceClaimDocumentationScenarioInternalDemosPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[6,"advance_claim_documentation_scenario"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/applications/:id/advance(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const advanceCredentialingApplicationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"advance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_config/v1/tools/describe_connection(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentConfigV1DescribeConnectionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_config"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"describe_connection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_config/v1/tools/finish_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentConfigV1FinishSetupPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_config"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"finish_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_config/v1/tools/get_agent_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentConfigV1GetAgentConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_config"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_agent_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_config/v1/tools/get_run_trace(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentConfigV1GetRunTracePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_config"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_run_trace"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_config/v1/tools/get_trigger_setup_instructions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentConfigV1GetTriggerSetupInstructionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_config"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_trigger_setup_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_config/v1/tools/list_account_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentConfigV1ListAccountUsersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_config"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_account_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_config/v1/tools/list_agent_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentConfigV1ListAgentFilesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_config"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_agent_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_config/v1/tools/list_available_connections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentConfigV1ListAvailableConnectionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_config"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_available_connections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_config/v1/tools/list_past_runs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentConfigV1ListPastRunsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_config"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_past_runs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_config/v1/tools/run_agent_now(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentConfigV1RunAgentNowPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_config"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"run_agent_now"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_config/v1/tools/start_iteration_run(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentConfigV1StartIterationRunPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_config"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"start_iteration_run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_config/v1/tools/update_agent_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentConfigV1UpdateAgentConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_config"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"update_agent_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_config/v1/tools/update_agent_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentConfigV1UpdateAgentDetailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_config"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"update_agent_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/runs/:public_id/trace(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1Path = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"trace"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/attachments/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1AttachmentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/agent_files/clone(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1ClonePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"agent_files"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/tools/create_artifact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1CreateArtifactPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"create_artifact"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/agent_files/delete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1DeletePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"agent_files"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/events/run_finished(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1EventsRunFinishedPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"run_finished"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/events/run_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1EventsRunProgressPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"run_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/events/run_started(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1EventsRunStartedPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"run_started"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/tools/export_report_artifacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1ExportReportArtifactsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"export_report_artifacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/tools/get_email_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1GetEmailListsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_email_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/tools/get_query_examples(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1GetQueryExamplesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_query_examples"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/tools/get_table_schema(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1GetTableSchemaPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_table_schema"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/tools/get_text_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1GetTextListsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_text_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/agent_files/list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1ListPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"agent_files"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/tools/list_metrics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1ListMetricsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/agent_files/read(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1ReadPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"agent_files"],[2,[7,"/"],[2,[6,"read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/tools/resolve_metric(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1ResolveMetricPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"resolve_metric"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/agent_files/restore_previous(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1RestorePreviousPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"agent_files"],[2,[7,"/"],[2,[6,"restore_previous"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/tools/run_query(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1RunQueryPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"run_query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/tools/send_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1SendEmailPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/tools/send_text(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1SendTextPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"send_text"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent_runtime/v1/agent_files/write(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agentRuntimeV1WritePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agent_runtime"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"agent_files"],[2,[7,"/"],[2,[6,"write"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/action_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiActionRequestPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"action_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/chats/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiChatPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/chat_attachments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiChatAttachmentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"chat_attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai_chats/:chat_id/messages/:message_id/feedback(.:format)
 * @param {any} chatId
 * @param {any} messageId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiChatMessageFeedbackPath = /*#__PURE__*/ __route({"chat_id":{"r":true},"message_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai_chats"],[2,[7,"/"],[2,[3,"chat_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"message_id"],[2,[7,"/"],[2,[6,"feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/chats/:chat_id/messages(.:format)
 * @param {any} chatId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiChatMessagesPath = /*#__PURE__*/ __route({"chat_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[3,"chat_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/chats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiChatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"chats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai/client_tool/respond(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiClientToolRespondPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"client_tool"],[2,[7,"/"],[2,[6,"respond"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai_invocations/:public_id/feedback(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiInvocationFeedbackPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai_invocations"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/ai_reports/:inquiry_id/archive(.:format)
 * @param {any} accountId
 * @param {any} inquiryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiReportArchiveEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"inquiry_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"ai_reports"],[2,[7,"/"],[2,[3,"inquiry_id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/ai_reports/:inquiry_id/archive(.:format)
 * @param {any} inquiryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiReportArchiveReportsPath = /*#__PURE__*/ __route({"inquiry_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"ai_reports"],[2,[7,"/"],[2,[3,"inquiry_id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/ai_report_inquiries(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiReportInquiriesEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"ai_report_inquiries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/ai_report_inquiries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiReportInquiriesReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"ai_report_inquiries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/ai_reports/:inquiry_id/pin(.:format)
 * @param {any} accountId
 * @param {any} inquiryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiReportPinEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"inquiry_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"ai_reports"],[2,[7,"/"],[2,[3,"inquiry_id"],[2,[7,"/"],[2,[6,"pin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/ai_reports/:inquiry_id/pin(.:format)
 * @param {any} inquiryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiReportPinReportsPath = /*#__PURE__*/ __route({"inquiry_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"ai_reports"],[2,[7,"/"],[2,[3,"inquiry_id"],[2,[7,"/"],[2,[6,"pin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/ai_reports/:inquiry_id(.:format)
 * @param {any} accountId
 * @param {any} inquiryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiReportShowEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"inquiry_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"ai_reports"],[2,[7,"/"],[2,[3,"inquiry_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/ai_reports/:inquiry_id(.:format)
 * @param {any} inquiryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiReportShowReportsPath = /*#__PURE__*/ __route({"inquiry_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"ai_reports"],[2,[7,"/"],[2,[3,"inquiry_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/ai_reports/:inquiry_id/unpin(.:format)
 * @param {any} accountId
 * @param {any} inquiryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiReportUnpinEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"inquiry_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"ai_reports"],[2,[7,"/"],[2,[3,"inquiry_id"],[2,[7,"/"],[2,[6,"unpin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/ai_reports/:inquiry_id/unpin(.:format)
 * @param {any} inquiryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiReportUnpinReportsPath = /*#__PURE__*/ __route({"inquiry_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"ai_reports"],[2,[7,"/"],[2,[3,"inquiry_id"],[2,[7,"/"],[2,[6,"unpin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/ai_reports(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiReportsEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"ai_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/ai_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiReportsReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"ai_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/always_drawing
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alwaysDrawingLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"always_drawing"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/holds/answer
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const answerCredentialingHoldsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"holds"],[2,[7,"/"],[6,"answer"]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/agent_review/findings/:finding_id/answer
 * @param {any} implementationId
 * @param {any} findingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const answerImplementationImplementationAgentReviewPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"finding_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"agent_review"],[2,[7,"/"],[2,[6,"findings"],[2,[7,"/"],[2,[3,"finding_id"],[2,[7,"/"],[6,"answer"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api-docs/:token/reference
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiDocsReferencePath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"api-docs"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[6,"reference"]]]]]]);

/**
 * Generates rails route to
 * /api/v1/desktop/external_letters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1DesktopExternalLetterPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"desktop"],[2,[7,"/"],[2,[6,"external_letters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/xray_mounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1XrayMountsPath = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"xray_mounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/ambient_sessions/:id/append_chunk(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appendChunkLocationApiV1AmbientSessionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ambient_sessions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"append_chunk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/families/:id/apply_address
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applyAddressLocationFamilyPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"families"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"apply_address"]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/change_sets/:id/apply
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applyCredentialingChangeSetPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"change_sets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"apply"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/treatments/apply_discount
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applyDiscountLocationPatientOdontogramTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[6,"apply_discount"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/invoice_reconciliations/apply(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applyEnterpriseInvoiceReconciliationsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"invoice_reconciliations"],[2,[7,"/"],[2,[6,"apply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/regressions/:id/apply
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applyImplementationImplementationRegressionPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"regressions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"apply"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_sheet_import_runs/:id/apply
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applyImplementationImplementationSetupSheetImportRunPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_sheet_import_runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"apply"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/fee_schedules/:id/apply_import
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applyImportLocationFeeSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"fee_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"apply_import"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/apply_insurance_suggestion(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applyInsuranceSuggestionRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply_insurance_suggestion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/apply_job_status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applyJobStatusImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"apply_job_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_plans/:id/apply_phasing(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applyPhasingLocationApiV1PatientTreatmentPlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply_phasing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/ai_carrier_calls/:id/apply(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applyRcmServicesSoftphoneAdminAiCarrierCallPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"ai_carrier_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/carrier_numbers/:id/apply(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applyRcmServicesSoftphoneAdminCarrierNumberPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"carrier_numbers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/schedule_design/apply(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applySettingsLocationScheduleDesignPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"schedule_design"],[2,[7,"/"],[2,[6,"apply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/apply_snapshot_for_location
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applySnapshotForLocationImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"apply_snapshot_for_location"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/invoice_reconciliations/apply_status(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applyStatusEnterpriseInvoiceReconciliationsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"invoice_reconciliations"],[2,[7,"/"],[2,[6,"apply_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_plans/:id/apply_to_invoice
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applyToInvoiceLocationPatientPaymentPlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"apply_to_invoice"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/appointment_efficiency_drill(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appointmentEfficiencyDrillEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"appointment_efficiency_drill"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/appointment_efficiency(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appointmentEfficiencyEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"appointment_efficiency"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/appointment_templates(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appointmentTemplatesLocationAppointmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"appointment_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/appointments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appointmentsDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/appointments(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appointmentsEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/appointments
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appointmentsLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"appointments"]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/appointments_trend(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appointmentsTrendDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"appointments_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/appointments_trend(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appointmentsTrendEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"appointments_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_ar_dashboard/approval(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approvalEnterprisePatientArDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_ar_dashboard"],[2,[7,"/"],[2,[6,"approval"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/action_requests/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveAiActionRequestPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"action_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/approve_collections_review(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveCollectionsReviewLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve_collections_review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_ar_dashboard/:id/approve(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveEnterprisePatientArDashboardPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_ar_dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/provider_requests/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveInternalProviderRequestPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"provider_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/approve_list_translations(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveListTranslationsSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"approve_list_translations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/approve(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/approve_outreach_candidate(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveOutreachCandidateLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve_outreach_candidate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/approve_scheduling_request(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveSchedulingRequestLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve_scheduling_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /central/:account_id/rcm/dashboard/ar_aging
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const arAgingCentralRcmDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"ar_aging"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/ar_aging(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const arAgingEnterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"ar_aging"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/dashboard/ar_aging
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const arAgingLocationRcmDashboardIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"ar_aging"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/reports/ar_aging
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const arAgingRcmServicesReportsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[6,"ar_aging"]]]]]]);

/**
 * Generates rails route to
 * /reports/ar_aging(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const arAgingReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"ar_aging"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/archive_account_appointment_category
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveAccountAppointmentCategoryImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"archive_account_appointment_category"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/appointment_categories/archive_category
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveCategoryEnterprisePoliciesAppointmentCategoriesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"appointment_categories"],[2,[7,"/"],[6,"archive_category"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/appointment_categories/archive_category(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveCategorySettingsLocationAppointmentCategoriesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"appointment_categories"],[2,[7,"/"],[2,[6,"archive_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/credential_types/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveCredentialingCredentialTypePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"credential_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/payers/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveCredentialingPayerPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"payers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/payer_application_forms/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveCredentialingPayerApplicationFormPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"payer_application_forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/practices/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveCredentialingPracticePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"practices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/profiles/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveCredentialingProfilePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/archive_document
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveDocumentImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"archive_document"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/:id/archive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveEnterpriseAgentPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/custom_codes/:id/archive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveEnterpriseCustomCodePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"custom_codes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/library/presentations/:id/archive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveEnterpriseLibraryPagePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/membership_plans/:id/archive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveEnterpriseMembershipPlanPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"membership_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_prompts/:id/archive
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveEnterprisePoliciesClinicalNotePromptPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"clinical_note_prompts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"archive"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_templates/:id/archive
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveEnterprisePoliciesClinicalNoteTemplatePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"archive"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/prescription_favorites/:id/archive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveEnterprisePrescriptionFavoritePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"prescription_favorites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/categories/:id/archive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveEnterpriseReferralsCategoryPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/letter_template/archive(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveEnterpriseReferralsLetterTemplatePath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letter_template"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/practices/:id/archive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveEnterpriseReferralsPracticePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"practices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/providers/:id/archive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveEnterpriseReferralsProviderPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/users/:id/archive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveEnterpriseUserPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:id/archive
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveInternalImplementationPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"archive"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/archive_lab
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveLabImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"archive_lab"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/faxes/:id/archive
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveLocationFaxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"faxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"archive"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/fee_schedules/:id/archive
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveLocationFeeSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"fee_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"archive"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/archive
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"archive"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/categories/:id/archive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveLocationReferralsCategoryPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/letter_template/archive(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveLocationReferralsLetterTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letter_template"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/practices/:id/archive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveLocationReferralsPracticePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"practices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/providers/:id/archive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveLocationReferralsProviderPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/archive_outreach_candidate_patient(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveOutreachCandidatePatientLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive_outreach_candidate_patient"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/faxes/:id/archive_sent
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveSentLocationFaxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"faxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"archive_sent"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_prompts/:id/archive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveSettingsClinicalNotePromptPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_prompts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_templates/:id/archive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveSettingsClinicalNoteTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/adjustment_types/:id/archive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveSettingsLocationAdjustmentTypePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"adjustment_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/custom_codes/:id/archive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveSettingsLocationCustomCodePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_codes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/labs/:id/archive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveSettingsLocationLabPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"labs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/operatories/:id/archive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveSettingsLocationOperatoryPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"operatories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/prescription_favorites/:id/archive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveSettingsLocationPrescriptionFavoritePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"prescription_favorites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/providers/:id/archive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveSettingsProviderPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/stations/:id
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveStationImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[2,[6,"stations"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scenarios/:id/archive
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveTwelveTeamScenarioPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"archive"]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scorecards/:id/archive
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveTwelveTeamScorecardPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"archive"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:appointment_id/operatory_wait/arrive
 * @param {any} locationId
 * @param {any} appointmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const arriveLocationAppointmentOperatoryWaitPath = /*#__PURE__*/ __route({"location_id":{"r":true},"appointment_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"appointment_id"],[2,[7,"/"],[2,[6,"operatory_wait"],[2,[7,"/"],[6,"arrive"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/verification_queue/ask_form_options(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const askFormOptionsLocationRcmVerificationQueueIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"verification_queue"],[2,[7,"/"],[2,[6,"ask_form_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/agent_review/reviews/:review_id/ask
 * @param {any} implementationId
 * @param {any} reviewId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const askImplementationImplementationAgentReviewPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"review_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"agent_review"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"review_id"],[2,[7,"/"],[6,"ask"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/ask
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const askLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"ask"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bank_transactions/:id/ask_office
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const askOfficeRcmServicesPostingBankTransactionPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bank_transactions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"ask_office"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/ask_office
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const askOfficeRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"ask_office"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/ask_office
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const askOfficeRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"ask_office"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/ask_twelve/ai_summary
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const askTwelveAiSummaryLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ask_twelve"],[2,[7,"/"],[6,"ai_summary"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/ask_twelve/conversations
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const askTwelveConversationsLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ask_twelve"],[2,[7,"/"],[6,"conversations"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/ask_twelve
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const askTwelveLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"ask_twelve"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/ask_twelve/open_tasks
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const askTwelveOpenTasksLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ask_twelve"],[2,[7,"/"],[6,"open_tasks"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/applications/:id/assign(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignCredentialingApplicationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/profiles/:id/assign(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignCredentialingProfilePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/assign_item
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignItemImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"assign_item"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/assign(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/assign_location_mapping
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignLocationMappingImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"assign_location_mapping"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/faxes/:id/assign(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignRcmServicesFaxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"faxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/assign_scheduling_request(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignSchedulingRequestLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_scheduling_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/assign_station_task
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignStationTaskImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"assign_station_task"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/overview/assign_todo
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignTodoImplementationImplementationOverviewPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[6,"assign_todo"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/assignable_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignableUsersRcmServicesInboxIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[6,"assignable_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/assistant_performance(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assistantPerformanceEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"assistant_performance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/assistant_performance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assistantPerformanceReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"assistant_performance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/attach_document(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachDocumentInternalGoLiveConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"attach_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_videos/:id/attach_document(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachDocumentInternalTrainingVideoPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/knowledge/:id/attach_image(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachImageEnterpriseKnowledgePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/knowledge/:id/attach_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachImageInternalKnowledgePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/account/:id/attach_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachImageKnowledgeAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/twelve/:id/attach_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachImageKnowledgeTwelvePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"twelve"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/attach_in_vyne(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachInVyneRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach_in_vyne"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/attach_insurance_payments
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachInsurancePaymentsLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attach_insurance_payments"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/attach_insurance_payments
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachInsurancePaymentsRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attach_insurance_payments"]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/applications/:id/attach_receipt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachReceiptCredentialingApplicationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/applications/:id/attach_signature(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachSignatureCredentialingApplicationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach_signature"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/knowledge/:id/attach_video(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachVideoInternalKnowledgePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach_video"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/attachable_payments
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachablePaymentsLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachable_payments"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/attachable_payments
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachablePaymentsRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachable_payments"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/attachment_fulfillment
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentFulfillmentLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_fulfillment"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/attachment_fulfillment
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentFulfillmentLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_fulfillment"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/attachment_fulfillment(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentFulfillmentRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attachment_fulfillment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/attachment_mount_image
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentMountImageLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_mount_image"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/attachment_mount_image
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentMountImageLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_mount_image"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/attachment_mount_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentMountImageRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attachment_mount_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/attachment_narrative_image
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentNarrativeImageLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_narrative_image"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/attachment_narrative_image
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentNarrativeImageLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_narrative_image"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/attachment_narrative_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentNarrativeImageRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attachment_narrative_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/attachment_narrative
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentNarrativeLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_narrative"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/attachment_narrative
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentNarrativeLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_narrative"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/attachment_narrative_notes
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentNarrativeNotesLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_narrative_notes"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/attachment_narrative_notes
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentNarrativeNotesLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_narrative_notes"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/attachment_narrative_notes(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentNarrativeNotesRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attachment_narrative_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/attachment_narrative(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentNarrativeRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attachment_narrative"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/attachment_perio_chart
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentPerioChartLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_perio_chart"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/attachment_perio_chart
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentPerioChartLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_perio_chart"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/attachment_perio_chart(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentPerioChartRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attachment_perio_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/attachment_preview
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentPreviewLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_preview"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/attachment_preview
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentPreviewLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_preview"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/attachment_preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentPreviewRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attachment_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/attachment_primary_eob
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentPrimaryEobLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_primary_eob"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/attachment_primary_eob
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentPrimaryEobLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_primary_eob"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/attachment_primary_eob(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentPrimaryEobRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attachment_primary_eob"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/attachment_signed_url
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentSignedUrlLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[6,"attachment_signed_url"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/attachment_upload
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentUploadLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_upload"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/attachment_upload
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentUploadLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_upload"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/attachment_upload(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentUploadRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attachment_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/attachment_waiver
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentWaiverLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_waiver"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/attachment_waiver
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentWaiverLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"attachment_waiver"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/attachment_waiver(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentWaiverRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attachment_waiver"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/auto_apply_snapshot
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const autoApplySnapshotImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"auto_apply_snapshot"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages/:id/automated_message_trace
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const automatedMessageTraceLocationMessagePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"automated_message_trace"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/clinical_note_addenda/:id/autosave(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const autosaveLocationApiV1ClinicalNoteAddendumPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clinical_note_addenda"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"autosave"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/clinical_notes/autosave(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const autosaveLocationApiV1ClinicalNotesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clinical_notes"],[2,[7,"/"],[2,[6,"autosave"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/schedule/availability
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const availabilityLocationPatientSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"schedule"],[2,[7,"/"],[6,"availability"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/inbound_numbers/available(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const availableRcmServicesSoftphoneAdminInboundNumbersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"inbound_numbers"],[2,[7,"/"],[2,[6,"available"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_status/backfill_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backfillAllInternalEobStatusIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_status"],[2,[7,"/"],[2,[6,"backfill_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_status/backfill_all_preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backfillAllPreviewInternalEobStatusIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_status"],[2,[7,"/"],[2,[6,"backfill_all_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eligibility_dashboard/backfill
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backfillInternalEligibilityDashboardPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eligibility_dashboard"],[2,[7,"/"],[6,"backfill"]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_status/backfill(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backfillInternalEobStatusIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_status"],[2,[7,"/"],[2,[6,"backfill"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/pre_auth_dashboard/backfill
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backfillInternalPreAuthDashboardPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"pre_auth_dashboard"],[2,[7,"/"],[6,"backfill"]]]]]]);

/**
 * Generates rails route to
 * /internal/eligibility_dashboard/backfill_preview
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backfillPreviewInternalEligibilityDashboardPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eligibility_dashboard"],[2,[7,"/"],[6,"backfill_preview"]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_status/backfill_preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backfillPreviewInternalEobStatusIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_status"],[2,[7,"/"],[2,[6,"backfill_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/pre_auth_dashboard/backfill_preview
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backfillPreviewInternalPreAuthDashboardPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"pre_auth_dashboard"],[2,[7,"/"],[6,"backfill_preview"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/faxes/badge_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const badgeIdsRcmServicesFaxesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"faxes"],[2,[7,"/"],[2,[6,"badge_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/balance_check_mismatches
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const balanceCheckMismatchesImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"balance_check_mismatches"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/balance_check_status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const balanceCheckStatusImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"balance_check_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_ar_dashboard/balances(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const balancesEnterprisePatientArDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_ar_dashboard"],[2,[7,"/"],[2,[6,"balances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/bank_deposit_link_locations
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bankDepositLinkLocationsLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"bank_deposit_link_locations"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/bank_deposit_link_locations
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bankDepositLinkLocationsLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"bank_deposit_link_locations"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/bank_deposit_link_locations
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bankDepositLinkLocationsRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"bank_deposit_link_locations"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/bank_deposit_link_locations
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bankDepositLinkLocationsRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"bank_deposit_link_locations"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/bank_transactions_for_linking
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bankTransactionsForLinkingLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"bank_transactions_for_linking"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/bank_transactions_for_linking
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bankTransactionsForLinkingLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"bank_transactions_for_linking"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/bank_transactions_for_linking
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bankTransactionsForLinkingRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"bank_transactions_for_linking"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/bank_transactions_for_linking
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bankTransactionsForLinkingRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"bank_transactions_for_linking"]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/batch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"batch"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/batch(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/billing
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"billing"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/families/:id/billing_recipient_suggestion
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingRecipientSuggestionLocationFamilyPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"families"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"billing_recipient_suggestion"]]]]]]]]]]);

/**
 * Generates rails route to
 * /billing-setup/:token
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingSetupPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"billing-setup"],[2,[7,"/"],[3,"token"]]]]);

/**
 * Generates rails route to
 * /billing-setup/:token/canceled
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingSetupCanceledPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"billing-setup"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[6,"canceled"]]]]]]);

/**
 * Generates rails route to
 * /billing-setup/:token/complete
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingSetupCompletePath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"billing-setup"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[6,"complete"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_verifications/board_events
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const boardEventsRcmServicesInsuranceVerificationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_verifications"],[2,[7,"/"],[6,"board_events"]]]]]]);

/**
 * Generates rails route to
 * /brands/:brand_id/privacy-policy
 * @param {any} brandId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandPrivacyPolicyPath = /*#__PURE__*/ __route({"brand_id":{"r":true}}, [2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"brand_id"],[2,[7,"/"],[6,"privacy-policy"]]]]]]);

/**
 * Generates rails route to
 * /brands/:brand_id/sms-opt-in
 * @param {any} brandId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandSmsOptInPath = /*#__PURE__*/ __route({"brand_id":{"r":true}}, [2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"brand_id"],[2,[7,"/"],[6,"sms-opt-in"]]]]]]);

/**
 * Generates rails route to
 * /brands/:brand_id/sms-opt-in-details
 * @param {any} brandId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandSmsOptInDetailsPath = /*#__PURE__*/ __route({"brand_id":{"r":true}}, [2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"brand_id"],[2,[7,"/"],[6,"sms-opt-in-details"]]]]]]);

/**
 * Generates rails route to
 * /brands/:brand_id/sms-opt-out
 * @param {any} brandId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandSmsOptOutPath = /*#__PURE__*/ __route({"brand_id":{"r":true}}, [2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"brand_id"],[2,[7,"/"],[6,"sms-opt-out"]]]]]]);

/**
 * Generates rails route to
 * /brands/:brand_id/terms-and-conditions
 * @param {any} brandId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandTermsAndConditionsPath = /*#__PURE__*/ __route({"brand_id":{"r":true}}, [2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"brand_id"],[2,[7,"/"],[6,"terms-and-conditions"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/break(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const breakLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"break"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/collections/:id/breakdown(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const breakdownRcmServicesCollectionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"collections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/browser_line_candidates
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const browserLineCandidatesInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"browser_line_candidates"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/build(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"build"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/applications/bulk_advance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkAdvanceCredentialingApplicationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"bulk_advance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_ar_dashboard/bulk_approve(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkApproveEnterprisePatientArDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_ar_dashboard"],[2,[7,"/"],[2,[6,"bulk_approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup/bulk_approve
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkApproveImplementationImplementationSetupPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[6,"bulk_approve"]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/practices/bulk_archive(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkArchiveCredentialingPracticesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"practices"],[2,[7,"/"],[2,[6,"bulk_archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_templates/bulk_archive
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkArchiveEnterprisePoliciesClinicalNoteTemplatesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[6,"bulk_archive"]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/applications/bulk_assign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkAssignCredentialingApplicationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"bulk_assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/applications/bulk_create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkCreateCredentialingApplicationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_curricula/:training_curriculum_id/entries/bulk_create(.:format)
 * @param {any} trainingCurriculumId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkCreateInternalTrainingCurriculumEntriesPath = /*#__PURE__*/ __route({"training_curriculum_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_curricula"],[2,[7,"/"],[2,[3,"training_curriculum_id"],[2,[7,"/"],[2,[6,"entries"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/documents/bulk_destroy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkDestroyCredentialingDocumentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"bulk_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/enrollments/bulk_destroy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkDestroyCredentialingEnrollmentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"enrollments"],[2,[7,"/"],[2,[6,"bulk_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/documents/bulk_download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkDownloadCredentialingDocumentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"bulk_download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/enrollments/bulk_note(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkNoteCredentialingEnrollmentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"enrollments"],[2,[7,"/"],[2,[6,"bulk_note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/carrier_portal_configs/bulk_soft_delete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkSoftDeleteInternalCarrierPortalConfigsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"carrier_portal_configs"],[2,[7,"/"],[2,[6,"bulk_soft_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/enrollments/bulk_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkStatusCredentialingEnrollmentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"enrollments"],[2,[7,"/"],[2,[6,"bulk_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/practices/bulk_unarchive(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkUnarchiveCredentialingPracticesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"practices"],[2,[7,"/"],[2,[6,"bulk_unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_templates/bulk_unarchive
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkUnarchiveEnterprisePoliciesClinicalNoteTemplatesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[6,"bulk_unarchive"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_videos/bulk_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkUpdateInternalTrainingVideosPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_videos"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_templates/bulk_update_visibility
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkUpdateVisibilityEnterprisePoliciesClinicalNoteTemplatesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[6,"bulk_update_visibility"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/calendar_events(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendarEventsLocationAppointmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"calendar_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/time_blocks/calendar_time_blocks(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendarTimeBlocksLocationTimeBlocksPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"time_blocks"],[2,[7,"/"],[2,[6,"calendar_time_blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scorecards/:id/calibrate
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calibrateTwelveTeamScorecardPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"calibrate"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/call_detail(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const callDetailEnterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"call_detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_ar_dashboard/call_detail(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const callDetailEnterprisePatientArDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_ar_dashboard"],[2,[7,"/"],[2,[6,"call_detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/call_detail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const callDetailReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"call_detail"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/plan_evidence/:id/call_recording
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const callRecordingRcmServicesPlanEvidencePath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"plan_evidence"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"call_recording"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/calls(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const callsEnterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"calls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/calls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const callsReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"calls"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/invoice_reconciliations/cancel_apply(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelApplyEnterpriseInvoiceReconciliationsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"invoice_reconciliations"],[2,[7,"/"],[2,[6,"cancel_apply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/calls/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelCredentialingCallPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/users/:id/cancel_email_change(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelEmailChangeEnterpriseUserPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_email_change"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/invoice_reconciliations/cancel(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelEnterpriseInvoiceReconciliationsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"invoice_reconciliations"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/agent_review/reviews/:review_id/cancel
 * @param {any} implementationId
 * @param {any} reviewId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelImplementationImplementationAgentReviewPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"review_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"agent_review"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"review_id"],[2,[7,"/"],[6,"cancel"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/modento_form_exports/:id/cancel
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelImplementationImplementationModentoFormExportPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"modento_form_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"cancel"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/modento_form_exports/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelInternalModentoFormExportPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"modento_form_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/imports/items/:item_id/cancel(.:format)
 * @param {any} locationId
 * @param {any} itemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelItemSettingsPatientFormImportsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"item_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_plans/:id/cancel
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelLocationPatientPaymentPlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"cancel"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/plan_subscription/cancel
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelLocationPatientPlanSubscriptionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"plan_subscription"],[2,[7,"/"],[6,"cancel"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/virtual_cards/:id/cancel
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelLocationRcmVirtualCardPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"virtual_cards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"cancel"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks/:id/cancel(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelLocationTaskPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/cancel_migration
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelMigrationImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"cancel_migration"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks/:id/cancel_modal(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelModalLocationTaskPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/cancel_oryx_crawl
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelOryxCrawlImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"cancel_oryx_crawl"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/calls/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelRcmServicesCallPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/imports/:id/cancel(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelSettingsPatientFormImportPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/cancel_snapshot
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelSnapshotImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"cancel_snapshot"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/links/:id/snapshots/:snapshot_id/cancel
 * @param {any} id
 * @param {any} snapshotId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelSnapshotInternalLinkPath = /*#__PURE__*/ __route({"id":{"r":true},"snapshot_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[2,[3,"snapshot_id"],[2,[7,"/"],[6,"cancel"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_intents/:id/cancel_terminal_request
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelTerminalRequestLocationPatientPaymentIntentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_intents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"cancel_terminal_request"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_methods/cancel_terminal_request
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelTerminalRequestLocationPatientPaymentMethodsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[6,"cancel_terminal_request"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelUserRegistrationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/virtual_cards/:id/canceled
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const canceledLocationRcmVirtualCardPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"virtual_cards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"canceled"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_merges/candidates(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const candidatesEnterprisePatientMergesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_merges"],[2,[7,"/"],[2,[6,"candidates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/calls/:id/capture_in_flight(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const captureInFlightRcmServicesCallPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"capture_in_flight"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/capture_in_flight(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const captureInFlightRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"capture_in_flight"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/capture_profile_picture_modal
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const captureProfilePictureModalLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"capture_profile_picture_modal"]]]]]]]]]]);

/**
 * Generates rails route to
 * /carrier_calling/ai/assignment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carrierCallingAiAssignmentPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"assignment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /carrier_calling/ai/calls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carrierCallingAiCallsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"calls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /carrier_calling/ai(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carrierCallingAiWorklistPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[2,[7,"/"],[2,[6,"ai"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /carrier_calling/assignment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carrierCallingAssignmentPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[2,[7,"/"],[2,[6,"assignment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /carrier_calling/calls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carrierCallingCallsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[2,[7,"/"],[2,[6,"calls"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /carrier_calling/live(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carrierCallingLivePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[2,[7,"/"],[2,[6,"live"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /carrier_calling(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carrierCallingRootPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /carrier_calling/verifier/calls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carrierCallingVerifierCallsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[2,[7,"/"],[2,[6,"verifier"],[2,[7,"/"],[2,[6,"calls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /carrier_calling/verifier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carrierCallingVerifierWorklistPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[2,[7,"/"],[2,[6,"verifier"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /carrier_calling/worklist(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carrierCallingWorklistIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[2,[7,"/"],[2,[6,"worklist"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/reports/carrier_calls
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carrierCallsRcmServicesReportsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[6,"carrier_calls"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/stats/carrier_calls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carrierCallsRcmServicesStatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"carrier_calls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/deposit_triage/:id/carrier_options
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carrierOptionsRcmServicesDepositTriagePath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"deposit_triage"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"carrier_options"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/deposit_triage/:id/carrier_portal
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carrierPortalRcmServicesDepositTriagePath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"deposit_triage"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"carrier_portal"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/carrier_portal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carrierPortalRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"carrier_portal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/holds/carriers
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carriersCredentialingHoldsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"holds"],[2,[7,"/"],[6,"carriers"]]]]]]);

/**
 * Generates rails route to
 * /central/:account_id/ops_manager
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const centralOpsManagerPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"ops_manager"]]]]]]);

/**
 * Generates rails route to
 * /central/:account_id/rcm/dashboard
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const centralRcmDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[6,"dashboard"]]]]]]]]);

/**
 * Generates rails route to
 * /central/:account_id/rcm/requests_history
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const centralRcmRequestsHistoryIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[6,"requests_history"]]]]]]]]);

/**
 * Generates rails route to
 * /central/:account_id
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const centralRootPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[3,"account_id"]]]]);

/**
 * Generates rails route to
 * /central/:account_id/scheduling
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const centralSchedulingPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"scheduling"]]]]]]);

/**
 * Generates rails route to
 * /ai/chats/:id/cf_session(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cfSessionAiChatPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cf_session"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/odontogram/change_dentition(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changeDentitionLocationApiV1PatientOdontogramPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"change_dentition"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_photos/:id/change_patient
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changePatientLocationPatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"change_patient"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_photos/:id/change_patient_modal
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changePatientModalLocationPatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"change_patient_modal"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/change_plan
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changePlanLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"change_plan"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/schedule_design/changes/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changeSettingsLocationScheduleDesignPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"schedule_design"],[2,[7,"/"],[2,[6,"changes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/schedule_design/changes(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changesSettingsLocationScheduleDesignPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"schedule_design"],[2,[7,"/"],[2,[6,"changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/goto/channel
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const channelSettingsPhoneMessagingGotoPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"goto"],[2,[7,"/"],[6,"channel"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/letter_template/chat(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatEnterpriseReferralsLetterTemplatePath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letter_template"],[2,[7,"/"],[2,[6,"chat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat_exports/:signed_id
 * @param {any} signedId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatExportPath = /*#__PURE__*/ __route({"signed_id":{"r":true}}, [2,[7,"/"],[2,[6,"chat_exports"],[2,[7,"/"],[3,"signed_id"]]]]);

/**
 * Generates rails route to
 * /chat_exports/f/:attachment_id
 * @param {any} attachmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatExportFilePath = /*#__PURE__*/ __route({"attachment_id":{"r":true}}, [2,[7,"/"],[2,[6,"chat_exports"],[2,[7,"/"],[2,[6,"f"],[2,[7,"/"],[3,"attachment_id"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/letter_template/chat(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatLocationReferralsLetterTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letter_template"],[2,[7,"/"],[2,[6,"chat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/xray_mounts/check_deletions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkDeletionsApiV1XrayMountsPath = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"xray_mounts"],[2,[7,"/"],[2,[6,"check_deletions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/email/check_domain(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkDomainSettingsLocationEmailPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"check_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_merges/check(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkEnterprisePatientMergesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_merges"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/verification_queue/check_existing_request(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkExistingRequestLocationRcmVerificationQueueIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"verification_queue"],[2,[7,"/"],[2,[6,"check_existing_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/check_existing_request(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkExistingRequestRcmServicesInboxIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[6,"check_existing_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/check_in
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkInLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"check_in"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/check_in/mark_ready
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkInMarkReadyLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[6,"mark_ready"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/check_in/share
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkInShareLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[6,"share"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/check_out
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkOutLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"check_out"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/email/check_sender(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkSenderSettingsLocationEmailPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"check_sender"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_intents/:id/check_status
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkStatusLocationPatientPaymentIntentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_intents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"check_status"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_methods/check_status
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkStatusLocationPatientPaymentMethodsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[6,"check_status"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/checklist_compliance_data(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checklistComplianceDataEnterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"checklist_compliance_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/checklist_compliance_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checklistComplianceDataReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"checklist_compliance_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/checklist_compliance_details(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checklistComplianceDetailsEnterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"checklist_compliance_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/checklist_compliance_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checklistComplianceDetailsReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"checklist_compliance_details"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/checklist_compliance(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checklistComplianceEnterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"checklist_compliance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/checklist_compliance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checklistComplianceReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"checklist_compliance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/checklist(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checklistLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"checklist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/claim_denial_notice_evidence(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimDenialNoticeEvidenceLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim_denial_notice_evidence"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/claim_document(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimDocumentRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/claim_documentation(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimDocumentationLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim_documentation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/claim_documentation/mounts/:mount_id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {any} mountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimDocumentationMountLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"mount_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim_documentation"],[2,[7,"/"],[2,[6,"mounts"],[2,[7,"/"],[2,[3,"mount_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/claim_documentation/narrative(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimDocumentationNarrativeLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim_documentation"],[2,[7,"/"],[2,[6,"narrative"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/claim_documentation/narrative_notes(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimDocumentationNarrativeNotesLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim_documentation"],[2,[7,"/"],[2,[6,"narrative_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/claim_documentation/perio_charts/:chart_id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {any} chartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimDocumentationPerioChartLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"chart_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim_documentation"],[2,[7,"/"],[2,[6,"perio_charts"],[2,[7,"/"],[2,[3,"chart_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/claim_documentation/remove_upload(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimDocumentationRemoveUploadLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim_documentation"],[2,[7,"/"],[2,[6,"remove_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/demos/claim_documentation_scenario_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimDocumentationScenarioStatusInternalDemosPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[6,"claim_documentation_scenario_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/claim_documentation/send_without(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimDocumentationSendWithoutLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim_documentation"],[2,[7,"/"],[2,[6,"send_without"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/claim_documentation/upload(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimDocumentationUploadLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim_documentation"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /claim_documentation_view_switch
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimDocumentationViewSwitchPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"claim_documentation_view_switch"]]);

/**
 * Generates rails route to
 * /rcm_services/reports/claim_quality
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimQualityRcmServicesReportsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[6,"claim_quality"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/stats/claim_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimStatsRcmServicesStatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"claim_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /central/:account_id/rcm/dashboard/claim_trend
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimTrendCentralRcmDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"claim_trend"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/dashboard/claim_trend
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimTrendLocationRcmDashboardIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"claim_trend"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/stats/claims_aging(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimsAgingRcmServicesStatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"claims_aging"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/claims(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimsEnterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"claims"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/claims(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimsReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"claims"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/cleanup(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanupSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"cleanup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/cleanup_status(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanupStatusSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"cleanup_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/devices/:id/clear_calibration
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clearCalibrationLocationApiV1DevicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"devices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"clear_calibration"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/deposit_triage/:id/clear_not_insurance
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clearNotInsuranceRcmServicesDepositTriagePath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"deposit_triage"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"clear_not_insurance"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/no_call_carriers/:id/clear(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clearRcmServicesSoftphoneAdminNoCallCarrierPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"no_call_carriers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_verifications/replies/:message_id/clear
 * @param {any} messageId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clearReplyRcmServicesInsuranceVerificationsPath = /*#__PURE__*/ __route({"message_id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_verifications"],[2,[7,"/"],[2,[6,"replies"],[2,[7,"/"],[2,[3,"message_id"],[2,[7,"/"],[6,"clear"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/:id/clear_resignature(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clearResignatureSettingsPatientFormTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_resignature"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/text_agent/clear
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clearSettingsPhoneMessagingTextAgentPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"text_agent"],[2,[7,"/"],[6,"clear"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/dosespot/clinic_favorites
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clinicFavoritesLocationDosespotPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"dosespot"],[2,[7,"/"],[6,"clinic_favorites"]]]]]]]]);

/**
 * Generates rails route to
 * /clinical_photos/viewer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clinicalPhotosViewerPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[6,"viewer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/clinician_status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clinicianStatusInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"clinician_status"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:invoice_id/adjustments/:id/close_delete_and_credit_balance_warning
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} invoiceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const closeDeleteAndCreditBalanceWarningLocationPatientInvoiceAdjustmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"invoice_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"close_delete_and_credit_balance_warning"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/clinical_opportunities/:id/close(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const closeLocationApiV1PatientClinicalOpportunityPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_opportunities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/close_panel
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const closePanelLocationPatientsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[6,"close_panel"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/close_schedule_warning(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const closeScheduleWarningLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close_schedule_warning"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/medical_claims/:id/cms1500
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cms1500LocationPatientMedicalClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"medical_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"cms1500"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /central/:account_id/rcm/dashboard/collection_breakdown
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collectionBreakdownCentralRcmDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"collection_breakdown"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/overview_cards/collection_breakdown(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collectionBreakdownEnterpriseOverviewCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"overview_cards"],[2,[7,"/"],[2,[6,"collection_breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/dashboard/collection_breakdown
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collectionBreakdownLocationRcmDashboardIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"collection_breakdown"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/collection(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collectionEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"collection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/collection_validation_status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collectionValidationStatusImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"collection_validation_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/uploads/:id/commit(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const commitEnterpriseMarketingUploadPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"commit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/periodontal_charts/compare
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compareLocationPatientPeriodontalChartsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"periodontal_charts"],[2,[7,"/"],[6,"compare"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/complete_ar_practice_task(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeArPracticeTaskLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete_ar_practice_task"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/check_out/complete
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeCheckOutLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_out"],[2,[7,"/"],[6,"complete"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/links/:id/curve_exports/:export_id/complete
 * @param {any} id
 * @param {any} exportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeCurveExportInternalLinkPath = /*#__PURE__*/ __route({"id":{"r":true},"export_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"curve_exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[6,"complete"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/curve_exports/:id/complete
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeImplementationImplementationCurveExportPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"curve_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"complete"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/referral_contexts/:id/complete(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeLocationApiV1PatientReferralContextPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"referral_contexts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/inbound_records/:id/complete(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeLocationReferralsInboundRecordPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"inbound_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/outbound_records/:id/complete(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeLocationReferralsOutboundRecordPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"outbound_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks/:id/complete(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeLocationTaskPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks/:id/complete_modal(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeModalLocationTaskPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /my_twelve/:account_id/practice_attempts/:id/complete
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeMyTwelvePracticeAttemptPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"my_twelve"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"practice_attempts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"complete"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/overview/complete_step
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeStepImplementationImplementationOverviewPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[6,"complete_step"]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/practice_attempts/:id/complete
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeTwelveTeamPracticeAttemptPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"practice_attempts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"complete"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/complete_unconfirmed_family_visit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeUnconfirmedFamilyVisitLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete_unconfirmed_family_visit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation/complete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeUserConfirmationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/stats/completed_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completedItemsRcmServicesStatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"completed_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/forms/completed
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completedLocationPatientFormsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[6,"completed"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/signatures/completed
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completedLocationSignatureLinksPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[6,"completed"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup/config_review_items
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configReviewItemsImplementationImplementationSetupPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[6,"config_review_items"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_status/configure_carriers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configureCarriersInternalEobStatusIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_status"],[2,[7,"/"],[2,[6,"configure_carriers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation/configure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configureInternalRcmAutomationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[2,[7,"/"],[2,[6,"configure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/confirm_family(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmFamilyLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_family"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/confirm(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/confirm_location_mapping
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmLocationMappingImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"confirm_location_mapping"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/confirm
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"confirm"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/confirm_mango_step
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmMangoStepImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"confirm_mango_step"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:id/confirm_send_statement
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmSendStatementLocationPatientInvoicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"confirm_send_statement"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/:id/confirm_text_receipt
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmTextReceiptLocationPatientPatientPaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"confirm_text_receipt"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/whatconverts/connect(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectEnterpriseMarketingWhatconvertsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"whatconverts"],[2,[7,"/"],[2,[6,"connect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/connect_goto
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectGotoImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"connect_goto"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/links/connect
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectImplementationImplementationLinksPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[6,"connect"]]]]]]]]]]);

/**
 * Generates rails route to
 * /connect/onboarding/complete
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectOnboardingCompletePath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"connect"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[6,"complete"]]]]]]);

/**
 * Generates rails route to
 * /connect/onboarding/:token/refresh
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectOnboardingRefreshPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"connect"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[6,"refresh"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/connected_apps/partners/:partner
 * @param {any} accountId
 * @param {any} partner
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectPartnerEnterpriseConnectedAppsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"partner":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"connected_apps"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[3,"partner"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/connect_pearl
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectPearlImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"connect_pearl"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/connect_pearl(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectPearlInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"connect_pearl"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /central/:account_id/rcm/requests_history/conversation/:task_public_id
 * @param {any} accountId
 * @param {any} taskPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const conversationCentralRcmRequestsHistoryIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true},"task_public_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"requests_history"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[3,"task_public_id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages/conversation/:conversation_id
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const conversationLocationMessagesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[3,"conversation_id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/requests_history/conversation/:task_public_id(.:format)
 * @param {any} locationId
 * @param {any} taskPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const conversationLocationRcmRequestsHistoryIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"task_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"requests_history"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"task_public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /central/:account_id/rcm/requests_history/conversation/:task_public_id/messages
 * @param {any} accountId
 * @param {any} taskPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const conversationMessagesCentralRcmRequestsHistoryIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true},"task_public_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"requests_history"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"task_public_id"],[2,[7,"/"],[6,"messages"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/requests_history/conversation/:task_public_id/messages(.:format)
 * @param {any} locationId
 * @param {any} taskPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const conversationMessagesLocationRcmRequestsHistoryIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"task_public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"requests_history"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"task_public_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const conversationV2LocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[3,"conversation_id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversations_page
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const conversationsPageLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[6,"conversations_page"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/convert_eob_only
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const convertEobOnlyLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"convert_eob_only"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/convert_eob_only
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const convertEobOnlyRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"convert_eob_only"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/convert_not_insurance
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const convertNotInsuranceLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"convert_not_insurance"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/convert_not_insurance
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const convertNotInsuranceRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"convert_not_insurance"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/users/:id/convert_to_full(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const convertToFullEnterpriseUserPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"convert_to_full"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/users/:id/convert_to_limited(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const convertToLimitedEnterpriseUserPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"convert_to_limited"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scorecards/:id/convert
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const convertTwelveTeamScorecardPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"convert"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/copier_copy
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copierCopyImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"copier_copy"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/copier_dry_run
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copierDryRunImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"copier_dry_run"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/text_agent/cover
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coverSettingsPhoneMessagingTextAgentPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"text_agent"],[2,[7,"/"],[6,"cover"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammates/:id/create_absence(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createAbsenceRcmServicesTeammatePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_absence"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/create_account_appointment_category
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createAccountAppointmentCategoryImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"create_account_appointment_category"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/communications/:id/action_item
 * @param {any} locationId
 * @param {any} conversationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createActionItemLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"action_item"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/confirmation_add_ons/create_add_on
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createAddOnEnterprisePoliciesConfirmationAddOnsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"confirmation_add_ons"],[2,[7,"/"],[6,"create_add_on"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_plans/:id/create_agreement
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createAgreementLocationPatientPaymentPlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"create_agreement"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/create_allergy(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createAllergySettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"create_allergy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/forms/create_appointment_forms
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createAppointmentFormsLocationPatientFormsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[6,"create_appointment_forms"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/create_billing_customer
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createBillingCustomerImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"create_billing_customer"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/create_bounced_check
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createBouncedCheckLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"create_bounced_check"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/claim_completeness/create_carrier_override(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createCarrierOverrideRcmServicesClaimCompletenessIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"claim_completeness"],[2,[7,"/"],[2,[6,"create_carrier_override"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/appointment_categories/create_category
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createCategoryEnterprisePoliciesAppointmentCategoriesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"appointment_categories"],[2,[7,"/"],[6,"create_category"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/claim_completeness/create_category(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createCategoryRcmServicesClaimCompletenessIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"claim_completeness"],[2,[7,"/"],[2,[6,"create_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_plan_settings/create_category(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createCategoryRcmServicesInsurancePlanSettingsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_plan_settings"],[2,[7,"/"],[2,[6,"create_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/appointment_categories/create_category(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createCategorySettingsLocationAppointmentCategoriesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"appointment_categories"],[2,[7,"/"],[2,[6,"create_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/treatment_catalogs/create_category(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createCategorySettingsTreatmentCatalogsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"treatment_catalogs"],[2,[7,"/"],[2,[6,"create_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/migration_runs/:id/create_checkpoint
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createCheckpointImplementationImplementationMigrationRunPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"migration_runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"create_checkpoint"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/create_clinic
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createClinicInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"create_clinic"]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/create_clinician
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createClinicianInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"create_clinician"]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/ai_receptionist/:id/create_closure_notice(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createClosureNoticeEnterpriseAiReceptionistPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"ai_receptionist"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_closure_notice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_plan_settings/create_code_group(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createCodeGroupRcmServicesInsurancePlanSettingsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_plan_settings"],[2,[7,"/"],[2,[6,"create_code_group"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/comm_logs
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createCommLogLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[6,"comm_logs"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/ai_outreach/create_config(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createConfigSettingsAiOutreachIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ai_outreach"],[2,[7,"/"],[2,[6,"create_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/online_scheduling/create_config(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createConfigSettingsOnlineSchedulingIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"online_scheduling"],[2,[7,"/"],[2,[6,"create_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/create_connected_account
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createConnectedAccountImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"create_connected_account"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createConversationLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[6,"conversation"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/create_credential
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createCredentialImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"create_credential"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/links/:id/curve_exports
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createCurveExportInternalLinkPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"curve_exports"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/create_delete_payment
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createDeletePaymentLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"create_delete_payment"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/mounts_devices/create_device(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createDeviceSettingsMountsDevicesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"mounts_devices"],[2,[7,"/"],[2,[6,"create_device"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/create_documents
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createDocumentsImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"create_documents"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/providers/:id/create_dosespot_clinician(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createDosespotClinicianInternalProviderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_dosespot_clinician"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/calendar/create_event
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createEventImplementationImplementationCalendarPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[6,"create_event"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_plan_settings/create_field_requirement(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createFieldRequirementRcmServicesInsurancePlanSettingsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_plan_settings"],[2,[7,"/"],[2,[6,"create_field_requirement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/bank_accounts/create_for_plaid
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createForPlaidEnterpriseBankAccountsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"bank_accounts"],[2,[7,"/"],[6,"create_for_plaid"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/bank_accounts/create_for_teller
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createForTellerEnterpriseBankAccountsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"bank_accounts"],[2,[7,"/"],[6,"create_for_teller"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/pre_authorizations_queue/create_from_determination(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createFromDeterminationLocationRcmPreAuthorizationsQueueIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"pre_authorizations_queue"],[2,[7,"/"],[2,[6,"create_from_determination"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_methods/create_from_terminal
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createFromTerminalLocationPatientPaymentMethodsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[6,"create_from_terminal"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/lab_cases/create_from_treatments(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createFromTreatmentsLocationLabCasesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"lab_cases"],[2,[7,"/"],[2,[6,"create_from_treatments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/create_go_live_option(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createGoLiveOptionInternalGoLiveConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"create_go_live_option"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/create_group_provider
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createGroupProviderImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"create_group_provider"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/create_group_provider(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createGroupProviderInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_group_provider"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:id/create_implementation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createImplementationInternalGoLivePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_implementation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/treatment_catalogs/create_item(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createItemSettingsTreatmentCatalogsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"treatment_catalogs"],[2,[7,"/"],[2,[6,"create_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/create_lab
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createLabImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"create_lab"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/create_location
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createLocationImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"create_location"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/create_location_todo
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createLocationTodoImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"create_location_todo"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/create_mango_configuration
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createMangoConfigurationImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"create_mango_configuration"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/dosespot/create_manual
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createManualLocationDosespotPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"dosespot"],[2,[7,"/"],[6,"create_manual"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/treatments/create_manual
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createManualTreatmentLocationPatientOdontogramTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[6,"create_manual"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/perio_charts/:id/create_measurement
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createMeasurementLocationPatientPerioChartPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"perio_charts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"create_measurement"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/create_merchant_fee
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createMerchantFeeLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"create_merchant_fee"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/bank_deposits/:id/create_note
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createNoteLocationBankDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"bank_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"create_note"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/create_note
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createNoteLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"create_note"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/create_note
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createNoteLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"create_note"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bank_transactions/:id/create_note
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createNoteRcmServicesPostingBankTransactionPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bank_transactions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"create_note"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/create_note
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createNoteRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"create_note"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/create_note
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createNoteRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"create_note"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/create_operatory
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createOperatoryImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"create_operatory"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/claim_completeness/create_override(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createOverrideRcmServicesClaimCompletenessIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"claim_completeness"],[2,[7,"/"],[2,[6,"create_override"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/deposit_triage/:id/create_pattern
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createPatternRcmServicesDepositTriagePath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"deposit_triage"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"create_pattern"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/create_phase(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createPhaseInternalGoLiveConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"create_phase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/create_phone_number
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createPhoneNumberImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"create_phone_number"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/bank_accounts/create_plaid_link_token
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createPlaidLinkTokenEnterpriseBankAccountsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"bank_accounts"],[2,[7,"/"],[6,"create_plaid_link_token"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/treatments/create_preauth_from_visits
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createPreauthFromVisitsLocationPatientOdontogramTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[6,"create_preauth_from_visits"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/treatments/create_preauth
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createPreauthLocationPatientOdontogramTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[6,"create_preauth"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/create_prepayment
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createPrepaymentLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"create_prepayment"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/create_problem_group(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createProblemGroupSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"create_problem_group"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/create_problem(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createProblemSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"create_problem"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_templates/create_prompt
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createPromptEnterprisePoliciesClinicalNoteTemplatesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[6,"create_prompt"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_templates/create_prompt(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createPromptSettingsClinicalNoteTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[2,[6,"create_prompt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammates/:id/create_rate_change(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createRateChangeRcmServicesTeammatePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_rate_change"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/create_recall
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createRecallLocationPatientOdontogramPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[6,"create_recall"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/create_refund_from_credit
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createRefundFromCreditLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"create_refund_from_credit"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/create_refund
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createRefundLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"create_refund"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/create_request(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createRequestRcmServicesInboxIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[6,"create_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/create_station
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createStationImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"create_station"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/create_station_task(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createStationTaskInternalGoLiveConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"create_station_task"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/create_stripe_connected_account
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createStripeConnectedAccountInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"create_stripe_connected_account"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/verification_queue/create_task(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createTaskLocationRcmVerificationQueueIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"verification_queue"],[2,[7,"/"],[2,[6,"create_task"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/create_team
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createTeamImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"create_team"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/mounts_devices/create_template(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createTemplateSettingsMountsDevicesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"mounts_devices"],[2,[7,"/"],[2,[6,"create_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/modento_form_import_runs/:id/create_templates
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createTemplatesImplementationImplementationModentoFormImportRunPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"modento_form_import_runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"create_templates"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/create_todo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createTodoInternalGoLiveConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"create_todo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/create_transfer_to_family_member
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createTransferToFamilyMemberLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"create_transfer_to_family_member"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/treatments
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createTreatmentLocationPatientOdontogramTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[6,"treatments"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/create_twilio_subaccount(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createTwilioSubaccountInternalAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_twilio_subaccount"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/verification_queue/create_verification_request(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createVerificationRequestLocationRcmVerificationQueueIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"verification_queue"],[2,[7,"/"],[2,[6,"create_verification_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/create_visit_forms
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createVisitFormsLocationPatientOdontogramPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[6,"create_visit_forms"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/xray_mounts/creation_metadata(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creationMetadataApiV1XrayMountsPath = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"xray_mounts"],[2,[7,"/"],[2,[6,"creation_metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingAccountsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/ai_chat(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingAiChatPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"ai_chat"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingApplicationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingApplicationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/calls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingCallPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/calls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingCallsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"calls"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/chats
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingChatsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[6,"chats"]]]]);

/**
 * Generates rails route to
 * /credentialing/credentials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingCreateCredentialPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/credentials/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingCredentialPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/credential_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingCredentialTypePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"credential_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/credential_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingCredentialTypesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"credential_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/credentials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingCredentialsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingDashboardIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingDocumentPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/document_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingDocumentTypePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/document_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingDocumentTypesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingDocumentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/enrollments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingEnrollmentPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"enrollments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/enrollments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingEnrollmentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"enrollments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/holds
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingHoldsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[6,"holds"]]]]);

/**
 * Generates rails route to
 * /credentialing/malpractice_cases/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingMalpracticeCasePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"malpractice_cases"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/malpractice_cases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingMalpracticeCasesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"malpractice_cases"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/payers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingPayerPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"payers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/payer_application_forms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingPayerApplicationFormPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"payer_application_forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/payer_application_forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingPayerApplicationFormsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"payer_application_forms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/payer_states/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingPayerStatePath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"payer_states"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /credentialing/payer_states
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingPayerStatesPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[6,"payer_states"]]]]);

/**
 * Generates rails route to
 * /credentialing/payers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingPayersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"payers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/practices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingPracticePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"practices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/practices/:practice_id/payer_audit(.:format)
 * @param {any} practiceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingPracticePayerAuditPath = /*#__PURE__*/ __route({"practice_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"practices"],[2,[7,"/"],[2,[3,"practice_id"],[2,[7,"/"],[2,[6,"payer_audit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/practices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingPracticesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"practices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/profiles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingProfilePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/profiles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingProfilesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingRootPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /credentialing/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingSettingsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/state_notes/:state
 * @param {any} state
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentialingStateNotePath = /*#__PURE__*/ __route({"state":{"r":true}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"state_notes"],[2,[7,"/"],[3,"state"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/credit_ledger
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creditLedgerLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"credit_ledger"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/cross_location_payments(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const crossLocationPaymentsEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"cross_location_payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks/:id/custom_snooze_modal(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customSnoozeModalLocationTaskPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"custom_snooze_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/daily_audit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dailyAuditDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"daily_audit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/daily_audit(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dailyAuditEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"daily_audit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/data_cleanup_status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataCleanupStatusImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"data_cleanup_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/demos/data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataInternalDemosPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/data_model_verification_status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataModelVerificationStatusImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"data_model_verification_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentation_snapshots/:id/decision
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decisionLocationPatientTreatmentPresentationSnapshotPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentation_snapshots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"decision"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/declare_covered_lines
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const declareCoveredLinesLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"declare_covered_lines"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/declare_covered_lines
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const declareCoveredLinesRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"declare_covered_lines"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammates/:id/delete_absence(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteAbsenceRcmServicesTeammatePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_absence"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks/:id/delete_active(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteActiveLocationTaskPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/fee_schedules/:id/delete_all_fees
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteAllFeesLocationFeeSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"fee_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"delete_all_fees"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/comm_logs/:id
 * @param {any} locationId
 * @param {any} conversationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteCommLogLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"comm_logs"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/delete_conversation_message(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteConversationMessageRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_conversation_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/coverage_category_mappings/:public_id
 * @param {any} implementationId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteCoverageCategoryMappingImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"public_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"coverage_category_mappings"],[2,[7,"/"],[3,"public_id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/credentials/:id
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteCredentialImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/delete_dosespot_config
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteDosespotConfigImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"delete_dosespot_config"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/delete_dosespot_config(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteDosespotConfigInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_dosespot_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/delete_eob
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteEobLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"delete_eob"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/delete_eob
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteEobRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"delete_eob"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages/:id/delete
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteLocationMessagePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"delete"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/messages/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteMessageLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/delete_pearl_config
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deletePearlConfigImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"delete_pearl_config"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/delete_pearl_config(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deletePearlConfigInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_pearl_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/delete_pylon_config
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deletePylonConfigImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"delete_pylon_config"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/delete_pylon_config(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deletePylonConfigInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_pylon_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammates/:id/delete_rate_change(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteRateChangeRcmServicesTeammatePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_rate_change"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/delete_retell_config
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteRetellConfigImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"delete_retell_config"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/delete_retell_config(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteRetellConfigInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_retell_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/delete_swell_config
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteSwellConfigImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"delete_swell_config"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/delete_swell_config(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteSwellConfigInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_swell_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/delete_team
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteTeamImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"delete_team"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/delete_twilio_config
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteTwilioConfigImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"delete_twilio_config"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/delete_twilio_config(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteTwilioConfigInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_twilio_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/delete_vyne_config
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteVyneConfigImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"delete_vyne_config"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/delete_vyne_config(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteVyneConfigInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_vyne_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/delete_vyne_login
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteVyneLoginImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"delete_vyne_login"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/delete_vyne_login(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteVyneLoginInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_vyne_login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /central/:account_id/rcm/dashboard/denial_breakdown
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const denialBreakdownCentralRcmDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"denial_breakdown"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/dashboard/denial_breakdown
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const denialBreakdownLocationRcmDashboardIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"denial_breakdown"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/stats/denial_procedures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const denialProceduresRcmServicesStatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"denial_procedures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/stats/denial_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const denialStatsRcmServicesStatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"denial_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/reports/denials
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const denialsRcmServicesReportsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[6,"denials"]]]]]]);

/**
 * Generates rails route to
 * /central/:account_id/rcm/dashboard/denied_procedures
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deniedProceduresCentralRcmDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"denied_procedures"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/dashboard/denied_procedures
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deniedProceduresLocationRcmDashboardIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"denied_procedures"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/dentist_performance(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dentistPerformanceEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"dentist_performance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/dentist_performance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dentistPerformanceReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"dentist_performance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/holds/dentists
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dentistsCredentialingHoldsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"holds"],[2,[7,"/"],[6,"dentists"]]]]]]);

/**
 * Generates rails route to
 * /ai/action_requests/:id/deny(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const denyAiActionRequestPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"action_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deny"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/schedule/deposit_intent
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const depositIntentLocationPatientSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"schedule"],[2,[7,"/"],[6,"deposit_intent"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/confirmation_add_ons/destroy_add_on
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyAddOnEnterprisePoliciesConfirmationAddOnsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"confirmation_add_ons"],[2,[7,"/"],[6,"destroy_add_on"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/destroy_allergy(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyAllergySettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"destroy_allergy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/claim_completeness/:id/destroy_carrier_override(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyCarrierOverrideRcmServicesClaimCompletenessPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"claim_completeness"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_carrier_override"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/claim_completeness/:id/destroy_category(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyCategoryRcmServicesClaimCompletenessPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"claim_completeness"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_plan_settings/:id/destroy_category(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyCategoryRcmServicesInsurancePlanSettingPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_plan_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/treatment_catalogs/destroy_category(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyCategorySettingsTreatmentCatalogsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"treatment_catalogs"],[2,[7,"/"],[2,[6,"destroy_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_plan_settings/:id/destroy_code_group(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyCodeGroupRcmServicesInsurancePlanSettingPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_plan_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_code_group"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/odontogram/tooth_conditions(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyConditionsLocationApiV1PatientOdontogramToothConditionsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"tooth_conditions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/ai_outreach/configs/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyConfigSettingsAiOutreachIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ai_outreach"],[2,[7,"/"],[2,[6,"configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/online_scheduling/configs/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyConfigSettingsOnlineSchedulingIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"online_scheduling"],[2,[7,"/"],[2,[6,"configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/links/:id/curve_exports/:export_id
 * @param {any} id
 * @param {any} exportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyCurveExportInternalLinkPath = /*#__PURE__*/ __route({"id":{"r":true},"export_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"curve_exports"],[2,[7,"/"],[3,"export_id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/mounts_devices/devices/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyDeviceSettingsMountsDevicesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"mounts_devices"],[2,[7,"/"],[2,[6,"devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/calendar/destroy_event/:id
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyEventImplementationImplementationCalendarPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"destroy_event"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_plan_settings/:id/destroy_field_requirement(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyFieldRequirementRcmServicesInsurancePlanSettingPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_plan_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_field_requirement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/forms/:id/destroy_from_appointment
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyFromAppointmentLocationPatientFormPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"destroy_from_appointment"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/treatment_catalogs/destroy_item(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyItemSettingsTreatmentCatalogsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"treatment_catalogs"],[2,[7,"/"],[2,[6,"destroy_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/location_todos/:id
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyLocationTodoImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[2,[6,"location_todos"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/dosespot/destroy_manual
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyManualLocationDosespotPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"dosespot"],[2,[7,"/"],[6,"destroy_manual"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/links/:id/snapshots/:snapshot_id/materialization
 * @param {any} id
 * @param {any} snapshotId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyMaterializationInternalLinkPath = /*#__PURE__*/ __route({"id":{"r":true},"snapshot_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[2,[3,"snapshot_id"],[2,[7,"/"],[6,"materialization"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/perio_charts/:id/destroy_measurement
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyMeasurementLocationPatientPerioChartPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"perio_charts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"destroy_measurement"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:invoice_id/adjustments/destroy_merchant_fee
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} invoiceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyMerchantFeeLocationPatientInvoiceAdjustmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"invoice_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[6,"destroy_merchant_fee"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/claim_completeness/:id/destroy_override(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyOverrideRcmServicesClaimCompletenessPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"claim_completeness"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_override"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_photos/:id/destroy_photo
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyPhotoLocationPatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"destroy_photo"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/destroy_problem_group(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyProblemGroupSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"destroy_problem_group"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/destroy_problem(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyProblemSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"destroy_problem"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/message_templates/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroySettingsPhoneMessagingMessageTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"message_templates"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/destroy_snapshot
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroySnapshotImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"destroy_snapshot"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/mounts_devices/templates/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyTemplateSettingsMountsDevicesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"mounts_devices"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/treatments/:treatment_id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} treatmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyTreatmentLocationPatientOdontogramTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"treatment_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[3,"treatment_id"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/treatments
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyTreatmentsLocationPatientOdontogramTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[6,"treatments"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyUserSessionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/detach_document(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detachDocumentInternalGoLiveConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"detach_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_videos/:id/detach_document(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detachDocumentInternalTrainingVideoPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"detach_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/detach_insurance_payment
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detachInsurancePaymentLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"detach_insurance_payment"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/detach_insurance_payment
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detachInsurancePaymentRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"detach_insurance_payment"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentation_snapshots/:id/detach_recording
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detachRecordingLocationPatientTreatmentPresentationSnapshotPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentation_snapshots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"detach_recording"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/knowledge/:id/detach_video(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detachVideoInternalKnowledgePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"detach_video"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammates/:id/detail(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detailRcmServicesTeammatePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/details/approve
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detailsApproveLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[2,[7,"/"],[6,"approve"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/details
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detailsLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"details"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/details/status
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detailsStatusLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[2,[7,"/"],[6,"status"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/details/treatments/:treatment_id
 * @param {any} locationId
 * @param {any} id
 * @param {any} treatmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detailsTreatmentLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"treatment_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[3,"treatment_id"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/details/treatments
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detailsTreatmentsLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[2,[7,"/"],[6,"treatments"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/pre_authorizations_queue/determination_candidates(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const determinationCandidatesLocationRcmPreAuthorizationsQueueIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"pre_authorizations_queue"],[2,[7,"/"],[2,[6,"determination_candidates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/diagnosis_rate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const diagnosisRateDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"diagnosis_rate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/diagnosis_rate_drill_down(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const diagnosisRateDrillDownDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"diagnosis_rate_drill_down"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/diagnosis_rate_drill_down(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const diagnosisRateDrillDownEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"diagnosis_rate_drill_down"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/diagnosis_rate(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const diagnosisRateEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"diagnosis_rate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/diagnosis_rate_trend(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const diagnosisRateTrendDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"diagnosis_rate_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/diagnosis_rate_trend(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const diagnosisRateTrendEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"diagnosis_rate_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/dialstack_accounts
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dialstackAccountsInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"dialstack_accounts"]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/dialstack_locations
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dialstackLocationsInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"dialstack_locations"]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/agent_review/findings/:finding_id/dig_deeper
 * @param {any} implementationId
 * @param {any} findingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const digDeeperImplementationImplementationAgentReviewPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"finding_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"agent_review"],[2,[7,"/"],[2,[6,"findings"],[2,[7,"/"],[2,[3,"finding_id"],[2,[7,"/"],[6,"dig_deeper"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/stats/dirty_claims(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dirtyClaimsRcmServicesStatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"dirty_claims"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation/disable_login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disableLoginInternalRcmAutomationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[2,[7,"/"],[2,[6,"disable_login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/ai_calling_carriers/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disableRcmServicesSoftphoneAdminAiCallingCarrierPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"ai_calling_carriers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/location/disable_slack(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disableSlackSettingsLocationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"location"],[2,[7,"/"],[2,[6,"disable_slack"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/disband
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disbandLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"disband"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/disband
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disbandRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"disband"]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/change_sets/:id/discard
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discardCredentialingChangeSetPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"change_sets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"discard"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/:id/discard_draft(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discardDraftSettingsPatientFormTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discard_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/ambient_sessions/:id/discard(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discardLocationApiV1AmbientSessionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ambient_sessions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/clinical_note_addenda/:id/discard(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discardLocationApiV1ClinicalNoteAddendumPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clinical_note_addenda"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/discard_pending_split
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discardPendingSplitLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"discard_pending_split"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/discard_pending_split
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discardPendingSplitRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"discard_pending_split"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/email/discard(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discardSettingsLocationEmailPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/connected_apps/partners/:partner/disconnect
 * @param {any} accountId
 * @param {any} partner
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disconnectPartnerEnterpriseConnectedAppsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"partner":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"connected_apps"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"partner"],[2,[7,"/"],[6,"disconnect"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/dismiss_announcement(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissAnnouncementLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss_announcement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/dismiss_collections_review(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissCollectionsReviewLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss_collections_review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/documents/:document_id/dismiss_check
 * @param {any} locationId
 * @param {any} id
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissDocumentCheckLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"document_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[6,"dismiss_check"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/dismiss_duplicate
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissDuplicateLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"dismiss_duplicate"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/dismiss_duplicate
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissDuplicateRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"dismiss_duplicate"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_merges/dismiss(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissEnterprisePatientMergesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_merges"],[2,[7,"/"],[2,[6,"dismiss"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/dismiss_eob_only
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissEobOnlyLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"dismiss_eob_only"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/dismiss_eob_only
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissEobOnlyRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"dismiss_eob_only"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/dismiss_failed_charge(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissFailedChargeLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss_failed_charge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/agent_review/findings/:finding_id/dismiss
 * @param {any} implementationId
 * @param {any} findingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissImplementationImplementationAgentReviewPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"finding_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"agent_review"],[2,[7,"/"],[2,[6,"findings"],[2,[7,"/"],[2,[3,"finding_id"],[2,[7,"/"],[6,"dismiss"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/language_suggestion/dismiss
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissLanguageSuggestionLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"language_suggestion"],[2,[7,"/"],[6,"dismiss"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/live_call_suggestions/:id/dismiss
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissLocationLiveCallSuggestionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"live_call_suggestions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"dismiss"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/submissions/:id/dismiss(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissLocationReferralsSubmissionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/suggested_actions/:id/dismiss(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissLocationSuggestedActionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"suggested_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/dismiss_practice_task_update(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissPracticeTaskUpdateLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss_practice_task_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/dismiss_pre_auth_denial_notice(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissPreAuthDenialNoticeLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss_pre_auth_denial_notice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/dismiss_pre_auth_received_notice(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissPreAuthReceivedNoticeLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss_pre_auth_received_notice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/dismiss_profile_update(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissProfileUpdateLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss_profile_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/imports/:id/dismiss(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissSettingsPatientFormImportPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/dismiss_simplify_medical_lists(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissSimplifyMedicalListsSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"dismiss_simplify_medical_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/suggested_actions/:id/dismiss
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissSuggestedActionLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"suggested_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"dismiss"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/dismiss_unify_credential_issue(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismissUnifyCredentialIssueLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss_unify_credential_issue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/ai_carrier_calls/dispatch_batch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dispatchBatchRcmServicesSoftphoneAdminAiCarrierCallsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"ai_carrier_calls"],[2,[7,"/"],[2,[6,"dispatch_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/distribute_unallocated_funds
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const distributeUnallocatedFundsLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"distribute_unallocated_funds"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/document_file
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentFileLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"document_file"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/faxes/:id/document
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentLocationFaxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"faxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"document"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/files_v2/:id/document
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentLocationPatientFilesV2Path = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"files_v2"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"document"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/document
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"document"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/payments_denials/:id/document
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentLocationRcmPaymentsDenialPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"payments_denials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"document"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/faxes/:id/document(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentRcmServicesFaxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"faxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/plan_evidence/:id/documents/:attachment_id
 * @param {any} id
 * @param {any} attachmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentRcmServicesPlanEvidencePath = /*#__PURE__*/ __route({"id":{"r":true},"attachment_id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"plan_evidence"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[3,"attachment_id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/document
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"document"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/sent_faxes/:id/document(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentRcmServicesSentFaxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"sent_faxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/files_v2/document_templates
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentTemplatesLocationPatientFilesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"files_v2"],[2,[7,"/"],[6,"document_templates"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/providers/:id/dosespot_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dosespotStatusInternalProviderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dosespot_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eligibility_dashboard/claim_statuses/:id/download_pdf
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadClaimPdfInternalEligibilityDashboardPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eligibility_dashboard"],[2,[7,"/"],[2,[6,"claim_statuses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"download_pdf"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/pre_auth_dashboard/claim_statuses/:id/download_pdf
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadClaimPdfInternalPreAuthDashboardPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"pre_auth_dashboard"],[2,[7,"/"],[2,[6,"claim_statuses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"download_pdf"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eligibility_dashboard/claim_statuses/:id/download_screenshot
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadClaimScreenshotInternalEligibilityDashboardPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eligibility_dashboard"],[2,[7,"/"],[2,[6,"claim_statuses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"download_screenshot"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/pre_auth_dashboard/claim_statuses/:id/download_screenshot
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadClaimScreenshotInternalPreAuthDashboardPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"pre_auth_dashboard"],[2,[7,"/"],[2,[6,"claim_statuses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"download_screenshot"]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/applications/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadCredentialingApplicationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/documents/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadCredentialingDocumentPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/api_keys/download_desktop(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadDesktopSettingsLocationApiKeysPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[6,"download_desktop"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/artifacts/:id/download(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadEnterpriseAgentArtifactPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/files/:id/download(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadEnterpriseAgentFilePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_status/:id/download_eob_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadEobPdfInternalEobStatusPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_status"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_eob_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/exports/:export_id/download(.:format)
 * @param {any} id
 * @param {any} exportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadExportInternalAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"export_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/modento_form_exports/:id/download
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadImplementationImplementationModentoFormExportPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"modento_form_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"download"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/links/download_installer
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadInstallerInternalLinksPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[6,"download_installer"]]]]]]);

/**
 * Generates rails route to
 * /internal/content_sync_runs/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadInternalContentSyncRunPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"content_sync_runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/modento_form_exports/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadInternalModentoFormExportPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"modento_form_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/records_releases/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadInternalRecordsReleasePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"records_releases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_ar_dashboard/:id/download_letter(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadLetterEnterprisePatientArDashboardPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_ar_dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_letter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_photos/:id/download
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadLocationPatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"download"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_photos/:id/download_photo
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadPhotoLocationPatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"download_photo"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/forms/:id/download_proof
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadProofLocationPatientFormPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"download_proof"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/treatment_agreements/download_proof
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadProofLocationTreatmentAgreementsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"treatment_agreements"],[2,[7,"/"],[6,"download_proof"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_status/:id/download_screenshot(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadScreenshotInternalEobStatusPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_status"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_screenshot"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/faxes/draft_cover_message
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draftCoverMessageLocationFaxesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"faxes"],[2,[7,"/"],[6,"draft_cover_message"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/sent_faxes/draft_cover_message(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draftCoverMessageRcmServicesSentFaxesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"sent_faxes"],[2,[7,"/"],[2,[6,"draft_cover_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/letter_template/draft(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draftEnterpriseReferralsLetterTemplatePath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letter_template"],[2,[7,"/"],[2,[6,"draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/letter_template/draft(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draftLocationReferralsLetterTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letter_template"],[2,[7,"/"],[2,[6,"draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/draft_mango_translations
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draftMangoTranslationsImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"draft_mango_translations"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/draft_preview(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draftPreviewSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"draft_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scorecards/:id/draft
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draftTwelveTeamScorecardPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"draft"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/denticon_checkpoints/:id/drop
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dropImplementationImplementationDenticonCheckpointPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"denticon_checkpoints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"drop"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/drop_insurance_coverage
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dropInsuranceCoverageLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"drop_insurance_coverage"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_plans/:id/duplicate(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateLocationApiV1PatientTreatmentPlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/perio_charts/:id/duplicate
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateLocationPatientPerioChartPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"perio_charts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"duplicate"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/periodontal_charts/:id/duplicate
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateLocationPatientPeriodontalChartPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"periodontal_charts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"duplicate"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_templates/:id/duplicate(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateSettingsClinicalNoteTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/:id/duplicate(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateSettingsPatientFormTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:account_id/members/:id/edit(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAccountAccountUserPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/:id/edit_billing
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBillingLocationPatientTreatmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit_billing"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/edit_conversation_message(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editConversationMessageRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_conversation_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/practices/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCredentialingPracticePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"practices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/profiles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCredentialingProfilePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:id/edit_date
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editDateLocationPatientInvoicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit_date"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/knowledge/:id/edit(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEnterpriseKnowledgePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/marketing_tags/:id/edit(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEnterpriseMarketingMarketingTagPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"marketing_tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/membership_plans/:id/edit(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEnterpriseMembershipPlanPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"membership_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/appointment_management/custom_fields/:id/edit
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEnterprisePoliciesAppointmentManagementCustomFieldPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"appointment_management"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_prompts/:id/edit
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEnterprisePoliciesClinicalNotePromptPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"clinical_note_prompts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_templates/:id/edit
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEnterprisePoliciesClinicalNoteTemplatePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/in_appointment/guidances/:id/edit
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEnterprisePoliciesInAppointmentGuidancePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"in_appointment"],[2,[7,"/"],[2,[6,"guidances"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/patient_management/custom_fields/:id/edit
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEnterprisePoliciesPatientManagementCustomFieldPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"patient_management"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/payment_options/:id/edit
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEnterprisePoliciesPaymentOptionPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"payment_options"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /insurance_plans/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInsurancePlanPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/knowledge/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInternalKnowledgePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/phone_numbers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInternalPhoneNumberPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"phone_numbers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/whats_new/:id/edit
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInternalWhatsNewPostPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"whats_new"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/account/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editKnowledgeAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/twelve/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editKnowledgeTwelvePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"twelve"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/edit
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:appointment_id/comments/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} appointmentId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationAppointmentCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"appointment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"appointment_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/event_logs/:event_log_id/comments/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} eventLogId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationEventLogCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"event_log_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"event_logs"],[2,[7,"/"],[2,[3,"event_log_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_claims/:insurance_claim_id/comments/:id/edit
 * @param {any} locationId
 * @param {any} insuranceClaimId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationInsuranceClaimCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"insurance_claim_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"insurance_claim_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/edit
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:insurance_plan_id/comments/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} insurancePlanId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationInsurancePlanCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"insurance_plan_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"insurance_plan_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/lab_cases/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationLabCasePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"lab_cases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/lab_cases/:lab_case_id/comments/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} labCaseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationLabCaseCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"lab_case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"lab_cases"],[2,[7,"/"],[2,[3,"lab_case_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_photos/:id/edit
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationPatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_dental_anxiety/edit
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationPatientPatientDentalAnxietyPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_dental_anxiety"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_medications/:id/edit
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationPatientPatientMedicationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_medications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_medication_risks/:id/edit
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationPatientPatientMedicationRiskPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_medication_risks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_notes/:id/edit
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationPatientPatientNotePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/:id/edit
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationPatientPatientPaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_premedications/:id/edit
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationPatientPatientPremedicationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_premedications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_surgeries/:id/edit
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationPatientPatientSurgeryPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_surgeries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_tobacco_uses/:id/edit
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationPatientPatientTobaccoUsePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_tobacco_uses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_vitals/:id/edit
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationPatientPatientVitalPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_vitals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_plans/:id/edit
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationPatientPaymentPlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/perio_charts/:id/edit
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationPatientPerioChartPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"perio_charts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/plan_subscription/edit
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationPatientPlanSubscriptionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"plan_subscription"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/:id/edit
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationPatientTreatmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks/:task_id/comments/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} taskId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationTaskCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"task_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/time_blocks/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationTimeBlockPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"time_blocks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/dosespot/edit_manual
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editManualLocationDosespotPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"dosespot"],[2,[7,"/"],[6,"edit_manual"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_alerts/notes/:kind/:alert_id/edit
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} kind
 * @param {any} alertId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editNoteLocationPatientClinicalAlertsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"kind":{"r":true},"alert_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_alerts"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"kind"],[2,[7,"/"],[2,[3,"alert_id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/edit_profile_picture_modal
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProfilePictureModalLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit_profile_picture_modal"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/edit
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/appointment_templates/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsAppointmentTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"appointment_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_prompts/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsClinicalNotePromptPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_prompts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_templates/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsClinicalNoteTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/location/edit(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsLocationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"location"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/note_abbreviations/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsNoteAbbreviationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"note_abbreviations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsPatientFormTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/providers/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsProviderPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scenarios/:id/edit
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTwelveTeamScenarioPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editUserPasswordPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editUserRegistrationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/edit_wallet_merchant_fee
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editWalletMerchantFeeLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"edit_wallet_merchant_fee"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/perio_charts/:id/editor
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editorLocationPatientPerioChartPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"perio_charts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"editor"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/email_attachment_signed_url
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emailAttachmentSignedUrlLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[6,"email_attachment_signed_url"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/emails/:id/content
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emailContentLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"content"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email-preferences/:token
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emailPreferencesPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"email-preferences"],[2,[7,"/"],[3,"token"]]]]);

/**
 * Generates rails route to
 * /settings/email/verification_callback
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emailVerificationCallbackPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[6,"verification_callback"]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/embed_allowed_origins/:origin_id(.:format)
 * @param {any} id
 * @param {any} originId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embedAllowedOriginInternalAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"origin_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"embed_allowed_origins"],[2,[7,"/"],[2,[3,"origin_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/embed_allowed_origins/:origin_id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {any} originId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embedAllowedOriginInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"origin_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"embed_allowed_origins"],[2,[7,"/"],[2,[3,"origin_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/embed_allowed_origins(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embedAllowedOriginsInternalAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"embed_allowed_origins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/embed_allowed_origins(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embedAllowedOriginsInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"embed_allowed_origins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/:id/enable(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enableEnterpriseAgentPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation/enable_login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enableLoginInternalRcmAutomationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[2,[7,"/"],[2,[6,"enable_login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/ai_calling_carriers/:id/enable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enableRcmServicesSoftphoneAdminAiCallingCarrierPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"ai_calling_carriers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/location/enable_slack(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enableSlackSettingsLocationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"location"],[2,[7,"/"],[2,[6,"enable_slack"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/end_of_day_data(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const endOfDayDataEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"end_of_day_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/end_of_day_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const endOfDayDataReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"end_of_day_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/end_of_day(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const endOfDayEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"end_of_day"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/end_of_day(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const endOfDayReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"end_of_day"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/end_wait(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const endWaitLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"end_wait"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseAgentPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/attachments(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseAgentAttachmentsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/connections/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseAgentConnectionPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/connections/authorize(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseAgentConnectionAuthorizePath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/agents/connections/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseAgentConnectionCallbackPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/connections/:connection_id/reconnect(.:format)
 * @param {any} accountId
 * @param {any} connectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseAgentConnectionReconnectPath = /*#__PURE__*/ __route({"account_id":{"r":true},"connection_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[3,"connection_id"],[2,[7,"/"],[2,[6,"reconnect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/connections(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseAgentConnectionsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"connections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/runs/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseAgentRunPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/runs(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseAgentRunsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"runs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseAgentsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/ai_chat
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseAiChatPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"ai_chat"]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/ai_receptionist/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseAiReceptionistPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"ai_receptionist"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/ai_receptionist(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseAiReceptionistIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"ai_receptionist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/audit_log_events(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseAuditLogEventsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"audit_log_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/audit_log_events/patients(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseAuditLogEventsPatientsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"audit_log_events"],[2,[7,"/"],[2,[6,"patients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/bank_accounts/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseBankAccountPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"bank_accounts"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/bank_accounts
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseBankAccountsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"bank_accounts"]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/calls(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseCallsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"calls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/connected_apps/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseConnectedAppPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"connected_apps"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/connected_apps/partners/:partner
 * @param {any} accountId
 * @param {any} partner
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseConnectedAppPartnerKeysPath = /*#__PURE__*/ __route({"account_id":{"r":true},"partner":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"connected_apps"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[3,"partner"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/connected_apps/:id/regenerate
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseConnectedAppRegeneratedPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"connected_apps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"regenerate"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/connected_apps
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseConnectedAppsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"connected_apps"]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/credentialing(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseCredentialingPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"credentialing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/credentialing/documents/:id/download(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseCredentialingDocumentDownloadPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/credentialing/documents/:id/view(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseCredentialingDocumentViewPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/custom_codes/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseCustomCodePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"custom_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/custom_codes(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseCustomCodesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"custom_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseDashboardPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/data/agent_chat_attachments(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseDataAgentChatAttachmentsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"agent_chat_attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/data/agent_connections(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseDataAgentConnectionsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"agent_connections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/data/agent_files(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseDataAgentFilesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"agent_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/data/agent_run_activity(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseDataAgentRunActivityPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"agent_run_activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/data/agent_run_messages(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseDataAgentRunMessagesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"agent_run_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/data/agent_runs(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseDataAgentRunsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"agent_runs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/data/agent_tags(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseDataAgentTagsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"agent_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/data/agent_versions(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseDataAgentVersionsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"agent_versions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/data/agents(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseDataAgentsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"agents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/data_cleanup(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseDataCleanupPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"data_cleanup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/data_cleanup/close_lab_cases(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseDataCleanupCloseLabCasesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"data_cleanup"],[2,[7,"/"],[2,[6,"close_lab_cases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/feature_adoption(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeatureAdoptionPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"feature_adoption"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/coverage
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisCoveragePath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[6,"coverage"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/coverage/data
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisCoverageDataPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[2,[6,"coverage"],[2,[7,"/"],[6,"data"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/gap_monitor
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisGapMonitorPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[6,"gap_monitor"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/harmonization
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisHarmonizationPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[6,"harmonization"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/opportunities/:key
 * @param {any} accountId
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisOpportunityPath = /*#__PURE__*/ __route({"account_id":{"r":true},"key":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[3,"key"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/opportunities/:key/data
 * @param {any} accountId
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisOpportunityDataPath = /*#__PURE__*/ __route({"account_id":{"r":true},"key":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"key"],[2,[7,"/"],[6,"data"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/opportunities/:key/dismiss
 * @param {any} accountId
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisOpportunityDismissPath = /*#__PURE__*/ __route({"account_id":{"r":true},"key":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"key"],[2,[7,"/"],[6,"dismiss"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/opportunities/:key/restore
 * @param {any} accountId
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisOpportunityRestorePath = /*#__PURE__*/ __route({"account_id":{"r":true},"key":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"key"],[2,[7,"/"],[6,"restore"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisOverviewPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"fee_analysis"]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/overview/data
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisOverviewDataPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[6,"data"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/participation
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisParticipationPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[6,"participation"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/payers/:carrier_id
 * @param {any} accountId
 * @param {any} carrierId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisPayerPath = /*#__PURE__*/ __route({"account_id":{"r":true},"carrier_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[2,[6,"payers"],[2,[7,"/"],[3,"carrier_id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/payers/:carrier_id/codes_export_csv
 * @param {any} accountId
 * @param {any} carrierId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisPayerCodesExportCsvPath = /*#__PURE__*/ __route({"account_id":{"r":true},"carrier_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[2,[6,"payers"],[2,[7,"/"],[2,[3,"carrier_id"],[2,[7,"/"],[6,"codes_export_csv"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/payers/:carrier_id/data
 * @param {any} accountId
 * @param {any} carrierId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisPayerDataPath = /*#__PURE__*/ __route({"account_id":{"r":true},"carrier_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[2,[6,"payers"],[2,[7,"/"],[2,[3,"carrier_id"],[2,[7,"/"],[6,"data"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/payers
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisPayersPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[6,"payers"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/rate_card
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisRateCardPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[6,"rate_card"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/rate_card/data
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisRateCardDataPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[2,[6,"rate_card"],[2,[7,"/"],[6,"data"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/rate_card/export_csv
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisRateCardExportCsvPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[2,[6,"rate_card"],[2,[7,"/"],[6,"export_csv"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/schedules/:schedule_id
 * @param {any} accountId
 * @param {any} scheduleId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisSchedulePath = /*#__PURE__*/ __route({"account_id":{"r":true},"schedule_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[3,"schedule_id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/schedules/:schedule_id/codes_export_csv
 * @param {any} accountId
 * @param {any} scheduleId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisScheduleCodesExportCsvPath = /*#__PURE__*/ __route({"account_id":{"r":true},"schedule_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"schedule_id"],[2,[7,"/"],[6,"codes_export_csv"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/schedules/:schedule_id/data
 * @param {any} accountId
 * @param {any} scheduleId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisScheduleDataPath = /*#__PURE__*/ __route({"account_id":{"r":true},"schedule_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"schedule_id"],[2,[7,"/"],[6,"data"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/schedules
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisSchedulesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[6,"schedules"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/schedules/data
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisSchedulesDataPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[6,"data"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/schedules/export_csv
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisSchedulesExportCsvPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[6,"export_csv"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/fee_analysis/track
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeeAnalysisTrackPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"fee_analysis"],[2,[7,"/"],[6,"track"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/feedback(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseFeedbackPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/historical_lock/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseHistoricalLockPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"historical_lock"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/historical_lock(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseHistoricalLockIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"historical_lock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/knowledge/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseKnowledgePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/knowledge(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseKnowledgeIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"knowledge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/library/drawings(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseLibraryDrawingsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"drawings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/library/imports/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseLibraryImportPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/library/imports(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseLibraryImportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/library/presentations/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseLibraryPagePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/library/presentations(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseLibraryPagesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"presentations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/limited_users(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseLimitedUsersPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"limited_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/manual_sync/completed_appointments
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseManualSyncCompletedAppointmentsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"manual_sync"],[2,[7,"/"],[6,"completed_appointments"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/manual_sync/ledger
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseManualSyncLedgerPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"manual_sync"],[2,[7,"/"],[6,"ledger"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/manual_sync/received_claims
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseManualSyncReceivedClaimsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"manual_sync"],[2,[7,"/"],[6,"received_claims"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseMarketingPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/attribution(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseMarketingAttributionPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"attribution"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/mail_campaigns/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseMarketingMailCampaignPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"mail_campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/marketing_tags/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseMarketingMarketingTagPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"marketing_tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/marketing_tags(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseMarketingMarketingTagsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"marketing_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/settings(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseMarketingSettingsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/setup(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseMarketingSetupPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/tracking_numbers/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseMarketingTrackingNumberPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"tracking_numbers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/tracking_numbers(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseMarketingTrackingNumbersPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"tracking_numbers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/tracking_tests(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseMarketingTrackingTestsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"tracking_tests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/uploads/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseMarketingUploadPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/uploads(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseMarketingUploadsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/web_traffic(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseMarketingWebTrafficPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"web_traffic"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/membership_plans/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseMembershipPlanPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"membership_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/membership_plans(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseMembershipPlansPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"membership_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/overview(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseOverviewIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_ar_dashboard(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePatientArDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_ar_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_merges(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePatientMergesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_merges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"policies"]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/appointment_categories
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesAppointmentCategoriesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"appointment_categories"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/appointment_management
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesAppointmentManagementPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"appointment_management"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/appointment_management/custom_fields/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesAppointmentManagementCustomFieldPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"appointment_management"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/appointment_management/custom_fields
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesAppointmentManagementCustomFieldsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"appointment_management"],[2,[7,"/"],[6,"custom_fields"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/broken_appointments
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesBrokenAppointmentsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"broken_appointments"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/charting_conventions
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesChartingConventionsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"charting_conventions"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/check_in
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesCheckInPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"check_in"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/check_out
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesCheckOutPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"check_out"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/claim_submission
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesClaimSubmissionPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"claim_submission"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_prompts/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesClinicalNotePromptPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"clinical_note_prompts"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_prompts
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesClinicalNotePromptsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"clinical_note_prompts"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_templates/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesClinicalNoteTemplatePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_template_categories
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesClinicalNoteTemplateCategoriesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"clinical_note_template_categories"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_templates
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesClinicalNoteTemplatesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"clinical_note_templates"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/confirmation_add_ons
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesConfirmationAddOnsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"confirmation_add_ons"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/in_appointment
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesInAppointmentPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"in_appointment"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/in_appointment/guidances/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesInAppointmentGuidancePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"in_appointment"],[2,[7,"/"],[2,[6,"guidances"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/in_appointment/guidances
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesInAppointmentGuidancesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"in_appointment"],[2,[7,"/"],[6,"guidances"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/insurance_posting
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesInsurancePostingPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"insurance_posting"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/appointment_management/custom_fields/new
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesNewAppointmentManagementCustomFieldPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"appointment_management"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/in_appointment/guidances/new
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesNewInAppointmentGuidancePath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"in_appointment"],[2,[7,"/"],[2,[6,"guidances"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/patient_management/custom_fields/new
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesNewPatientManagementCustomFieldPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"patient_management"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/payment_options/new
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesNewPaymentOptionPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"payment_options"],[2,[7,"/"],[6,"new"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/patient_ar
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesPatientArPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"patient_ar"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/patient_ar/sequence
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesPatientArSequencePath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"patient_ar"],[2,[7,"/"],[6,"sequence"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/patient_intake
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesPatientIntakePath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"patient_intake"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/patient_languages
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesPatientLanguagesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"patient_languages"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/patient_management
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesPatientManagementPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"patient_management"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/patient_management/custom_fields/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesPatientManagementCustomFieldPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"patient_management"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/patient_management/custom_fields
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesPatientManagementCustomFieldsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"patient_management"],[2,[7,"/"],[6,"custom_fields"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/payment_options/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesPaymentOptionPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"payment_options"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/payment_options
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesPaymentOptionsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"payment_options"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/recall
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesRecallPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"recall"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/scheduling
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesSchedulingPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"scheduling"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/treatment_agreements
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesTreatmentAgreementsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"treatment_agreements"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/treatment_planning
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePoliciesTreatmentPlanningPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[6,"treatment_planning"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/prescription_favorites/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePrescriptionFavoritePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"prescription_favorites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/prescription_favorites(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePrescriptionFavoritesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"prescription_favorites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/library/how-we-present(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprisePresentationStylePath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"how-we-present"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/procedure_code_overrides/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseProcedureCodeOverridePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"procedure_code_overrides"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/procedure_code_overrides(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseProcedureCodeOverridesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"procedure_code_overrides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/categories(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseReferralsCategoriesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/categories/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseReferralsCategoryPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/letter_template(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseReferralsLetterTemplatePath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letter_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/letter_templates(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseReferralsLetterTemplatesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letter_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/practices/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseReferralsPracticePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"practices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/practices(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseReferralsPracticesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"practices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/providers/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseReferralsProviderPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/providers(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseReferralsProvidersPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"providers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseReportsRootPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/roles/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseRolePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/roles(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseRolesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseRootPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/security
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseSecurityPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"security"]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/starred_calls/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseStarredCallPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"starred_calls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/starred_calls(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseStarredCallsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"starred_calls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/teams/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseTeamPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/teams(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseTeamsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/translation_drafts(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseTranslationDraftsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"translation_drafts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/twelve_voice
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseTwelveVoicePath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"twelve_voice"]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/twelve_voice/launch
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseTwelveVoiceLaunchPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"twelve_voice"],[2,[7,"/"],[6,"launch"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/users/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseUserPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/users(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseUsersPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/eob_file
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eobFileLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"eob_file"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/eob_file
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eobFileRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"eob_file"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/medical_claims/:id/eob
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eobLocationPatientMedicalClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"medical_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"eob"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/stats/estimate_accuracy_lines(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimateAccuracyLinesRcmServicesStatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"estimate_accuracy_lines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/reports/estimate_accuracy_over_time
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimateAccuracyOverTimeRcmServicesReportsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[6,"estimate_accuracy_over_time"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/stats/estimate_accuracy_over_time(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimateAccuracyOverTimeRcmServicesStatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"estimate_accuracy_over_time"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/stats/estimate_accuracy_percentage_sources_over_time(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimateAccuracyPercentageSourcesOverTimeRcmServicesStatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"estimate_accuracy_percentage_sources_over_time"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/stats/estimate_accuracy_percentage_sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimateAccuracyPercentageSourcesRcmServicesStatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"estimate_accuracy_percentage_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/reports/estimate_accuracy
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimateAccuracyRcmServicesReportsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[6,"estimate_accuracy"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/stats/estimate_accuracy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimateAccuracyRcmServicesStatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"estimate_accuracy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/evidence_document
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evidenceDocumentLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"evidence_document"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/evidence_document
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evidenceDocumentRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"evidence_document"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/execute_ai_report(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const executeAiReportEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"execute_ai_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/execute_ai_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const executeAiReportReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"execute_ai_report"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/execute_custom_query(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const executeCustomQueryEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"execute_custom_query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/execute_custom_query(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const executeCustomQueryReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"execute_custom_query"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/execute_post_processing_step
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const executePostProcessingStepImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"execute_post_processing_step"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_links/:id/expire
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const expireLocationPatientPaymentLinkPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"expire"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/api_keys/:id/expire(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const expireSettingsLocationApiKeyPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"expire"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/export_ai_report_csv(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportAiReportCsvEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"export_ai_report_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/export_ai_report_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportAiReportCsvReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"export_ai_report_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/manual_sync/completed_appointments/export_csv
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvEnterpriseManualSyncCompletedAppointmentsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"manual_sync"],[2,[7,"/"],[2,[6,"completed_appointments"],[2,[7,"/"],[6,"export_csv"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/manual_sync/received_claims/export_csv
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvEnterpriseManualSyncReceivedClaimsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"manual_sync"],[2,[7,"/"],[2,[6,"received_claims"],[2,[7,"/"],[6,"export_csv"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/bank_deposits/export_csv
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvLocationBankDepositsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"bank_deposits"],[2,[7,"/"],[6,"export_csv"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/fee_schedules/:id/export_csv
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvLocationFeeSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"fee_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"export_csv"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_claims/export_csv
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvLocationInsuranceClaimsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[6,"export_csv"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/export_csv
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvLocationInsurancePaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[6,"export_csv"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/manual_sync/completed_appointments/export_csv
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvLocationManualSyncCompletedAppointmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"manual_sync"],[2,[7,"/"],[2,[6,"completed_appointments"],[2,[7,"/"],[6,"export_csv"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/manual_sync/received_claims/export_csv
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvLocationManualSyncReceivedClaimsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"manual_sync"],[2,[7,"/"],[2,[6,"received_claims"],[2,[7,"/"],[6,"export_csv"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/claims/export_csv
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvRcmServicesClaimsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"claims"],[2,[7,"/"],[6,"export_csv"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bank_transactions/export_csv
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvRcmServicesPostingBankTransactionsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bank_transactions"],[2,[7,"/"],[6,"export_csv"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/export_csv
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvRcmServicesPostingPaymentsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[6,"export_csv"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/export_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportDataInternalAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/letters/:id/export(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportLocationReferralsLetterPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v1/plan_subscriptions/assign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1AssignPlanSubscriptionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"plan_subscriptions"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v1/notes/create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1CreateNotePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v1/plan_subscriptions/get/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1GetPlanSubscriptionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"plan_subscriptions"],[2,[7,"/"],[2,[6,"get"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v1/treatment_plans/get/:patient_id(.:format)
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1GetTreatmentPlansPath = /*#__PURE__*/ __route({"patient_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"treatment_plans"],[2,[7,"/"],[2,[6,"get"],[2,[7,"/"],[2,[3,"patient_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v1/appointments/list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1ListAppointmentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v1/plan_subscriptions/list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1ListPlanSubscriptionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"plan_subscriptions"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v1/membership_plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1MembershipPlansPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"membership_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v1/patients/get/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1PatientPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[6,"get"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v1/plan_subscriptions/reactivate/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1ReactivatePlanSubscriptionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"plan_subscriptions"],[2,[7,"/"],[2,[6,"reactivate"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v1/plan_subscriptions/remove/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1RemovePlanSubscriptionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"plan_subscriptions"],[2,[7,"/"],[2,[6,"remove"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v1/patients/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1SearchPatientsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v1/plan_subscriptions/suspend/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1SuspendPlanSubscriptionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"plan_subscriptions"],[2,[7,"/"],[2,[6,"suspend"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v1/plan_subscriptions/update/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1UpdatePlanSubscriptionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"plan_subscriptions"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/patients/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2Path = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/feedback
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2FeedbackPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[6,"feedback"]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/lead_sources
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LeadSourcesPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[6,"lead_sources"]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/appointments/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/adjustment_types
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationAdjustmentTypesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"adjustment_types"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/adjustments
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationAdjustmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"adjustments"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/appointments/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/appointment_types
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationAppointmentTypesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"appointment_types"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/appointments
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationAppointmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"appointments"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/appointments/:id/cancel
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationCancelAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"cancel"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/claim_procedures
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationClaimProceduresPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"claim_procedures"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/appointments/:id/confirm
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationConfirmAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"confirm"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/insurance_payments
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationInsurancePaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"insurance_payments"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/operatories
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationOperatoriesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"operatories"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/payments
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"payments"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/plan_subscriptions/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationPlanSubscriptionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"plan_subscriptions"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/plan_subscriptions
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationPlanSubscriptionsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"plan_subscriptions"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/procedure_codes
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationProcedureCodesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"procedure_codes"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/procedures
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationProceduresPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"procedures"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/providers
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationProvidersPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"providers"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/plan_subscriptions/:id/reactivate
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationReactivatePlanSubscriptionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"plan_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"reactivate"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/recall_types
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationRecallTypesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"recall_types"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/recalls
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationRecallsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"recalls"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/schedule
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"schedule"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/plan_subscriptions/:id/suspend
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationSuspendPlanSubscriptionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"plan_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"suspend"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations/:location_id/treatment_plans
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationTreatmentPlansPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"treatment_plans"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/locations
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LocationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[6,"locations"]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/membership_plans
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2MembershipPlansPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[6,"membership_plans"]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/patients/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2PatientPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/patients/:patient_id/notes
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2PatientNotesPath = /*#__PURE__*/ __route({"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"notes"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_api/v2/patients
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2PatientsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"external_api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[6,"patients"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/extract
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const extractLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"extract"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/collections/:id/factors(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const factorsRcmServicesCollectionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"collections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"factors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fv/:token
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const familyVisitHubPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"fv"],[2,[7,"/"],[3,"token"]]]]);

/**
 * Generates rails route to
 * /fee_schedules/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feeSchedulePath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"fee_schedules"],[2,[7,"/"],[3,"id"]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/activity/feed
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feedLocationActivityIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[6,"feed"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/clinical_opportunities/:id/feedback(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feedbackLocationApiV1PatientClinicalOpportunityPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_opportunities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/files/:file_id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {any} fileId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filePictureLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"file_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[3,"file_id"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/filter_waitlist(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filterWaitlistLocationAppointmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"filter_waitlist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/calls/:id/finalize(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finalizeCredentialingCallPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"finalize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/calls/:id/finalize(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finalizeRcmServicesCallPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"finalize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/otto/finalize
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finalizeRcmServicesOttoRunsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"otto"],[2,[7,"/"],[6,"finalize"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/clinical_photos/:id/flip_photo(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flipPhotoLocationApiV1PatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"flip_photo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/flyout_lab_cases
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flyoutLabCasesLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"flyout_lab_cases"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_notes/flyout
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flyoutLocationPatientPatientNotesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_notes"],[2,[7,"/"],[6,"flyout"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_methods/flyout
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flyoutLocationPatientPaymentMethodsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[6,"flyout"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /carrier_calling/verifier/assignment/for_item(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forItemCarrierCallingVerifierAssignmentPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[2,[7,"/"],[2,[6,"verifier"],[2,[7,"/"],[2,[6,"assignment"],[2,[7,"/"],[2,[6,"for_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/enrollments/for_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forLocationCredentialingEnrollmentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"enrollments"],[2,[7,"/"],[2,[6,"for_location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/forms/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const formLocationPatientFormPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/freshness(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const freshnessRcmServicesInboxIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[6,"freshness"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/odontogram/tooth_conditions/from_code(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fromCodeLocationApiV1PatientOdontogramToothConditionsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"tooth_conditions"],[2,[7,"/"],[2,[6,"from_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/full_screen
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fullScreenLocationPatientOdontogramPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[6,"full_screen"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/generate_demo_items(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generateDemoItemsLocationInboxIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[6,"generate_demo_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/knowledge/generate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generateInternalKnowledgeIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/applications/:id/generate_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generatePdfCredentialingApplicationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/ai_carrier_calls/:id/generate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generateRcmServicesSoftphoneAdminAiCarrierCallPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"ai_carrier_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /calendars/:kind/:token
 * @param {any} kind
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goLiveCalendarPath = /*#__PURE__*/ __route({"kind":{"r":true},"token":{"r":true}}, [2,[7,"/"],[2,[6,"calendars"],[2,[7,"/"],[2,[3,"kind"],[2,[7,"/"],[3,"token"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammates/:id/goal_history(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goalHistoryRcmServicesTeammatePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"goal_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /goto/oauth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gotoOauthPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"goto"],[2,[7,"/"],[2,[6,"oauth"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation/health_ask(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthAskInternalRcmAutomationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[2,[7,"/"],[2,[6,"health_ask"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation/health_results(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthResultsInternalRcmAutomationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[2,[7,"/"],[2,[6,"health_results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation/runs/:lane/:id/failure
 * @param {any} lane
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthRunFailureInternalRcmAutomationPath = /*#__PURE__*/ __route({"lane":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"lane"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"failure"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation/runs/:lane/:id
 * @param {any} lane
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthRunInternalRcmAutomationPath = /*#__PURE__*/ __route({"lane":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"lane"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation/runs/:lane/:id/screenshot
 * @param {any} lane
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthRunScreenshotInternalRcmAutomationPath = /*#__PURE__*/ __route({"lane":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"lane"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"screenshot"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_templates/:id/hide(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hideSettingsClinicalNoteTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"hide"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_ar_dashboard/history(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const historyEnterprisePatientArDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_ar_dashboard"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/bank_deposits/:id/history
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const historyLocationBankDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"bank_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"history"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/history
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const historyLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"history"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/history
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const historyLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"history"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bank_transactions/:id/history
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const historyRcmServicesPostingBankTransactionPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bank_transactions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"history"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/history
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const historyRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"history"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/history
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const historyRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"history"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/schedule/hold
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const holdLocationPatientSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"schedule"],[2,[7,"/"],[6,"hold"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/links/:id/curve_exports/:export_id/hydrate
 * @param {any} id
 * @param {any} exportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hydrateCurveExportInternalLinkPath = /*#__PURE__*/ __route({"id":{"r":true},"export_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"curve_exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[6,"hydrate"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/hygienist_performance_drill(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hygienistPerformanceDrillEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"hygienist_performance_drill"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/hygienist_performance_drill(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hygienistPerformanceDrillReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"hygienist_performance_drill"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/hygienist_performance(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hygienistPerformanceEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"hygienist_performance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/hygienist_performance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hygienistPerformanceReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"hygienist_performance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/accounts/:id/ignore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ignoreInternalBillingAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ignore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/library/presentations/:id/image(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const imageEnterpriseLibraryPagePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentation_snapshots/:id/images/:photo_id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {any} photoId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const imageLocationPatientTreatmentPresentationSnapshotPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"photo_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentation_snapshots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[3,"photo_id"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/agent_review
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationAgentReviewPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"agent_review"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/ai_chat
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationAiChatPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"ai_chat"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/calendar
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationCalendarPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"calendar"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/chats
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationChatsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"chats"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/conversion
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationConversionPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"conversion"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/curve_exports/:id
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationCurveExportPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"curve_exports"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/curve_exports
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationCurveExportsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"curve_exports"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"data"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data_sync
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationDataSyncPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"data_sync"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/denticon_checkpoints/:id
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationDenticonCheckpointPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"denticon_checkpoints"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/denticon_checkpoints
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationDenticonCheckpointsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"denticon_checkpoints"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/links
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationLinksPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"links"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/migration_runs/:id
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationMigrationRunPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"migration_runs"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/migration_runs
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationMigrationRunsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"migration_runs"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/modento_form_exports
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationModentoFormExportsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"modento_form_exports"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/modento_form_import_runs/:id
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationModentoFormImportRunPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"modento_form_import_runs"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/modento_form_import_runs
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationModentoFormImportRunsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"modento_form_import_runs"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/overview
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationOverviewPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"overview"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/regressions/:id
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationRegressionPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"regressions"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/regressions
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationRegressionsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"regressions"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationSetupPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"setup"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_sheet_import_runs/:id
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationSetupSheetImportRunPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_sheet_import_runs"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_sheet_import_runs
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationSetupSheetImportRunsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"setup_sheet_import_runs"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"setup_v1"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"snapshots"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/team/:id
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationTeamPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/team
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationTeamIndexPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"team"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/watch_conversions
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implementationImplementationWatchConversionsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[6,"watch_conversions"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/modento_form_exports/:id/import_forms
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importFormsImplementationImplementationModentoFormExportPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"modento_form_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"import_forms"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/modento_form_exports/:id/import_forms(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importFormsInternalModentoFormExportPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"modento_form_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import_forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importInternalGoLivesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/knowledge/import_loom(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importLoomInternalKnowledgeIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"import_loom"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/fee_schedules/:id/import_status
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importStatusLocationFeeSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"fee_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"import_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/import_status(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importStatusSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"import_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /inbox/badge_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inboxBadgeIdsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[6,"badge_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /inbox/items/details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inboxItemDetailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /inbox/items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inboxItemsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_verifications/inbox_items
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inboxItemsRcmServicesInsuranceVerificationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_verifications"],[2,[7,"/"],[6,"inbox_items"]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/initiate_clinician_tfa
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const initiateClinicianTfaInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"initiate_clinician_tfa"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/initiate_scan
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const initiateScanLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"initiate_scan"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/daily/insight_feedback(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insightFeedbackLocationDailyIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"daily"],[2,[7,"/"],[2,[6,"insight_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/insight_feedback
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insightFeedbackLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"insight_feedback"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/insight_feedback_modal
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insightFeedbackModalLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"insight_feedback_modal"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/insurance/add
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insuranceAddLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"insurance"],[2,[7,"/"],[6,"add"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/insurance/add/sync
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insuranceAddSyncLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"insurance"],[2,[7,"/"],[2,[6,"add"],[2,[7,"/"],[6,"sync"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/insurance_balance_check_status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insuranceBalanceCheckStatusImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"insurance_balance_check_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/schedule/insurance_card
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insuranceCardLocationPatientSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"schedule"],[2,[7,"/"],[6,"insurance_card"]]]]]]]]);

/**
 * Generates rails route to
 * /insurance_carriers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insuranceCarrierPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/:id/insurance_estimation_trace
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insuranceEstimationTraceLocationPatientTreatmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"insurance_estimation_trace"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/insurance_history/update
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insuranceHistoryUpdateLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"insurance_history"],[2,[7,"/"],[6,"update"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/insurance
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insuranceLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"insurance"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/:treatment_id/redo/insurance
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} treatmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insuranceLocationPatientTreatmentRedoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"treatment_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[2,[3,"treatment_id"],[2,[7,"/"],[2,[6,"redo"],[2,[7,"/"],[6,"insurance"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/insurance/need_this_faster
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insuranceNeedThisFasterLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"insurance"],[2,[7,"/"],[6,"need_this_faster"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /insurance_plans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insurancePlanPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /insurance_plan_page_preference
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insurancePlanPagePreferencePath = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"insurance_plan_page_preference"]]);

/**
 * Generates rails route to
 * /insurance_plans
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insurancePlansPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"insurance_plans"]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/insurance/request_plan/carriers
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insuranceRequestPlanCarriersLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"insurance"],[2,[7,"/"],[2,[6,"request_plan"],[2,[7,"/"],[6,"carriers"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/insurance/request_plan
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insuranceRequestPlanLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"insurance"],[2,[7,"/"],[6,"request_plan"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/insurance/rush_withdrawal
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insuranceRushWithdrawalLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"insurance"],[2,[7,"/"],[6,"rush_withdrawal"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/outbound_records/:id/intake_form(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const intakeFormLocationReferralsOutboundRecordPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"outbound_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"intake_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/account_copier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountCopierPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"account_copier"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/account_copier/copy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountCopierCopyPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"account_copier"],[2,[7,"/"],[2,[6,"copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/account_copier/dry_run(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountCopierDryRunPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"account_copier"],[2,[7,"/"],[2,[6,"dry_run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/custom_code_cleanup(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountCustomCodeCleanupPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"custom_code_cleanup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/custom_code_cleanup/fold(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountCustomCodeCleanupFoldPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"custom_code_cleanup"],[2,[7,"/"],[2,[6,"fold"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/custom_code_cleanup/fold_matching(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountCustomCodeCleanupFoldMatchingPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"custom_code_cleanup"],[2,[7,"/"],[2,[6,"fold_matching"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/custom_code_cleanup/undo(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountCustomCodeCleanupUndoPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"custom_code_cleanup"],[2,[7,"/"],[2,[6,"undo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/custom_code_cleanup/undo_check(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountCustomCodeCleanupUndoCheckPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"custom_code_cleanup"],[2,[7,"/"],[2,[6,"undo_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/merge_runs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountMergeRunPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"merge_runs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/merge_runs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountMergeRunsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"merge_runs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/provider_cleanup(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountProviderCleanupPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"provider_cleanup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/provider_cleanup/ai_review(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountProviderCleanupAiReviewPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"provider_cleanup"],[2,[7,"/"],[2,[6,"ai_review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/provider_cleanup/merge(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountProviderCleanupMergePath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"provider_cleanup"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/provider_cleanup/merge_check(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountProviderCleanupMergeCheckPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"provider_cleanup"],[2,[7,"/"],[2,[6,"merge_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/provider_cleanup/person(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountProviderCleanupPersonPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"provider_cleanup"],[2,[7,"/"],[2,[6,"person"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/provider_cleanup/relink(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountProviderCleanupRelinkPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"provider_cleanup"],[2,[7,"/"],[2,[6,"relink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/provider_cleanup/search(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountProviderCleanupSearchPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"provider_cleanup"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/provider_cleanup/undo(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountProviderCleanupUndoPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"provider_cleanup"],[2,[7,"/"],[2,[6,"undo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/provider_cleanup/undo_check(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountProviderCleanupUndoCheckPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"provider_cleanup"],[2,[7,"/"],[2,[6,"undo_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAccountsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/admins/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAdminPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admins/:admin_id/account_memberships/:id(.:format)
 * @param {any} adminId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAdminAccountMembershipPath = /*#__PURE__*/ __route({"admin_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"admin_id"],[2,[7,"/"],[2,[6,"account_memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admins/:admin_id/account_memberships(.:format)
 * @param {any} adminId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAdminAccountMembershipsPath = /*#__PURE__*/ __route({"admin_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"admin_id"],[2,[7,"/"],[2,[6,"account_memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admins(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAdminsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admins"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/ai_chats/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAiChatPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ai_chats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/ai_chats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAiChatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ai_chats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/ai_costs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAiCostDashboardPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[6,"ai_costs"]]]]);

/**
 * Generates rails route to
 * /internal/ai_invocations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAiInvocationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ai_invocations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/ai_invocations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAiInvocationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ai_invocations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/ai_memories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAiMemoriesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ai_memories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/ai_memories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAiMemoryPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ai_memories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/ai_outreach/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAiOutreachPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ai_outreach"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/ai_outreach(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAiOutreachIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ai_outreach"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/api_feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalApiFeedbackPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"api_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/bank_transaction_patterns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBankTransactionPatternPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"bank_transaction_patterns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/bank_transaction_patterns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBankTransactionPatternsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"bank_transaction_patterns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/bills/accounts/:account_id/locations/:location_id/voice_override
 * @param {any} accountId
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingPath = /*#__PURE__*/ __route({"account_id":{"r":true},"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"bills"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"voice_override"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/accounts/:account_id/charges/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingAccountChargePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"charges"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/accounts/:account_id/charges
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingAccountChargesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"charges"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/accounts/:account_id/contracts
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingAccountContractsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"contracts"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/accounts/:account_id/locations/:location_id/billing_exclusion
 * @param {any} accountId
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingAccountLocationBillingExclusionPath = /*#__PURE__*/ __route({"account_id":{"r":true},"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"billing_exclusion"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/accounts/:account_id/locations/:location_id/fees_start
 * @param {any} accountId
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingAccountLocationFeesStartPath = /*#__PURE__*/ __route({"account_id":{"r":true},"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"fees_start"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/accounts/:account_id/locations/:location_id/stripe_customer
 * @param {any} accountId
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingAccountLocationStripeCustomerPath = /*#__PURE__*/ __route({"account_id":{"r":true},"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"stripe_customer"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/accounts/:account_id/prices
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingAccountPricesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"prices"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingAccountsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/bills
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingBillsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[6,"bills"]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/bills/accounts/:account_id/locations/:location_id/add_line
 * @param {any} accountId
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingBillsAccountLocationAddLinePath = /*#__PURE__*/ __route({"account_id":{"r":true},"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"bills"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"add_line"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/bills/accounts/:account_id/locations/:location_id/add_next_line
 * @param {any} accountId
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingBillsAccountLocationAddNextLinePath = /*#__PURE__*/ __route({"account_id":{"r":true},"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"bills"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"add_next_line"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/bills/accounts/:account_id/locations/:location_id/hold
 * @param {any} accountId
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingBillsAccountLocationHoldPath = /*#__PURE__*/ __route({"account_id":{"r":true},"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"bills"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"hold"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/bills/accounts/:account_id/locations/:location_id/new_provider_fees/:fee_id/dismiss
 * @param {any} accountId
 * @param {any} locationId
 * @param {any} feeId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingBillsAccountLocationNewProviderFeeDismissPath = /*#__PURE__*/ __route({"account_id":{"r":true},"location_id":{"r":true},"fee_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"bills"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"new_provider_fees"],[2,[7,"/"],[2,[3,"fee_id"],[2,[7,"/"],[6,"dismiss"]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/bills/accounts/:account_id/locations/:location_id/phone_numbers/:phone_number_id/bill
 * @param {any} accountId
 * @param {any} locationId
 * @param {any} phoneNumberId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingBillsAccountLocationPhoneNumberBillPath = /*#__PURE__*/ __route({"account_id":{"r":true},"location_id":{"r":true},"phone_number_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"bills"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"phone_numbers"],[2,[7,"/"],[2,[3,"phone_number_id"],[2,[7,"/"],[6,"bill"]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/bills/accounts/:account_id/locations/:location_id/redraft
 * @param {any} accountId
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingBillsAccountLocationRedraftPath = /*#__PURE__*/ __route({"account_id":{"r":true},"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"bills"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"redraft"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/bills/accounts/:account_id/locations/:location_id/release
 * @param {any} accountId
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingBillsAccountLocationReleasePath = /*#__PURE__*/ __route({"account_id":{"r":true},"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"bills"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"release"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/bills/accounts/:account_id/locations/:location_id/send
 * @param {any} accountId
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingBillsAccountLocationSendPath = /*#__PURE__*/ __route({"account_id":{"r":true},"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"bills"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"send"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/bills/accounts/:account_id/locations/:location_id/voice_override
 * @param {any} accountId
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingBillsAccountLocationVoiceOverridePath = /*#__PURE__*/ __route({"account_id":{"r":true},"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"bills"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"voice_override"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/bills/send_all
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingBillsSendAllPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"bills"],[2,[7,"/"],[6,"send_all"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/bills/upload_dialstack
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingBillsUploadDialstackPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"bills"],[2,[7,"/"],[6,"upload_dialstack"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/contracts/:id/file
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingContractFilePath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"file"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/contracts
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingContractsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[6,"contracts"]]]]]]);

/**
 * Generates rails route to
 * /internal/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingDashboardPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/dialstack_files/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingDialstackFilePath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"dialstack_files"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/dialstack_files/:id/download
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingDialstackFileDownloadPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"dialstack_files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"download"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/dialstack_files
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingDialstackFilesPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[6,"dialstack_files"]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/invoices
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingInvoicesPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[6,"invoices"]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/ops
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingOpsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[6,"ops"]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/pricing
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingPricingPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[6,"pricing"]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/reconciliation
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingReconciliationPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[6,"reconciliation"]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/reconciliation/resync
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingReconciliationResyncPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"reconciliation"],[2,[7,"/"],[6,"resync"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/reconciliation/resync/:account_id
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingReconciliationResyncAccountPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"reconciliation"],[2,[7,"/"],[2,[6,"resync"],[2,[7,"/"],[3,"account_id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/review
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingReviewPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[6,"review"]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/stripe
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingStripeMirrorPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[6,"stripe"]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/stripe/invoices/:id/lines(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBillingStripeMirrorInvoiceLinesPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/bulk_verification_runs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalBulkVerificationRunPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"bulk_verification_runs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/carrier_archives(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalCarrierArchivesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"carrier_archives"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/carrier_call_asks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalCarrierCallAsksPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"carrier_call_asks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/carrier_merge_picks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalCarrierMergePicksPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"carrier_merge_picks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/insurance_carriers/merge_runs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalCarrierMergeRunPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[2,[6,"merge_runs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/insurance_carriers/merge_runs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalCarrierMergeRunsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[2,[6,"merge_runs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/insurance_carriers/merge_sweeps
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalCarrierMergeSweepsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[6,"merge_sweeps"]]]]]]);

/**
 * Generates rails route to
 * /internal/carrier_wallet_transfers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalCarrierWalletTransfersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"carrier_wallet_transfers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/content_sync_runs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalContentSyncRunsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"content_sync_runs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalDashboardIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/demos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalDemosPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"demos"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/dental_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalDentalCodesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"dental_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/duration_predictions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalDurationPredictionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"duration_predictions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/duration_predictions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalDurationPredictionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"duration_predictions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/eligibility_dashboard
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalEligibilityDashboardPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[6,"eligibility_dashboard"]]]]);

/**
 * Generates rails route to
 * /internal/eligibility_manual_checks/:id/download_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalEligibilityManualCheckDownloadPdfPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eligibility_manual_checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eligibility_manual_checks/:id/download_screenshot(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalEligibilityManualCheckDownloadScreenshotPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eligibility_manual_checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_screenshot"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_accuracy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalEobAccuracyPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_accuracy"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_batch_runs/:id/download_screenshot(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalEobBatchRunDownloadScreenshotPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_batch_runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_screenshot"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_manual_checks/:id/download_eob_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalEobManualCheckDownloadEobPdfPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_manual_checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_eob_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_manual_checks/:id/download_screenshot(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalEobManualCheckDownloadScreenshotPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_manual_checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_screenshot"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalEobStatusIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/external_text_flags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExternalTextFlagsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"external_text_flags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/feature_flags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalFeatureFlagsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"feature_flags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/feature_rollouts/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalFeatureRolloutPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"feature_rollouts"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /internal/feature_rollouts
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalFeatureRolloutsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[6,"feature_rollouts"]]]]);

/**
 * Generates rails route to
 * /internal/fee_schedule_drift(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalFeeScheduleDriftPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"fee_schedule_drift"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLivePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:go_live_id/account_links(.:format)
 * @param {any} goLiveId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveAccountLinksPath = /*#__PURE__*/ __route({"go_live_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"go_live_id"],[2,[7,"/"],[2,[6,"account_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:go_live_id/account_setup_links/:id(.:format)
 * @param {any} goLiveId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveAccountSetupLinkPath = /*#__PURE__*/ __route({"go_live_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"go_live_id"],[2,[7,"/"],[2,[6,"account_setup_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:go_live_id/account_setup_links(.:format)
 * @param {any} goLiveId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveAccountSetupLinksPath = /*#__PURE__*/ __route({"go_live_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"go_live_id"],[2,[7,"/"],[2,[6,"account_setup_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:go_live_id/assignments/:id(.:format)
 * @param {any} goLiveId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveAssignmentPath = /*#__PURE__*/ __route({"go_live_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"go_live_id"],[2,[7,"/"],[2,[6,"assignments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:go_live_id/assignments(.:format)
 * @param {any} goLiveId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveAssignmentsPath = /*#__PURE__*/ __route({"go_live_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"go_live_id"],[2,[7,"/"],[2,[6,"assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:go_live_id/contacts(.:format)
 * @param {any} goLiveId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveContactsPath = /*#__PURE__*/ __route({"go_live_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"go_live_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:go_live_id/credentials/:id(.:format)
 * @param {any} goLiveId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveCredentialPath = /*#__PURE__*/ __route({"go_live_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"go_live_id"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:go_live_id/credentials(.:format)
 * @param {any} goLiveId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveCredentialsPath = /*#__PURE__*/ __route({"go_live_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"go_live_id"],[2,[7,"/"],[2,[6,"credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:go_live_id/link(.:format)
 * @param {any} goLiveId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveLinkPath = /*#__PURE__*/ __route({"go_live_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"go_live_id"],[2,[7,"/"],[2,[6,"link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:go_live_id/option_selections/:id(.:format)
 * @param {any} goLiveId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveOptionSelectionPath = /*#__PURE__*/ __route({"go_live_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"go_live_id"],[2,[7,"/"],[2,[6,"option_selections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:go_live_id/option_selections(.:format)
 * @param {any} goLiveId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveOptionSelectionsPath = /*#__PURE__*/ __route({"go_live_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"go_live_id"],[2,[7,"/"],[2,[6,"option_selections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_plans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLivePlanPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_plans/:go_live_plan_id/stops/:id(.:format)
 * @param {any} goLivePlanId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLivePlanStopPath = /*#__PURE__*/ __route({"go_live_plan_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_plans"],[2,[7,"/"],[2,[3,"go_live_plan_id"],[2,[7,"/"],[2,[6,"stops"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_plans/:go_live_plan_id/stops(.:format)
 * @param {any} goLivePlanId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLivePlanStopsPath = /*#__PURE__*/ __route({"go_live_plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_plans"],[2,[7,"/"],[2,[3,"go_live_plan_id"],[2,[7,"/"],[2,[6,"stops"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLivePlansPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_sizing_rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveSizingRulesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_sizing_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:go_live_id/splashtop_assignments(.:format)
 * @param {any} goLiveId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveSplashtopAssignmentsPath = /*#__PURE__*/ __route({"go_live_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"go_live_id"],[2,[7,"/"],[2,[6,"splashtop_assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:go_live_id/splashtop_group(.:format)
 * @param {any} goLiveId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveSplashtopGroupPath = /*#__PURE__*/ __route({"go_live_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"go_live_id"],[2,[7,"/"],[2,[6,"splashtop_group"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_team_members/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveTeamMemberPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_team_members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_team_members(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveTeamMembersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_team_members"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:go_live_id/trainings/:id(.:format)
 * @param {any} goLiveId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveTrainingPath = /*#__PURE__*/ __route({"go_live_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"go_live_id"],[2,[7,"/"],[2,[6,"trainings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:go_live_id/trainings(.:format)
 * @param {any} goLiveId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLiveTrainingsPath = /*#__PURE__*/ __route({"go_live_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"go_live_id"],[2,[7,"/"],[2,[6,"trainings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoLivesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/held_balances
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalHeldBalancesPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[6,"held_balances"]]]]);

/**
 * Generates rails route to
 * /internal/implementations
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalImplementationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[6,"implementations"]]]]);

/**
 * Generates rails route to
 * /internal/insurance_carriers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalInsuranceCarriersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"insurance_carriers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/insurance_import_monitor/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalInsuranceImportMonitorPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"insurance_import_monitor"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/insurance_import_monitor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalInsuranceImportMonitorIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"insurance_import_monitor"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[6,"integrations"]]]]);

/**
 * Generates rails route to
 * /internal/knowledge/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalKnowledgePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/knowledge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalKnowledgeIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"knowledge"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/links/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalLinkPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /internal/links
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalLinksPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[6,"links"]]]]);

/**
 * Generates rails route to
 * /internal/live_calls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalLiveCallPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"live_calls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/live_calls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalLiveCallsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"live_calls"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/locations/merge_runs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalLocationMergeRunPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[6,"merge_runs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/locations/merge_runs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalLocationMergeRunsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[6,"merge_runs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/modento_form_exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalModentoFormExportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"modento_form_exports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/patient_dossiers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPatientDossierPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"patient_dossiers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/patient_dossiers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPatientDossiersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"patient_dossiers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/payment_settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPaymentSettingPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"payment_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/payment_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPaymentSettingsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"payment_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/perio_voice_sessions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPerioVoiceSessionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"perio_voice_sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/perio_voice_sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPerioVoiceSessionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"perio_voice_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/permissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPermissionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/phone_numbers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPhoneNumberPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"phone_numbers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/phone_numbers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPhoneNumbersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"phone_numbers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/practice_management_systems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPracticeManagementSystemPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"practice_management_systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/practice_management_systems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPracticeManagementSystemsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"practice_management_systems"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/practice_map(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPracticeMapPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"practice_map"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/pre_auth_dashboard
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPreAuthDashboardPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[6,"pre_auth_dashboard"]]]]);

/**
 * Generates rails route to
 * /internal/pre_auth_manual_checks/:id/download_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPreAuthManualCheckDownloadPdfPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"pre_auth_manual_checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/pre_auth_manual_checks/:id/download_screenshot(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPreAuthManualCheckDownloadScreenshotPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"pre_auth_manual_checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_screenshot"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/preferences(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPreferencesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/processes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalProcessesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"processes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/processing_rates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalProcessingRatesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"processing_rates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/prototypes/form_import/:variation(.:format)
 * @param {any} variation
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPrototypeFormImportPath = /*#__PURE__*/ __route({"variation":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"prototypes"],[2,[7,"/"],[2,[6,"form_import"],[2,[7,"/"],[2,[3,"variation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/providers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalProviderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/providers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalProvidersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"providers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalRcmAutomationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/records_releases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalRecordsReleasesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"records_releases"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/retell_tool_calls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalRetellToolCallPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"retell_tool_calls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/retell_tool_calls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalRetellToolCallsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"retell_tool_calls"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/revenue
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalRevenuePath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[6,"revenue"]]]]);

/**
 * Generates rails route to
 * /internal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalRootPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSidekiqWebPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[6,"sidekiq"]]]]);

/**
 * Generates rails route to
 * /internal/snail_mail
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSnailMailPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[6,"snail_mail"]]]]);

/**
 * Generates rails route to
 * /internal/snail_mail/extract_address
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSnailMailExtractAddressPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"snail_mail"],[2,[7,"/"],[6,"extract_address"]]]]]]);

/**
 * Generates rails route to
 * /internal/snail_mail/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSnailMailLetterPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"snail_mail"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /internal/snail_mail/:id/pdf
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSnailMailPdfPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"snail_mail"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"pdf"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/support(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/support/accounts/:account_id(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportAccountPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/support/accounts/:account_id/health(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportAccountHealthPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"health"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/support/accounts/:account_id/notes(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportAccountNotesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/support/accounts/:account_id/sentiment(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportAccountSentimentPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"sentiment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/support/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportAccountsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/support/admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportAdminPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/support/ai(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportAiPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"ai"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/support/backfill_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportBackfillMessagesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"backfill_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/support/issue_actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportIssueActionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"issue_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/support_on_call_shifts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportOnCallShiftPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support_on_call_shifts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/support_on_call_shifts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportOnCallShiftsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support_on_call_shifts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/support/overall(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportOverallPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"overall"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/support/run(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportRunPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/support/team(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportTeamPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"team"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/support/tickets/:pylon_issue_id
 * @param {any} pylonIssueId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportTicketPath = /*#__PURE__*/ __route({"pylon_issue_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[3,"pylon_issue_id"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/support/tickets/:pylon_issue_id/chats
 * @param {any} pylonIssueId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportTicketChatsPath = /*#__PURE__*/ __route({"pylon_issue_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"pylon_issue_id"],[2,[7,"/"],[6,"chats"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/support/topics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSupportTopicsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/third_party_imports
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalThirdPartyImportsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[6,"third_party_imports"]]]]);

/**
 * Generates rails route to
 * /internal/time_block_thresholds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalTimeBlockThresholdsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"time_block_thresholds"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalTrainingAdminPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalTrainingAnalyticsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_curricula(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalTrainingCurriculaPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_curricula"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_curricula/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalTrainingCurriculumPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_curricula"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_curricula/:training_curriculum_id/entries(.:format)
 * @param {any} trainingCurriculumId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalTrainingCurriculumEntriesPath = /*#__PURE__*/ __route({"training_curriculum_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_curricula"],[2,[7,"/"],[2,[3,"training_curriculum_id"],[2,[7,"/"],[2,[6,"entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_curricula/:training_curriculum_id/entries/:id(.:format)
 * @param {any} trainingCurriculumId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalTrainingCurriculumEntryPath = /*#__PURE__*/ __route({"training_curriculum_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_curricula"],[2,[7,"/"],[2,[3,"training_curriculum_id"],[2,[7,"/"],[2,[6,"entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_videos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalTrainingVideoPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_videos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_videos/:training_video_id/versions(.:format)
 * @param {any} trainingVideoId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalTrainingVideoVersionsPath = /*#__PURE__*/ __route({"training_video_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_videos"],[2,[7,"/"],[2,[3,"training_video_id"],[2,[7,"/"],[2,[6,"versions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_videos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalTrainingVideosPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_videos"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_viewers/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalTrainingViewerPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_viewers"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /internal/unify/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalUnifyPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"unify"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/unify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalUnifyIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"unify"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/unify/system(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalUnifySystemPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"unify"],[2,[7,"/"],[2,[6,"system"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/vendor_payer_coverage
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalVendorPayerCoverageIndexPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[6,"vendor_payer_coverage"]]]]);

/**
 * Generates rails route to
 * /internal/verification_api_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalVerificationApiRequestPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"verification_api_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/verification_api_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalVerificationApiRequestsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"verification_api_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/vyne_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalVyneStatusIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"vyne_status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/whats_new_highlights/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalWhatsNewHighlightPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"whats_new_highlights"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /internal/whats_new_highlights
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalWhatsNewHighlightsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[6,"whats_new_highlights"]]]]);

/**
 * Generates rails route to
 * /internal/whats_new/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalWhatsNewPostPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"whats_new"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /internal/whats_new
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalWhatsNewPostsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[6,"whats_new"]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const itemsRcmServicesInboxIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/documents/:document_id/join
 * @param {any} locationId
 * @param {any} id
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const joinDocumentLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"document_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[6,"join"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/documents/:document_id/join_partner
 * @param {any} locationId
 * @param {any} id
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const joinDocumentPartnerLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"document_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[6,"join_partner"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/kick_snapshot
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kickSnapshotImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"kick_snapshot"]]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/account/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgeAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgeAccountIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/twelve/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgeTwelvePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"twelve"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/twelve(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledgeTwelveIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"twelve"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/lab_case_fees_export_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labCaseFeesExportCsvReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"lab_case_fees_export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/lab_case_fees(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labCaseFeesReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"lab_case_fees"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/lab_fees(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labFeesDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"lab_fees"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/lab_fees(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labFeesEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"lab_fees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/lab_cases/lab_options(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labOptionsLocationLabCasesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"lab_cases"],[2,[7,"/"],[2,[6,"lab_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/schedule/language
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const languageLocationPatientSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"schedule"],[2,[7,"/"],[6,"language"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/language
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const languageLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"language"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise(/*legacy_path)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyEnterpriseRedirectPath = /*#__PURE__*/ __route({"legacy_path":{}}, [2,[7,"/"],[2,[6,"enterprise"],[1,[2,[7,"/"],[5,[3,"legacy_path"]]]]]]);

/**
 * Generates rails route to
 * /settings(/*legacy_path)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacySettingsRedirectPath = /*#__PURE__*/ __route({"legacy_path":{}}, [2,[7,"/"],[2,[6,"settings"],[1,[2,[7,"/"],[5,[3,"legacy_path"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/library_pages/:page_id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {any} pageId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const libraryPageLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"page_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"library_pages"],[2,[7,"/"],[3,"page_id"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/library_videos/:page_id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {any} pageId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const libraryVideoLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"page_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"library_videos"],[2,[7,"/"],[3,"page_id"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/holds/lift
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const liftCredentialingHoldsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"holds"],[2,[7,"/"],[6,"lift"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/inbound_records/:id/link_appointment(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkAppointmentLocationReferralsInboundRecordPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"inbound_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_appointment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/link_bank_deposit
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkBankDepositLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"link_bank_deposit"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/link_bank_deposit
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkBankDepositLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"link_bank_deposit"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/link_bank_deposit
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkBankDepositRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"link_bank_deposit"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/link_bank_deposit
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkBankDepositRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"link_bank_deposit"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/link_billing_customer
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkBillingCustomerImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"link_billing_customer"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/deposit_triage/:id/link_bulk_deposit
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkBulkDepositRcmServicesDepositTriagePath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"deposit_triage"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"link_bulk_deposit"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/link_connected_account
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkConnectedAccountImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"link_connected_account"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/link_dialstack_account
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkDialstackAccountInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"link_dialstack_account"]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/link_dialstack_location
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkDialstackLocationInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"link_dialstack_location"]]]]]]);

/**
 * Generates rails route to
 * /internal/providers/:id/link_dosespot_clinician(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkDosespotClinicianInternalProviderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_dosespot_clinician"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/link_go_live_location
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkGoLiveLocationImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"link_go_live_location"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:id/link_implementation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkImplementationInternalGoLivePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_implementation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/accounts/:account_id/locations/:location_id/stripe_customer/link
 * @param {any} accountId
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkInternalBillingAccountLocationStripeCustomerPath = /*#__PURE__*/ __route({"account_id":{"r":true},"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"stripe_customer"],[2,[7,"/"],[6,"link"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/link_location
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkLocationImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"link_location"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:id/link_location(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkLocationInternalGoLivePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/documents/:id/link_patient
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkPatientLocationRcmDocumentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"link_patient"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/deposit_triage/:id/link_payment
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkPaymentRcmServicesDepositTriagePath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"deposit_triage"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"link_payment"]]]]]]]]]]);

/**
 * Generates rails route to
 * /link-setup/:token
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkSetupPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"link-setup"],[2,[7,"/"],[3,"token"]]]]);

/**
 * Generates rails route to
 * /link-setup/:token/download
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkSetupDownloadPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"link-setup"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[6,"download"]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/link_stripe_connected_account
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkStripeConnectedAccountInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"link_stripe_connected_account"]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/link_twilio_subaccount(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkTwilioSubaccountInternalAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_twilio_subaccount"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/link_virtual_card_charge
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkVirtualCardChargeLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"link_virtual_card_charge"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/link_virtual_card_charge
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkVirtualCardChargeRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"link_virtual_card_charge"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentation_snapshots/:id/live
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const liveLocationPatientTreatmentPresentationSnapshotPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentation_snapshots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"live"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:id/active_subscribers(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationActiveSubscribersInsurancePlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/ai_chat
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationAiChatPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"ai_chat"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/ambient_patient_note_candidates/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1AmbientPatientNoteCandidatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ambient_patient_note_candidates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/ambient_sessions/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1AmbientSessionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ambient_sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/ambient_sessions(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1AmbientSessionsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ambient_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/clinical_note_addenda(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1ClinicalNoteAddendaPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clinical_note_addenda"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/clinical_note_lock(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1ClinicalNoteLockPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clinical_note_lock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/clinical_notes(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1ClinicalNotesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clinical_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/clinical_opportunities(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1PatientClinicalOpportunitiesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_opportunities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/clinical_photos/:id(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1PatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/clinical_photos(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1PatientClinicalPhotosPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/external_letters(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1PatientExternalLettersPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"external_letters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/odontogram(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1PatientOdontogramPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/odontogram/tooth_conditions/:id(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1PatientOdontogramToothConditionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"tooth_conditions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/odontogram/tooth_conditions(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1PatientOdontogramToothConditionsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"tooth_conditions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/referral_contexts(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1PatientReferralContextsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"referral_contexts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_plans/:id(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1PatientTreatmentPlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_plans(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1PatientTreatmentPlansPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_visits/:id(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1PatientTreatmentVisitPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_visits(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApiV1PatientTreatmentVisitsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:plan_id/document_imports/:id/apply(.:format)
 * @param {any} locationId
 * @param {any} planId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationApplyInsurancePlanDocumentImportPath = /*#__PURE__*/ __route({"location_id":{"r":true},"plan_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"plan_id"],[2,[7,"/"],[2,[6,"document_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:appointment_id/comments/:id(.:format)
 * @param {any} locationId
 * @param {any} appointmentId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationAppointmentCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"appointment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"appointment_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:appointment_id/comments(.:format)
 * @param {any} locationId
 * @param {any} appointmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationAppointmentCommentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"appointment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"appointment_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:appointment_id/operatory_wait
 * @param {any} locationId
 * @param {any} appointmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationAppointmentOperatoryWaitPath = /*#__PURE__*/ __route({"location_id":{"r":true},"appointment_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"appointment_id"],[2,[7,"/"],[6,"operatory_wait"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationAppointmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_carriers/:id/archive
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationArchiveInsuranceCarrierPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"archive"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:id/archive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationArchiveInsurancePlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/bank_deposits/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationBankDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"bank_deposits"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/bank_deposits
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationBankDepositsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"bank_deposits"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/calls(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationCallsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"calls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/check_in_flyer
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationCheckInFlyerPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"check_in_flyer"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/check_in_flyer/qr
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationCheckInFlyerQrPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in_flyer"],[2,[7,"/"],[6,"qr"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/closed_days(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationClosedDaysPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"closed_days"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages/conversations/:conversation_id/comm_logs/:id
 * @param {any} locationId
 * @param {any} conversationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationConversationCommLogPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"comm_logs"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages/conversations/:conversation_id/comm_logs
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationConversationCommLogsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[6,"comm_logs"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages/conversations/:conversation_id/communications/:id/create_action_item
 * @param {any} locationId
 * @param {any} conversationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationConversationCommunicationCreateActionItemPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"create_action_item"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages/conversations/:conversation_id/communications/:id/new_action_item
 * @param {any} locationId
 * @param {any} conversationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationConversationCommunicationNewActionItemPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"new_action_item"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages/conversations/:conversation_id/comm_logs/:id
 * @param {any} locationId
 * @param {any} conversationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationConversationDeleteCommLogPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"comm_logs"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages/conversations/:conversation_id/comm_logs/:id/edit
 * @param {any} locationId
 * @param {any} conversationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationConversationEditCommLogPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"comm_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages/conversations/:conversation_id/comm_logs/new
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationConversationNewCommLogPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"comm_logs"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages/conversations/:conversation_id/emails/:id
 * @param {any} locationId
 * @param {any} conversationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationConversationShowEmailPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:id/copy_benefits(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationCopyBenefitsInsurancePlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy_benefits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:plan_id/document_imports/current(.:format)
 * @param {any} locationId
 * @param {any} planId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationCurrentInsurancePlanDocumentImportPath = /*#__PURE__*/ __route({"location_id":{"r":true},"plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"plan_id"],[2,[7,"/"],[2,[6,"document_imports"],[2,[7,"/"],[2,[6,"current"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/daily(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationDailyIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"daily"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/documents/:patient_id/receipt/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationDocumentReceiptPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"receipt"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/documents/:patient_id/statement/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationDocumentStatementPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"statement"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/dosespot
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationDosespotPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"dosespot"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationEditInsurancePlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/event_logs/:event_log_id/comments/:id(.:format)
 * @param {any} locationId
 * @param {any} eventLogId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationEventLogCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"event_log_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"event_logs"],[2,[7,"/"],[2,[3,"event_log_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/event_logs/:event_log_id/comments(.:format)
 * @param {any} locationId
 * @param {any} eventLogId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationEventLogCommentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"event_log_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"event_logs"],[2,[7,"/"],[2,[3,"event_log_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/families
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationFamiliesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"families"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/families/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationFamilyPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"families"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/faxes
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationFaxesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"faxes"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/fee_schedules/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationFeeSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"fee_schedules"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/fee_schedules/:fee_schedule_id/fees/:id
 * @param {any} locationId
 * @param {any} feeScheduleId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationFeeScheduleFeePath = /*#__PURE__*/ __route({"location_id":{"r":true},"fee_schedule_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"fee_schedules"],[2,[7,"/"],[2,[3,"fee_schedule_id"],[2,[7,"/"],[2,[6,"fees"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/fee_schedules/:fee_schedule_id/fees
 * @param {any} locationId
 * @param {any} feeScheduleId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationFeeScheduleFeesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"fee_schedule_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"fee_schedules"],[2,[7,"/"],[2,[3,"fee_schedule_id"],[2,[7,"/"],[6,"fees"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/fee_schedules
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationFeeSchedulesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"fee_schedules"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/feedback(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationFeedbackPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:id/field_history(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationFieldHistoryInsurancePlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"field_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/find_time(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationFindTimePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"find_time"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/general_supervision_reviews
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationGeneralSupervisionReviewsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"general_supervision_reviews"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInboxIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/location_info
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInfoImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"location_info"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_carriers/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsuranceCarrierPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_carriers/:id/office_network
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsuranceCarrierOfficeNetworkPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"office_network"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_carriers/:id/provenance(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsuranceCarrierProvenancePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"provenance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_carriers/:insurance_carrier_id/wallet/correction_targets(.:format)
 * @param {any} locationId
 * @param {any} insuranceCarrierId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsuranceCarrierWalletCorrectionTargetsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"insurance_carrier_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[2,[3,"insurance_carrier_id"],[2,[7,"/"],[2,[6,"wallet"],[2,[7,"/"],[2,[6,"correction_targets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_carriers/wallet/invoice_options(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsuranceCarrierWalletInvoiceOptionsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[2,[6,"wallet"],[2,[7,"/"],[2,[6,"invoice_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_carriers/:insurance_carrier_id/wallet/opening_balances(.:format)
 * @param {any} locationId
 * @param {any} insuranceCarrierId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsuranceCarrierWalletOpeningBalancesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"insurance_carrier_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[2,[3,"insurance_carrier_id"],[2,[7,"/"],[2,[6,"wallet"],[2,[7,"/"],[2,[6,"opening_balances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_carriers/wallet/patient_search(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsuranceCarrierWalletPatientSearchPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[2,[6,"wallet"],[2,[7,"/"],[2,[6,"patient_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_carriers/:insurance_carrier_id/wallet/takebacks(.:format)
 * @param {any} locationId
 * @param {any} insuranceCarrierId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsuranceCarrierWalletTakebacksPath = /*#__PURE__*/ __route({"location_id":{"r":true},"insurance_carrier_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[2,[3,"insurance_carrier_id"],[2,[7,"/"],[2,[6,"wallet"],[2,[7,"/"],[2,[6,"takebacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_carriers
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsuranceCarriersPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"insurance_carriers"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_claims/:insurance_claim_id/comments/:id
 * @param {any} locationId
 * @param {any} insuranceClaimId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsuranceClaimCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"insurance_claim_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"insurance_claim_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_claims/:insurance_claim_id/comments
 * @param {any} locationId
 * @param {any} insuranceClaimId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsuranceClaimCommentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"insurance_claim_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"insurance_claim_id"],[2,[7,"/"],[6,"comments"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_claims
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsuranceClaimsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"insurance_claims"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsurancePaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"insurance_payments"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsurancePlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:id/capture_in_flight(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsurancePlanCaptureInFlightPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"capture_in_flight"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:insurance_plan_id/comments/:id(.:format)
 * @param {any} locationId
 * @param {any} insurancePlanId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsurancePlanCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"insurance_plan_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"insurance_plan_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:insurance_plan_id/comments(.:format)
 * @param {any} locationId
 * @param {any} insurancePlanId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsurancePlanCommentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"insurance_plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"insurance_plan_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:plan_id/document_imports/:id(.:format)
 * @param {any} locationId
 * @param {any} planId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsurancePlanDocumentImportPath = /*#__PURE__*/ __route({"location_id":{"r":true},"plan_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"plan_id"],[2,[7,"/"],[2,[6,"document_imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:plan_id/document_imports/:id/status(.:format)
 * @param {any} locationId
 * @param {any} planId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsurancePlanDocumentImportStatusPath = /*#__PURE__*/ __route({"location_id":{"r":true},"plan_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"plan_id"],[2,[7,"/"],[2,[6,"document_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:plan_id/document_imports(.:format)
 * @param {any} locationId
 * @param {any} planId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsurancePlanDocumentImportsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"plan_id"],[2,[7,"/"],[2,[6,"document_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:id/fee_schedule_overrides(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsurancePlanFeeScheduleOverridesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"fee_schedule_overrides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationInsurancePlansPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"insurance_plans"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/lab_cases/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationLabCasePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"lab_cases"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/lab_cases/:lab_case_id/comments/:id(.:format)
 * @param {any} locationId
 * @param {any} labCaseId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationLabCaseCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"lab_case_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"lab_cases"],[2,[7,"/"],[2,[3,"lab_case_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/lab_cases/:lab_case_id/comments(.:format)
 * @param {any} locationId
 * @param {any} labCaseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationLabCaseCommentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"lab_case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"lab_cases"],[2,[7,"/"],[2,[3,"lab_case_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/lab_cases(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationLabCasesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"lab_cases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:id/load_more_history(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationLoadMoreHistoryInsurancePlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"load_more_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/manual_sync/completed_appointments
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationManualSyncCompletedAppointmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"manual_sync"],[2,[7,"/"],[6,"completed_appointments"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/manual_sync/ledger
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationManualSyncLedgerPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"manual_sync"],[2,[7,"/"],[6,"ledger"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/manual_sync/received_claims
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationManualSyncReceivedClaimsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"manual_sync"],[2,[7,"/"],[6,"received_claims"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/location_mapping
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationMappingImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"location_mapping"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/unify/:id/location_mappings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationMappingsInternalUnifyPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"unify"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"location_mappings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:id/merge(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationMergeInsurancePlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationMessagesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"messages"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"messages_v2"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/office_phone/calls/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationOfficePhoneCallPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"office_phone"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/office_phone/call_session
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationOfficePhoneCallSessionPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"office_phone"],[2,[7,"/"],[6,"call_session"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/office_phone/caller
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationOfficePhoneCallerPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"office_phone"],[2,[7,"/"],[6,"caller"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/office_phone/calls
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationOfficePhoneCallsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"office_phone"],[2,[7,"/"],[6,"calls"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/office_phone/keepalive
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationOfficePhoneKeepalivePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"office_phone"],[2,[7,"/"],[6,"keepalive"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/office_phone/line
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationOfficePhoneLinePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"office_phone"],[2,[7,"/"],[6,"line"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/office_phone/lines
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationOfficePhoneLinesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"office_phone"],[2,[7,"/"],[6,"lines"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/office_phone/listener
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationOfficePhoneListenerPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"office_phone"],[2,[7,"/"],[6,"listener"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/office_phone/session
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationOfficePhoneSessionPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"office_phone"],[2,[7,"/"],[6,"session"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/office_phone/transcript_pause
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationOfficePhoneTranscriptPausePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"office_phone"],[2,[7,"/"],[6,"transcript_pause"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/office_phone/transfer_targets
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationOfficePhoneTransferTargetsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"office_phone"],[2,[7,"/"],[6,"transfer_targets"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/office_phone/window
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationOfficePhoneWindowPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"office_phone"],[2,[7,"/"],[6,"window"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/operatory_queue
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationOperatoryQueuePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"operatory_queue"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/agreements_v2
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientAgreementsV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"agreements_v2"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_photos/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_photos
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientClinicalPhotosPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"clinical_photos"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_photos/viewer
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientClinicalPhotosViewerPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[6,"viewer"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/excuse_letter
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientExcuseLetterPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"excuse_letter"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/excuse_letter/translation_draft
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientExcuseLetterTranslationDraftPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"excuse_letter"],[2,[7,"/"],[6,"translation_draft"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/files_v2/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientFilesV2Path = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"files_v2"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/files_v2
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientFilesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"files_v2"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/forms_v2/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientFormsV2Path = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"forms_v2"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/forms_v2
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientFormsV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"forms_v2"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_benefit_adjustments/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientInsuranceBenefitAdjustmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_benefit_adjustments"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_benefit_adjustments
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientInsuranceBenefitAdjustmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"insurance_benefit_adjustments"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:insurance_claim_id/insurance_claim_procedures/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} insuranceClaimId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientInsuranceClaimInsuranceClaimProcedurePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"insurance_claim_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"insurance_claim_id"],[2,[7,"/"],[2,[6,"insurance_claim_procedures"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientInsuranceClaimsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"insurance_claims"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_subscribers/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientInsuranceSubscriberPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_subscribers"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_verifications/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientInsuranceVerificationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_verifications"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_verifications
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientInsuranceVerificationsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"insurance_verifications"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_verifications/rerun
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientInsuranceVerificationsRerunPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_verifications"],[2,[7,"/"],[6,"rerun"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientInvoicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:invoice_id/adjustments/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} invoiceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientInvoiceAdjustmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"invoice_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:invoice_id/adjustments
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} invoiceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientInvoiceAdjustmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"invoice_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[6,"adjustments"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/medical_claims/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientMedicalClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"medical_claims"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/medical_claims/:medical_claim_id/lines/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} medicalClaimId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientMedicalClaimLinePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"medical_claim_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"medical_claims"],[2,[7,"/"],[2,[3,"medical_claim_id"],[2,[7,"/"],[2,[6,"lines"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/medical_coverages/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientMedicalCoveragePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"medical_coverages"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientOdontogramPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"odontogram"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/offsite_services/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientOffsiteServicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"offsite_services"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_dental_anxiety
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientDentalAnxietyPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"patient_dental_anxiety"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_medications/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientMedicationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_medications"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_medication_risks/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientMedicationRiskPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_medication_risks"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_medication_risks
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientMedicationRisksPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"patient_medication_risks"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_medications
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientMedicationsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"patient_medications"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_notes/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientNotePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_notes"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_notes
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientNotesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"patient_notes"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientPaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/:patient_payment_id/reallocation
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} patientPaymentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientPaymentReallocationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"patient_payment_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[2,[3,"patient_payment_id"],[2,[7,"/"],[6,"reallocation"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"patient_payments"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_premedications/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientPremedicationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_premedications"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_premedications
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientPremedicationsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"patient_premedications"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_surgeries
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientSurgeriesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"patient_surgeries"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_surgeries/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientSurgeryPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_surgeries"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_tobacco_uses/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientTobaccoUsePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_tobacco_uses"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_tobacco_uses
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientTobaccoUsesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"patient_tobacco_uses"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_vitals/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientVitalPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_vitals"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_vitals
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPatientVitalsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"patient_vitals"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_plans/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPaymentPlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_plans"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_plan_agreements/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPaymentPlanAgreementPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_plan_agreements"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_plans
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPaymentPlansPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"payment_plans"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/perio_charts/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPerioChartPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"perio_charts"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/perio_charts
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPerioChartsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"perio_charts"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/periodontal_charts/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPeriodontalChartPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"periodontal_charts"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/periodontal_charts
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPeriodontalChartsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"periodontal_charts"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/plan_subscription
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPlanSubscriptionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"plan_subscription"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:pre_authorization_id/claim_documentation
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} preAuthorizationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientPreAuthorizationClaimDocumentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"pre_authorization_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"pre_authorization_id"],[2,[7,"/"],[6,"claim_documentation"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/schedule
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"schedule"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientTreatmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/:treatment_id/adjustments/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} treatmentId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientTreatmentAdjustmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"treatment_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[2,[3,"treatment_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/:treatment_id/adjustments
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} treatmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientTreatmentAdjustmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"treatment_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[2,[3,"treatment_id"],[2,[7,"/"],[6,"adjustments"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentation_snapshots/:id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientTreatmentPresentationSnapshotPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentation_snapshots"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientTreatmentPresentationsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"treatment_presentations"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/:treatment_id/redo
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} treatmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientTreatmentRedoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"treatment_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[2,[3,"treatment_id"],[2,[7,"/"],[6,"redo"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"treatments"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPatientsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"patients"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/payment_links
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPaymentLinksPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"payment_links"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/possible_duplicates
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPossibleDuplicatesInsurancePlansPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[6,"possible_duplicates"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/practice-info
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPracticeInfoPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"practice-info"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/pre_auth_preparation(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPreAuthPreparationIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"pre_auth_preparation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/pre_authorizations
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPreAuthorizationsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"pre_authorizations"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:plan_id/document_imports/:id/preview(.:format)
 * @param {any} locationId
 * @param {any} planId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPreviewInsurancePlanDocumentImportPath = /*#__PURE__*/ __route({"location_id":{"r":true},"plan_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"plan_id"],[2,[7,"/"],[2,[6,"document_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/privacy-policy
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPrivacyPolicyPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"privacy-policy"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referral-intake
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationPublicReferralIntakePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"referral-intake"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRcmBulkDepositsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[6,"bulk_deposits"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/dashboard
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRcmDashboardIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[6,"dashboard"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/documents/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRcmDocumentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/documents
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRcmDocumentsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[6,"documents"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRcmEobUploadsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[6,"eob_uploads"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/payments_denials
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRcmPaymentsDenialsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[6,"payments_denials"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/pre_authorizations_queue(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRcmPreAuthorizationsQueueIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"pre_authorizations_queue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/requests_history(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRcmRequestsHistoryIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"requests_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/verification_queue(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRcmVerificationQueueIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"verification_queue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/virtual_cards
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRcmVirtualCardsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[6,"virtual_cards"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/categories(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsCategoriesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/categories/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsCategoryPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/directory/category_options(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsDirectoryCategoryOptionsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"directory"],[2,[7,"/"],[2,[6,"category_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/directory/office_provider_options(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsDirectoryOfficeProviderOptionsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"directory"],[2,[7,"/"],[2,[6,"office_provider_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/directory/patient_search(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsDirectoryPatientSearchPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"directory"],[2,[7,"/"],[2,[6,"patient_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/directory/practice_search(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsDirectoryPracticeSearchPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"directory"],[2,[7,"/"],[2,[6,"practice_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/directory/provider_search(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsDirectoryProviderSearchPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"directory"],[2,[7,"/"],[2,[6,"provider_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/directory/referring_provider_options(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsDirectoryReferringProviderOptionsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"directory"],[2,[7,"/"],[2,[6,"referring_provider_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/external_letters(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsExternalLettersPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"external_letters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/inbound_records/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsInboundRecordPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"inbound_records"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/inbound_records(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsInboundRecordsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"inbound_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/letters/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsLetterPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/letters/:letter_id/images/:id(.:format)
 * @param {any} locationId
 * @param {any} letterId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsLetterImagePath = /*#__PURE__*/ __route({"location_id":{"r":true},"letter_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letters"],[2,[7,"/"],[2,[3,"letter_id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/letter_template(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsLetterTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letter_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/letter_templates(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsLetterTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letter_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/outbound_records/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsOutboundRecordPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"outbound_records"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/outbound_records(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsOutboundRecordsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"outbound_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/practices/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsPracticePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"practices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/practices(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsPracticesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"practices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/providers/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsProviderPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/providers(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationReferralsProvidersPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"providers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/signed_forms/:form_type/:id
 * @param {any} locationId
 * @param {any} formType
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationSignedFormLinkPath = /*#__PURE__*/ __route({"location_id":{"r":true},"form_type":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"signed_forms"],[2,[7,"/"],[2,[3,"form_type"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/site_search
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationSiteSearchPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"site_search"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/sms-opt-in
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationSmsOptInPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"sms-opt-in"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/sms-opt-in-details
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationSmsOptInDetailsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"sms-opt-in-details"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/sms-opt-out
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationSmsOptOutPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"sms-opt-out"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/starred_calls/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationStarredCallPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"starred_calls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/starred_calls(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationStarredCallsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"starred_calls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTaskPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks/:task_id/comments/:id(.:format)
 * @param {any} locationId
 * @param {any} taskId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTaskCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"task_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks/:task_id/comments(.:format)
 * @param {any} locationId
 * @param {any} taskId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTaskCommentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks/:task_id/comments/:comment_id(.:format)
 * @param {any} locationId
 * @param {any} taskId
 * @param {any} commentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTaskDeleteCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"task_id":{"r":true},"comment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"comment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTasksPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/terms-and-conditions
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTermsAndConditionsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"terms-and-conditions"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/time_blocks/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTimeBlockPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"time_blocks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/time_blocks(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTimeBlocksPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"time_blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/training(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTrainingPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"training"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/training/curricula/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTrainingCurriculumPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"training"],[2,[7,"/"],[2,[6,"curricula"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/training/documents/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTrainingDocumentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"training"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/training/videos/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTrainingVideoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"training"],[2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/training/videos/:id/progress(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTrainingVideoProgressPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"training"],[2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"progress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/training/videos/:id/rating(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTrainingVideoRatingPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"training"],[2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rating"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/treatment_agreements/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTreatmentAgreementPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"treatment_agreements"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/treatment_agreements
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTreatmentAgreementsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"treatment_agreements"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/presentations/:id/deck
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTreatmentPresentationDeckPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"deck"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/presentations/:id/drawings
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTreatmentPresentationDrawingsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"drawings"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/presentations/:id/images/:photo_id
 * @param {any} locationId
 * @param {any} id
 * @param {any} photoId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTreatmentPresentationImagePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"photo_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[3,"photo_id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/presentations/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTreatmentPresentationLinkPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/presentations/:id/live
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTreatmentPresentationLivePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"live"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/presentations/:id/videos/:page_id
 * @param {any} locationId
 * @param {any} id
 * @param {any} pageId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationTreatmentPresentationVideoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"page_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[3,"page_id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_carriers/:id/unarchive
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationUnarchiveInsuranceCarrierPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unarchive"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:id/unarchive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationUnarchiveInsurancePlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/unscheduled_services/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationUnscheduledServicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"unscheduled_services"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/unscheduled_services(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationUnscheduledServicesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"unscheduled_services"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_carriers/:id/provenance/preferred_source(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationUpdatePreferredSourceInsuranceCarrierProvenancePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"provenance"],[2,[7,"/"],[2,[6,"preferred_source"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/documents/:patient_id/receipt/:id/verify
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationVerifyDocumentReceiptPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"receipt"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"verify"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/documents/:patient_id/statement/:id/verify
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationVerifyDocumentStatementPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"statement"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"verify"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/signed_forms/:form_type/:id/verify
 * @param {any} locationId
 * @param {any} formType
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationVerifySignedFormLinkPath = /*#__PURE__*/ __route({"location_id":{"r":true},"form_type":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"signed_forms"],[2,[7,"/"],[2,[3,"form_type"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"verify"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/presentations/:id/verify
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationVerifyTreatmentPresentationLinkPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"verify"]]]]]]]]]]);

/**
 * Generates rails route to
 * /pin_sessions/lock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lockPinSessionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pin_sessions"],[2,[7,"/"],[2,[6,"lock"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation/logins(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loginsInternalRcmAutomationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[2,[7,"/"],[2,[6,"logins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pin_sessions/logout_station(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logoutStationPinSessionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pin_sessions"],[2,[7,"/"],[2,[6,"logout_station"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/uploads/:id/mail_campaign(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailCampaignEnterpriseMarketingUploadPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mail_campaign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/custom_codes/office/make_shared
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makeSharedEnterpriseOfficeCustomCodesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"custom_codes"],[2,[7,"/"],[2,[6,"office"],[2,[7,"/"],[6,"make_shared"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/forms/manage_appointment
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manageAppointmentLocationPatientFormsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[6,"manage_appointment"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eligibility_dashboard/manual_check
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manualCheckInternalEligibilityDashboardPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eligibility_dashboard"],[2,[7,"/"],[6,"manual_check"]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_status/manual_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manualCheckInternalEobStatusIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_status"],[2,[7,"/"],[2,[6,"manual_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/pre_auth_dashboard/manual_check
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manualCheckInternalPreAuthDashboardPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"pre_auth_dashboard"],[2,[7,"/"],[6,"manual_check"]]]]]]);

/**
 * Generates rails route to
 * /internal/eligibility_dashboard/manual_check_result
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manualCheckResultInternalEligibilityDashboardPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eligibility_dashboard"],[2,[7,"/"],[6,"manual_check_result"]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_status/manual_check_result(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manualCheckResultInternalEobStatusIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_status"],[2,[7,"/"],[2,[6,"manual_check_result"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/pre_auth_dashboard/manual_check_result
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manualCheckResultInternalPreAuthDashboardPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"pre_auth_dashboard"],[2,[7,"/"],[6,"manual_check_result"]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/uploads/manual_spend(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manualSpendEnterpriseMarketingUploadsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"manual_spend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/uploads/manual_spend_preview(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manualSpendPreviewEnterpriseMarketingUploadsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"manual_spend_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/manual_sync_completed_appointments(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manualSyncCompletedAppointmentsEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"manual_sync_completed_appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/manual_sync_completed_appointments_export_csv(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manualSyncCompletedAppointmentsExportCsvEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"manual_sync_completed_appointments_export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/uploads/:id/mapping(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mappingEnterpriseMarketingUploadPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mapping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/mark_as_sent
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAsSentLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"mark_as_sent"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/mark_as_sent
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAsSentLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"mark_as_sent"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/forms_v2/mark_completed_by_practice
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markCompletedByPracticeLocationPatientFormsV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"forms_v2"],[2,[7,"/"],[6,"mark_completed_by_practice"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/mark_conversation_read(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markConversationReadLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_conversation_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/mark_conversation_read(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markConversationReadRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_conversation_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/content_sync_runs/:id/mark_delivered(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markDeliveredInternalContentSyncRunPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"content_sync_runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_delivered"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/mark_live
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markLiveImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"mark_live"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/mark_live(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markLiveInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_live"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/claim_mailings/:id/mark_mailed
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markMailedRcmServicesClaimMailingPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"claim_mailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"mark_mailed"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/deposit_triage/:id/mark_maybe_for_insurance
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markMaybeForInsuranceRcmServicesDepositTriagePath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"deposit_triage"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"mark_maybe_for_insurance"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/check_in/mark_new_patient_done
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markNewPatientDoneCheckInLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[6,"mark_new_patient_done"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/forms/mark_new_patient_done
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markNewPatientDoneLocationPatientFormsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[6,"mark_new_patient_done"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/deposit_triage/:id/mark_not_insurance
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markNotInsuranceRcmServicesDepositTriagePath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"deposit_triage"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"mark_not_insurance"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/manual_sync/ledger/patients/:patient_id/mark_synced
 * @param {any} accountId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markPatientSyncedEnterpriseManualSyncLedgerPath = /*#__PURE__*/ __route({"account_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"manual_sync"],[2,[7,"/"],[2,[6,"ledger"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"mark_synced"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/manual_sync/ledger/patients/:patient_id/mark_synced
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markPatientSyncedLocationManualSyncLedgerPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"manual_sync"],[2,[7,"/"],[2,[6,"ledger"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[6,"mark_synced"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/mark_practice_response_read(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markPracticeResponseReadRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_practice_response_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/mark_presented
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markPresentedLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"mark_presented"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/medical_claims/:id/mark_printed
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markPrintedLocationPatientMedicalClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"medical_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"mark_printed"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/outbound_records/:id/mark_sent(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markSentLocationReferralsOutboundRecordPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"outbound_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_sent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/mark_unread(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markUnreadLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_unread"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentation_snapshots/:id/markup
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markupLocationPatientTreatmentPresentationSnapshotPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentation_snapshots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"markup"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/live_calls/:id/match_patient
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const matchPatientLocationLiveCallPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"live_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"match_patient"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/materialization_status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const materializationStatusImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"materialization_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/denticon_checkpoints/:id/materialize
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const materializeImplementationImplementationDenticonCheckpointPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"denticon_checkpoints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"materialize"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/materialize_link_snapshot
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const materializeLinkSnapshotImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"materialize_link_snapshot"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/links/:id/snapshots/:snapshot_id/materialize
 * @param {any} id
 * @param {any} snapshotId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const materializeSnapshotInternalLinkPath = /*#__PURE__*/ __route({"id":{"r":true},"snapshot_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[2,[3,"snapshot_id"],[2,[7,"/"],[6,"materialize"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/perio_charts/:id/measurements
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const measurementsLocationPatientPerioChartPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"perio_charts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"measurements"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/medical_eob
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const medicalEobLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"medical_eob"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/medical_lists_plan
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const medicalListsPlanImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"medical_lists_plan"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/medical_lists_plan(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const medicalListsPlanSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"medical_lists_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/medication_names_plan
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const medicationNamesPlanImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"medication_names_plan"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/medication_names_plan(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const medicationNamesPlanSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"medication_names_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammates/members(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membersRcmServicesTeammatesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammates"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/membership_data(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membershipDataEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"membership_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/membership_discount_details(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membershipDiscountDetailsEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"membership_discount_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/membership(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membershipEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"membership"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/membership_included_procedures(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membershipIncludedProceduresEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"membership_included_procedures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/membership_members_drill_down(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membershipMembersDrillDownEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"membership_members_drill_down"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/merge/check
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeCheckLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge"],[2,[7,"/"],[6,"check"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/merge_duplicate
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeDuplicateLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"merge_duplicate"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/merge_duplicate
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeDuplicateRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"merge_duplicate"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/merge(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeInternalAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/merge(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/custom_codes/office/merge_into_shared
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeIntoSharedEnterpriseOfficeCustomCodesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"custom_codes"],[2,[7,"/"],[2,[6,"office"],[2,[7,"/"],[6,"merge_into_shared"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/merge
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"merge"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:id/merge
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeLocationPatientInvoicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"merge"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/merge/revert
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeRevertLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge"],[2,[7,"/"],[6,"revert"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/merge/search
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeSearchLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge"],[2,[7,"/"],[6,"search"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/merge_whole_payment
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeWholePaymentLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"merge_whole_payment"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/merge_whole_payment
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeWholePaymentRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"merge_whole_payment"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:id/mergeable_invoices
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeableInvoicesLocationPatientInvoicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"mergeable_invoices"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/message_templates
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messageTemplatesLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[6,"message_templates"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/migration_status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const migrationStatusImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"migration_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/activity/more(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moreLocationActivityIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"more"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:pre_authorization_id/claim_documentation/mounts/:mount_id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} preAuthorizationId
 * @param {any} mountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mountLocationPatientPreAuthorizationClaimDocumentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"pre_authorization_id":{"r":true},"mount_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"pre_authorization_id"],[2,[7,"/"],[2,[6,"claim_documentation"],[2,[7,"/"],[2,[6,"mounts"],[2,[7,"/"],[3,"mount_id"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/move_account_appointment_category_priority
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moveAccountAppointmentCategoryPriorityImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"move_account_appointment_category_priority"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/confirmation_add_ons/move_add_on
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moveAddOnEnterprisePoliciesConfirmationAddOnsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"confirmation_add_ons"],[2,[7,"/"],[6,"move_add_on"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/appointment_categories/move_category_priority
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moveCategoryPriorityEnterprisePoliciesAppointmentCategoriesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"appointment_categories"],[2,[7,"/"],[6,"move_category_priority"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/appointment_categories/move_category_priority(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moveCategoryPrioritySettingsLocationAppointmentCategoriesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"appointment_categories"],[2,[7,"/"],[2,[6,"move_category_priority"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/documents/:document_id/move_to_deposit
 * @param {any} locationId
 * @param {any} id
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moveDocumentToDepositLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"document_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[6,"move_to_deposit"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/treatment_catalogs/move_item(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moveItemSettingsTreatmentCatalogsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"treatment_catalogs"],[2,[7,"/"],[2,[6,"move_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/pages/move
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const movePagesLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[6,"move"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/:id/move_targets
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moveTargetsLocationPatientTreatmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"move_targets"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_visits/:id/move_to_location(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moveToLocationLocationApiV1PatientTreatmentVisitPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_visits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move_to_location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_visits/:id/move_to_location_options(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moveToLocationOptionsLocationApiV1PatientTreatmentVisitPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_visits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move_to_location_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/move_to_visit
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moveToVisitLocationPatientTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[6,"move_to_visit"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /my_twelve/:account_id/hours
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const myTwelveHoursPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"my_twelve"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"hours"]]]]]]);

/**
 * Generates rails route to
 * /my_twelve/:account_id/practice_attempts/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const myTwelvePracticeAttemptPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"my_twelve"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"practice_attempts"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /my_twelve/:account_id/practice_scenarios/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const myTwelvePracticeScenarioPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"my_twelve"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"practice_scenarios"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /my_twelve/:account_id
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const myTwelveRootPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"my_twelve"],[2,[7,"/"],[3,"account_id"]]]]);

/**
 * Generates rails route to
 * /my_twelve/:account_id/training
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const myTwelveTrainingPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"my_twelve"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"training"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:pre_authorization_id/claim_documentation/narrative
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} preAuthorizationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const narrativeLocationPatientPreAuthorizationClaimDocumentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"pre_authorization_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"pre_authorization_id"],[2,[7,"/"],[2,[6,"claim_documentation"],[2,[7,"/"],[6,"narrative"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:pre_authorization_id/claim_documentation/narrative_notes
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} preAuthorizationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const narrativeNotesLocationPatientPreAuthorizationClaimDocumentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"pre_authorization_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"pre_authorization_id"],[2,[7,"/"],[2,[6,"claim_documentation"],[2,[7,"/"],[6,"narrative_notes"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/navigate_to_visit(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const navigateToVisitEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"navigate_to_visit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/navigate_to_visit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const navigateToVisitReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"navigate_to_visit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/net_collection(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const netCollectionDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"net_collection"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/net_collection(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const netCollectionEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"net_collection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/net_collection_trend(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const netCollectionTrendDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"net_collection_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/net_collection_trend(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const netCollectionTrendEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"net_collection_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/net_production(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const netProductionDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"net_production"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/net_production(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const netProductionEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"net_production"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/net_production_trend(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const netProductionTrendDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"net_production_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/net_production_trend(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const netProductionTrendEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"net_production_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:account_id/members/new(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountAccountUserPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/new_bounced_check
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBouncedCheckLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"new_bounced_check"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/practices/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCredentialingPracticePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"practices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/profiles/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCredentialingProfilePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/new_delete_payment
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newDeletePaymentLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"new_delete_payment"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/knowledge/new(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEnterpriseKnowledgePath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/marketing_tags/new(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEnterpriseMarketingMarketingTagPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"marketing_tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/membership_plans/new(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEnterpriseMembershipPlanPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"membership_plans"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_prompts/new
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEnterprisePoliciesClinicalNotePromptPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"clinical_note_prompts"],[2,[7,"/"],[6,"new"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_templates/new
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEnterprisePoliciesClinicalNoteTemplatePath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[6,"new"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/knowledge/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalKnowledgePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/account/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newKnowledgeAccountPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge/twelve/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newKnowledgeTwelvePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"twelve"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:appointment_id/comments/new(.:format)
 * @param {any} locationId
 * @param {any} appointmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationAppointmentCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"appointment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"appointment_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/dosespot/new
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationDosespotPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"dosespot"],[2,[7,"/"],[6,"new"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/event_logs/:event_log_id/comments/new(.:format)
 * @param {any} locationId
 * @param {any} eventLogId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationEventLogCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"event_log_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"event_logs"],[2,[7,"/"],[2,[3,"event_log_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/feedback/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationFeedbackPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"feedback"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_claims/:insurance_claim_id/comments/new
 * @param {any} locationId
 * @param {any} insuranceClaimId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationInsuranceClaimCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"insurance_claim_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"insurance_claim_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_plans/:insurance_plan_id/comments/new(.:format)
 * @param {any} locationId
 * @param {any} insurancePlanId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationInsurancePlanCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"insurance_plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[3,"insurance_plan_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/lab_cases/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationLabCasePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"lab_cases"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/lab_cases/:lab_case_id/comments/new(.:format)
 * @param {any} locationId
 * @param {any} labCaseId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationLabCaseCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"lab_case_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"lab_cases"],[2,[7,"/"],[2,[3,"lab_case_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/new
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[6,"new"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_verifications/new
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientInsuranceVerificationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_verifications"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:invoice_id/adjustments/new
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} invoiceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientInvoiceAdjustmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"invoice_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_medications/new
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientPatientMedicationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_medications"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_medication_risks/new
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientPatientMedicationRiskPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_medication_risks"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_notes/new
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientPatientNotePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_notes"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/new
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientPatientPaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/:patient_payment_id/reallocation/new
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} patientPaymentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientPatientPaymentReallocationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"patient_payment_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[2,[3,"patient_payment_id"],[2,[7,"/"],[2,[6,"reallocation"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_premedications/new
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientPatientPremedicationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_premedications"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_surgeries/new
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientPatientSurgeryPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_surgeries"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_tobacco_uses/new
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientPatientTobaccoUsePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_tobacco_uses"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_vitals/new
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientPatientVitalPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_vitals"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_links/new
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientPaymentLinkPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_links"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_plans/new
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientPaymentPlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_plans"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/plan_subscription/new
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientPlanSubscriptionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"plan_subscription"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/new
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientTreatmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/:treatment_id/redo/new
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} treatmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationPatientTreatmentRedoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"treatment_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[2,[3,"treatment_id"],[2,[7,"/"],[2,[6,"redo"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/new
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[6,"new"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks/:task_id/comments/new(.:format)
 * @param {any} locationId
 * @param {any} taskId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationTaskCommentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/time_blocks/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationTimeBlockPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"time_blocks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/treatment_agreements/new
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationTreatmentAgreementPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"treatment_agreements"],[2,[7,"/"],[6,"new"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/new_merchant_fee
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMerchantFeeLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"new_merchant_fee"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/new_patients_by_referral_source_data(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPatientsByReferralSourceDataEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"new_patients_by_referral_source_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/new_patients_by_referral_source(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPatientsByReferralSourceEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"new_patients_by_referral_source"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/new_patients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPatientsDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"new_patients"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/new_patients_drill_down(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPatientsDrillDownDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"new_patients_drill_down"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/new_patients_drill_down(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPatientsDrillDownEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"new_patients_drill_down"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/new_patients(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPatientsEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"new_patients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/new_patients_trend(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPatientsTrendDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"new_patients_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/new_patients_trend(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPatientsTrendEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"new_patients_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/new_prepayment
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPrepaymentLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"new_prepayment"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailSourcePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/sent_faxes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRcmServicesSentFaxPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"sent_faxes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/new_refund_from_credit
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRefundFromCreditLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"new_refund_from_credit"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/new_refund
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRefundLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"new_refund"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/appointment_templates/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsAppointmentTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"appointment_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_prompts/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsClinicalNotePromptPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_prompts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_templates/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsClinicalNoteTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/operatories/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsLocationOperatoryPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"operatories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/note_abbreviations/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsNoteAbbreviationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"note_abbreviations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/imports/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsPatientFormImportPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsPatientFormTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/automated_messages/new
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsPhoneMessagingAutomatedMessagePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"automated_messages"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/new_transfer_to_family_member
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTransferToFamilyMemberLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"new_transfer_to_family_member"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scenarios/new
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTwelveTeamScenarioPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[6,"new"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scorecards/new
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTwelveTeamScorecardPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[6,"new"]]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserConfirmationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserPasswordPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserRegistrationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserSessionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/referral_contexts/:id/not_done_yet(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notDoneYetLocationApiV1PatientReferralContextPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"referral_contexts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"not_done_yet"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/inbound_records/:id/not_done_yet(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notDoneYetLocationReferralsInboundRecordPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"inbound_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"not_done_yet"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/ambient_sessions/:id/note_changes(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const noteChangesLocationApiV1AmbientSessionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ambient_sessions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"note_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /odontogram_preference
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const odontogramPreferencePath = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"odontogram_preference"]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bank_transactions/:id/office_conversation
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const officeConversationRcmServicesPostingBankTransactionPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bank_transactions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"office_conversation"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/office_conversation
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const officeConversationRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"office_conversation"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/office_conversation
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const officeConversationRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"office_conversation"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/:id/office_discount
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const officeDiscountLocationPatientTreatmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"office_discount"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/offices
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const officesImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"offices"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/rcm_teammates/onboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboardRcmServicesRcmTeammatesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"rcm_teammates"],[2,[7,"/"],[2,[6,"onboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/operatory_utilization(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const operatoryUtilizationEnterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"operatory_utilization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/original_document
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const originalDocumentLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"original_document"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/original_document
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const originalDocumentRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"original_document"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/oryx_extract_status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oryxExtractStatusImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"oryx_extract_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/other_money_lines
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const otherMoneyLinesLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"other_money_lines"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/other_money_lines
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const otherMoneyLinesLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"other_money_lines"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/other_money_lines
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const otherMoneyLinesRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"other_money_lines"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/other_money_lines
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const otherMoneyLinesRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"other_money_lines"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/reports/otto_over_time
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ottoOverTimeRcmServicesReportsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[6,"otto_over_time"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/reports/otto
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ottoRcmServicesReportsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[6,"otto"]]]]]]);

/**
 * Generates rails route to
 * /carrier_calling/ai/assignment/outcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const outcomeCarrierCallingAiAssignmentPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"assignment"],[2,[7,"/"],[2,[6,"outcome"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /carrier_calling/assignment/outcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const outcomeCarrierCallingAssignmentPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[2,[7,"/"],[2,[6,"assignment"],[2,[7,"/"],[2,[6,"outcome"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /carrier_calling/verifier/assignment/outcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const outcomeCarrierCallingVerifierAssignmentPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[2,[7,"/"],[2,[6,"verifier"],[2,[7,"/"],[2,[6,"assignment"],[2,[7,"/"],[2,[6,"outcome"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/override_medical_hold
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overrideMedicalHoldLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"override_medical_hold"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/office_hours/overrides/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overrideSettingsLocationOfficeHoursPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"office_hours"],[2,[7,"/"],[2,[6,"overrides"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/overview/custom_fields
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overviewCustomFieldsLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[6,"custom_fields"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_ar_dashboard/overview(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overviewEnterprisePatientArDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_ar_dashboard"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/overview/patient_search
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overviewPatientSearchLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[6,"patient_search"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/overview/profile
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overviewProfileLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[6,"profile"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/overview/settings
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overviewSettingsLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[6,"settings"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/owners_drill(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ownersDrillEnterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"owners_drill"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/owners(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ownersEnterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"owners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/profiles/:id/packet(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packetCredentialingProfilePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"packet"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/panel(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const panelLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"panel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/panel
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const panelLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"panel"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/fee_schedules/:id/parse_import
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parseImportLocationFeeSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"fee_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"parse_import"]]]]]]]]]]);

/**
 * Generates rails route to
 * /c/:token
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientConfirmationPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[3,"token"]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/patient_links
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientLinksLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[6,"patient_links"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/premedication(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInAnswerPremedicationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"premedication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/card_on_file(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInCardOnFilePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"card_on_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/card_on_file/success(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInCardOnFileSuccessPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"card_on_file"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/payment/card_on_file/charge(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInChargeCardOnFilePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"payment"],[2,[7,"/"],[2,[6,"card_on_file"],[2,[7,"/"],[2,[6,"charge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/confirm_contact_info(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInConfirmContactInfoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"confirm_contact_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/payment(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInPaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/payment/card_on_file(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInPaymentCardOnFilePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"payment"],[2,[7,"/"],[2,[6,"card_on_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/payment/front_desk(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInPaymentFrontDeskPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"payment"],[2,[7,"/"],[2,[6,"front_desk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/payment/success(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInPaymentSuccessPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"payment"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/payment/wallet
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInPaymentWalletPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"payment"],[2,[7,"/"],[6,"wallet"]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/profile_picture(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInProfilePicturePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"profile_picture"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/agreement(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInSaveAgreementPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"agreement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/form(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInSaveFormPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/profile_picture(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInSaveProfilePicturePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"profile_picture"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/card_on_file/skip(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInSkipCardOnFilePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"card_on_file"],[2,[7,"/"],[2,[6,"skip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/profile_picture/skip(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInSkipProfilePicturePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"profile_picture"],[2,[7,"/"],[2,[6,"skip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/check_in/card_on_file/start
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalCheckInStartCardOnFilePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"card_on_file"],[2,[7,"/"],[6,"start"]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/forms(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalFormsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/login(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalLoginPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/logout(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalLogoutPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/payment_plan_agreement(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalPaymentPlanAgreementPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"payment_plan_agreement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalRootPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/forms/agreement(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalSaveAgreementPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"agreement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/forms/form(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalSaveFormPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/forms/payment_plan_agreement(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalSavePaymentPlanAgreementPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"payment_plan_agreement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /patient/:location_id/treatment_agreement(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientPortalTreatmentAgreementPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"treatment_agreement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/records_releases/patient_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientSearchInternalRecordsReleasesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"records_releases"],[2,[7,"/"],[2,[6,"patient_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/xray_mounts/patients_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const patientsSearchApiV1XrayMountsPath = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"xray_mounts"],[2,[7,"/"],[2,[6,"patients_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/:id/pause(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pauseEnterpriseAgentPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/text_agent/pause
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pauseSettingsPhoneMessagingTextAgentPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"text_agent"],[2,[7,"/"],[6,"pause"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pay/create_intent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payCreateIntentPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pay"],[2,[7,"/"],[2,[6,"create_intent"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pay/patient/:patient_id/balance(.:format)
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payPatientBalancePath = /*#__PURE__*/ __route({"patient_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pay"],[2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"balance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pay/patient/:patient_id/family_balance(.:format)
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payPatientFamilyBalancePath = /*#__PURE__*/ __route({"patient_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pay"],[2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"family_balance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pay/patient/:patient_id/family_balance_credited(.:format)
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payPatientFamilyBalanceCreditedPath = /*#__PURE__*/ __route({"patient_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pay"],[2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"family_balance_credited"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pay/patient/:patient_id/wallet(.:format)
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payPatientWalletPath = /*#__PURE__*/ __route({"patient_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pay"],[2,[7,"/"],[2,[6,"patient"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"wallet"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/calls/payers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payersCredentialingCallsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"payers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/payments_data(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentsDataEnterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"payments_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/payments_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentsDataReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"payments_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/payments(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentsEnterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentsReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/desktop/external_letters/:id/pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pdfApiV1DesktopExternalLetterPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"desktop"],[2,[7,"/"],[2,[6,"external_letters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/external_letters/:id/pdf
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pdfLocationReferralsExternalLetterPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"external_letters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"pdf"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/clinical_photos/:id/pearl_annotations(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pearlAnnotationsLocationApiV1ClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pearl_annotations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/clinical_photos/pending_slot_labels(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pendingSlotLabelsLocationApiV1PatientClinicalPhotosPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[6,"pending_slot_labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_ar_dashboard/performance(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const performanceEnterprisePatientArDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_ar_dashboard"],[2,[7,"/"],[2,[6,"performance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/desktop/external_letters/:id/perio(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const perioApiV1DesktopExternalLetterPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"desktop"],[2,[7,"/"],[2,[6,"external_letters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"perio"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:pre_authorization_id/claim_documentation/perio_charts/:chart_id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} preAuthorizationId
 * @param {any} chartId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const perioChartLocationPatientPreAuthorizationClaimDocumentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"pre_authorization_id":{"r":true},"chart_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"pre_authorization_id"],[2,[7,"/"],[2,[6,"claim_documentation"],[2,[7,"/"],[2,[6,"perio_charts"],[2,[7,"/"],[3,"chart_id"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/roles/permission_explorer(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const permissionExplorerEnterpriseRolesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"permission_explorer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /phone-service/:token
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phoneBreakdownPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"phone-service"],[2,[7,"/"],[3,"token"]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/goto/phone_number
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phoneNumberSettingsPhoneMessagingGotoPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"goto"],[2,[7,"/"],[6,"phone_number"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/desktop/external_letters/:id/photos/:photo_id(.:format)
 * @param {any} id
 * @param {any} photoId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const photoApiV1DesktopExternalLetterPath = /*#__PURE__*/ __route({"id":{"r":true},"photo_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"desktop"],[2,[7,"/"],[2,[6,"external_letters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"photos"],[2,[7,"/"],[2,[3,"photo_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/pick_up(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pickUpRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pick_up"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/picker_options
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pickerOptionsLocationPatientTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[6,"picker_options"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/pictures/:photo_id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {any} photoId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pictureLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"photo_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pictures"],[2,[7,"/"],[3,"photo_id"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/pin(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pinLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_notes/:id/pin
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pinLocationPatientPatientNotePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"pin"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_premedications/:id/pin
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pinLocationPatientPatientPremedicationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_premedications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"pin"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pin_sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pinSessionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pin_sessions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/pinned_appointments(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pinnedAppointmentsLocationAppointmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"pinned_appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_ar_dashboard/pipeline(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pipelineEnterprisePatientArDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_ar_dashboard"],[2,[7,"/"],[2,[6,"pipeline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_plans/:id/plan_trip(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planTripInternalGoLivePlanPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"plan_trip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/polish_send_remark(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const polishSendRemarkRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"polish_send_remark"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_methods/poll
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pollLocationPatientPaymentMethodsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[6,"poll"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/live_calls/pops_preference
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const popsPreferenceLocationLiveCallsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"live_calls"],[2,[7,"/"],[6,"pops_preference"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/plan_evidence/:id/portal_pdf
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portalPdfRcmServicesPlanEvidencePath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"plan_evidence"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"portal_pdf"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/plan_evidence/:id/portal_screenshot
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portalScreenshotRcmServicesPlanEvidencePath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"plan_evidence"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"portal_screenshot"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation/portal_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portalSetupInternalRcmAutomationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[2,[7,"/"],[2,[6,"portal_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/post_conversation_message(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postConversationMessageLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"post_conversation_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/post_conversation_message(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postConversationMessageRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"post_conversation_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/overview/practice_details
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const practiceDetailsImplementationImplementationOverviewPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[6,"practice_details"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/:id/pre_auth
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preAuthLocationPatientTreatmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"pre_auth"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/ai_outreach/preferences(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preferencesSettingsAiOutreachIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ai_outreach"],[2,[7,"/"],[2,[6,"preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/demos/prepare_delta_dental_eob_1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prepareDeltaDentalEob1InternalDemosPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[6,"prepare_delta_dental_eob_1"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/dosespot/prescriptions
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prescriptionsLocationDosespotPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"dosespot"],[2,[7,"/"],[6,"prescriptions"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/present
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presentLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"present"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/holds/preview
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewCredentialingHoldsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"holds"],[2,[7,"/"],[6,"preview"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/preview_email
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewEmailLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[6,"preview_email"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/message_templates/preview_email_template
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewEmailTemplateSettingsPhoneMessagingMessageTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"message_templates"],[2,[7,"/"],[6,"preview_email_template"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/artifacts/:id/preview(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewEnterpriseAgentArtifactPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/treatment_agreements/preview
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewEnterprisePoliciesTreatmentAgreementsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"treatment_agreements"],[2,[7,"/"],[6,"preview"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/accounts/:account_id/prices/preview
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewInternalBillingAccountPricesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"prices"],[2,[7,"/"],[6,"preview"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/form_templates/:id/preview
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewLocationPatientFormTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"form_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"preview"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_benefit_adjustments/preview
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewLocationPatientInsuranceBenefitAdjustmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_benefit_adjustments"],[2,[7,"/"],[6,"preview"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/treatment_agreements/preview
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewLocationTreatmentAgreementsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"treatment_agreements"],[2,[7,"/"],[6,"preview"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/automated_messages/preview
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewSettingsPhoneMessagingAutomatedMessagesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"automated_messages"],[2,[7,"/"],[6,"preview"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/message_templates/preview
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewSettingsPhoneMessagingMessageTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"message_templates"],[2,[7,"/"],[6,"preview"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/claim_documentation/print(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printClaimDocumentationLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim_documentation"],[2,[7,"/"],[2,[6,"print"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/print_family_statement
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printFamilyStatementLocationPatientInvoicesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[6,"print_family_statement"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/print_ledger_statement
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printLedgerStatementLocationPatientInvoicesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[6,"print_ledger_statement"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/agreements/:id/print
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printLocationPatientAgreementPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"agreements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"print"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_photos/:id/print
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printLocationPatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"print"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/:id/print
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printLocationPatientPatientPaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"print"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/perio_charts/:id/print
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printLocationPatientPerioChartPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"perio_charts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"print"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/dosespot/print_manual
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printManualLocationDosespotPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"dosespot"],[2,[7,"/"],[6,"print_manual"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/dosespot/print_manual_pdf
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printManualPdfLocationDosespotPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"dosespot"],[2,[7,"/"],[6,"print_manual_pdf"]]]]]]]]);

/**
 * Generates rails route to
 * /my_twelve/:account_id/hours/print
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printMyTwelveHoursPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"my_twelve"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"hours"],[2,[7,"/"],[6,"print"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/periodontal_charts/:id/print_options
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printOptionsLocationPatientPeriodontalChartPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"periodontal_charts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"print_options"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/print_partial_plan
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printPartialPlanLocationPatientTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[6,"print_partial_plan"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/forms/:id/print_proof
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printProofLocationPatientFormPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"print_proof"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/lab_cases/:id/print_slip
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printSlipLocationLabCasePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"lab_cases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"print_slip"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/lab_cases/:id/print_slip_modal(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printSlipModalLocationLabCasePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"lab_cases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"print_slip_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:id/print_statement
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printStatementLocationPatientInvoicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"print_statement"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/print_statements
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printStatementsLocationPatientInvoicesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[6,"print_statements"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/print_statements_modal
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const printStatementsModalLocationPatientInvoicesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[6,"print_statements_modal"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /privacy_policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacyPolicyPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"privacy_policy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/procedure_code_analysis_data(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const procedureCodeAnalysisDataEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"procedure_code_analysis_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/procedure_code_analysis_detail(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const procedureCodeAnalysisDetailEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"procedure_code_analysis_detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/procedure_code_analysis(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const procedureCodeAnalysisEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"procedure_code_analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/procedure_code_analysis_presentation_detail(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const procedureCodeAnalysisPresentationDetailEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"procedure_code_analysis_presentation_detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/procedures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proceduresDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"procedures"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/procedures(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proceduresEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"procedures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/procedures_trend(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proceduresTrendDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"procedures_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/procedures_trend(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proceduresTrendEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"procedures_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/perio_charts/:id/process_transcripts
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processTranscriptsLocationPatientPerioChartPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"perio_charts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"process_transcripts"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/production_and_collection(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productionAndCollectionEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"production_and_collection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /central/:account_id/rcm/dashboard/production_breakdown
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productionBreakdownCentralRcmDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"production_breakdown"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/overview_cards/production_breakdown(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productionBreakdownEnterpriseOverviewCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"overview_cards"],[2,[7,"/"],[2,[6,"production_breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/dashboard/production_breakdown
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productionBreakdownLocationRcmDashboardIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"production_breakdown"]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/production_chart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productionChartDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"production_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/production_chart(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productionChartEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"production_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /central/:account_id/rcm/dashboard/production_collection_row
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productionCollectionRowCentralRcmDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"production_collection_row"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/dashboard/production_collection_row
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productionCollectionRowLocationRcmDashboardIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"production_collection_row"]]]]]]]]]]);

/**
 * Generates rails route to
 * /central/:account_id/rcm/dashboard/production_collections
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productionCollectionsCentralRcmDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"production_collections"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/dashboard/production_collections
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productionCollectionsLocationRcmDashboardIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"production_collections"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/production(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productionEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"production"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/production_leaderboard(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productionLeaderboardEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"production_leaderboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/production_records(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productionRecordsLocationAppointmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"production_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/production_validation_status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productionValidationStatusImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"production_validation_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammates/:id/profile(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profileRcmServicesTeammatePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/lab_cases/:id/progress_log(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const progressLogLocationLabCasePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"lab_cases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"progress_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammates/:id/progress(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const progressRcmServicesTeammatePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"progress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_videos/:training_video_id/versions/:id/promote(.:format)
 * @param {any} trainingVideoId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const promoteInternalTrainingVideoVersionPath = /*#__PURE__*/ __route({"training_video_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_videos"],[2,[7,"/"],[2,[3,"training_video_id"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"promote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/xray_mounts/:id/promote_stack_photo(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const promoteStackPhotoApiV1XrayMountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"xray_mounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"promote_stack_photo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/clinical_photos/:id/promote_stack_photo(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const promoteStackPhotoLocationApiV1PatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"promote_stack_photo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/provider(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const providerEnterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"provider"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/provider_payout(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const providerPayoutEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"provider_payout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/provider_report_pdf(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const providerReportPdfLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"provider_report_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/provider_report_perio_image(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const providerReportPerioImageLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"provider_report_perio_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/provider_report_seed(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const providerReportSeedLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"provider_report_seed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/provider_report_xrays(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const providerReportXraysLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"provider_report_xrays"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/provider(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const providerReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"provider"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/inbound_numbers/:id/provision(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const provisionRcmServicesSoftphoneAdminInboundNumberPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"inbound_numbers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"provision"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /medications
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publicMedicationListPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"medications"]]);

/**
 * Generates rails route to
 * /referral-letter/:token
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publicReferralLetterPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"referral-letter"],[2,[7,"/"],[3,"token"]]]]);

/**
 * Generates rails route to
 * /referral-letter/:token/download
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publicReferralLetterDownloadPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"referral-letter"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[6,"download"]]]]]]);

/**
 * Generates rails route to
 * /referral-letter/:token/images/:position
 * @param {any} token
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publicReferralLetterImagePath = /*#__PURE__*/ __route({"token":{"r":true},"position":{"r":true}}, [2,[7,"/"],[2,[6,"referral-letter"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[3,"position"]]]]]]]]);

/**
 * Generates rails route to
 * /referral-letter/:token/pages/:page
 * @param {any} token
 * @param {any} page
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publicReferralLetterPagePath = /*#__PURE__*/ __route({"token":{"r":true},"page":{"r":true}}, [2,[7,"/"],[2,[6,"referral-letter"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[3,"page"]]]]]]]]);

/**
 * Generates rails route to
 * /referral-letter/:token/report
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publicReferralLetterReportPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"referral-letter"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[6,"report"]]]]]]);

/**
 * Generates rails route to
 * /referral-letter/:token/view
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publicReferralLetterViewPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"referral-letter"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[6,"view"]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/letter_template/publish(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publishEnterpriseReferralsLetterTemplatePath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letter_template"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/letter_template/publish(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publishLocationReferralsLetterTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letter_template"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/pull_clinician_roles
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pullClinicianRolesInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"pull_clinician_roles"]]]]]]);

/**
 * Generates rails route to
 * /internal/providers/:id/pull_dosespot_demographics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pullDosespotDemographicsInternalProviderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pull_dosespot_demographics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/providers/:id/push_dosespot_demographics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pushDosespotDemographicsInternalProviderPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"push_dosespot_demographics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /manifest.webmanifest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwaManifestPath = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manifest"],[2,[8,"."],[2,[6,"webmanifest"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/files_v2/qr_code
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const qrCodeLocationPatientFilesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"files_v2"],[2,[7,"/"],[6,"qr_code"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/treatment_agreements/qr_code_new_link.:format
 * @param {any} locationId
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const qrCodeNewLinkLocationTreatmentAgreementsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"treatment_agreements"],[2,[7,"/"],[2,[6,"qr_code_new_link"],[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/qr
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const qrLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"qr"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation/queue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const queueInternalRcmAutomationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[2,[7,"/"],[2,[6,"queue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationPath = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationProxyPath = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailIncineratePath = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailReroutePath = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailSourcesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDirectUploadsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encodedKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDiskServicePath = /*#__PURE__*/ __route({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsHealthCheckPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMailgunInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundHealthCheckPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsPostmarkInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsRelayInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsSendgridInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobPath = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobProxyPath = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/rcm_claims_aging_data(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmClaimsAgingDataEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"rcm_claims_aging_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/rcm_claims_aging_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmClaimsAgingDataReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"rcm_claims_aging_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/rcm_claims_waterfall_data(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmClaimsWaterfallDataEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"rcm_claims_waterfall_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/rcm_claims_waterfall_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmClaimsWaterfallDataReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"rcm_claims_waterfall_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/rcm_combined_patient_aging_data(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmCombinedPatientAgingDataEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"rcm_combined_patient_aging_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/rcm_combined_patient_aging_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmCombinedPatientAgingDataReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"rcm_combined_patient_aging_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/rcm_conversation_message
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmConversationMessageLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"rcm_conversation_message"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_import_monitor/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_import_monitor"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/bank_transaction_patterns/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesBankTransactionPatternPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"bank_transaction_patterns"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/bank_transaction_patterns
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesBankTransactionPatternsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[6,"bank_transaction_patterns"]]]]);

/**
 * Generates rails route to
 * /rcm_services/calls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCallPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/call_audits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCallAuditPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"call_audits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/call_audits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCallAuditsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"call_audits"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/calls/:call_id/items/:id(.:format)
 * @param {any} callId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCallItemPath = /*#__PURE__*/ __route({"call_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[3,"call_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/calls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCallsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"calls"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/capacity
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCapacityPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[6,"capacity"]]]]);

/**
 * Generates rails route to
 * /rcm_services/capacity/assumptions
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCapacityAssumptionsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"capacity"],[2,[7,"/"],[6,"assumptions"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/capacity/handle_times/:kind
 * @param {any} kind
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCapacityHandleTimePath = /*#__PURE__*/ __route({"kind":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"capacity"],[2,[7,"/"],[2,[6,"handle_times"],[2,[7,"/"],[3,"kind"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/capacity/practices/:location_id
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCapacityPracticeOverridePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"capacity"],[2,[7,"/"],[2,[6,"practices"],[2,[7,"/"],[3,"location_id"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/capacity/scenarios/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCapacityScenarioPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"capacity"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/capacity/scenarios
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCapacityScenariosPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"capacity"],[2,[7,"/"],[6,"scenarios"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/capacity/team/:user_id
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCapacityTeamInclusionPath = /*#__PURE__*/ __route({"user_id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"capacity"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[3,"user_id"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/claim_completeness(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesClaimCompletenessIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"claim_completeness"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/claim_mailings
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesClaimMailingsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[6,"claim_mailings"]]]]);

/**
 * Generates rails route to
 * /rcm_services/claims
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesClaimsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[6,"claims"]]]]);

/**
 * Generates rails route to
 * /rcm_services/collection_health
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCollectionHealthPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[6,"collection_health"]]]]);

/**
 * Generates rails route to
 * /rcm_services/collection_health/:location_id/cohort
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCollectionHealthCohortPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"collection_health"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[6,"cohort"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/collection_health/:location_id
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCollectionHealthLocationPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"collection_health"],[2,[7,"/"],[3,"location_id"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/collection_health/uncollected
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCollectionHealthUncollectedPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"collection_health"],[2,[7,"/"],[6,"uncollected"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/collections/:collection_id/review_notes(.:format)
 * @param {any} collectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCollectionReviewNotesPath = /*#__PURE__*/ __route({"collection_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"collections"],[2,[7,"/"],[2,[3,"collection_id"],[2,[7,"/"],[2,[6,"review_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/collections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCollectionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"collections"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/collections_agency
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesCollectionsAgencyPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[6,"collections_agency"]]]]);

/**
 * Generates rails route to
 * /rcm_services/disposition_framework
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesDispositionFrameworkIndexPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[6,"disposition_framework"]]]]);

/**
 * Generates rails route to
 * /rcm_services/faxes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesFaxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"faxes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/fax_admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesFaxAdminPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"fax_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/faxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesFaxesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"faxes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbound_call_audits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesInboundCallAuditPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbound_call_audits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbound_call_audits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesInboundCallAuditsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbound_call_audits"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesInboxIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_import_monitor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesInsuranceImportMonitorPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_import_monitor"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_plan_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesInsurancePlanSettingsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_plan_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_verifications
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesInsuranceVerificationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[6,"insurance_verifications"]]]]);

/**
 * Generates rails route to
 * /rcm_services/my_calls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesMyCallPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"my_calls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/my_calls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesMyCallsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"my_calls"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/otto
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesOttoRunsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[6,"otto"]]]]);

/**
 * Generates rails route to
 * /rcm_services/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesOverviewPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/patients/:patient_id/call_item_options(.:format)
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesPatientCallItemOptionsPath = /*#__PURE__*/ __route({"patient_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"call_item_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/personal_performance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesPersonalPerformanceIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"personal_performance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesPostingPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[6,"posting"]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bank_transactions/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesPostingBankTransactionPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bank_transactions"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bank_transactions
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesPostingBankTransactionsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[6,"bank_transactions"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesPostingBulkDepositsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[6,"bulk_deposits"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesPostingPaymentsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[6,"payments"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/practice_review/sla_bucket_claims
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesPracticeReviewSlaBucketClaimsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"practice_review"],[2,[7,"/"],[6,"sla_bucket_claims"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/practice_review(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesPracticeReviewsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"practice_review"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/rcm_ai_models(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesRcmAiModelsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"rcm_ai_models"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/rcm_team(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesRcmTeamPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"rcm_team"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/rcm_team/assign_unassigned(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesRcmTeamAssignUnassignedPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"rcm_team"],[2,[7,"/"],[2,[6,"assign_unassigned"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/rcm_team/board(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesRcmTeamBoardPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"rcm_team"],[2,[7,"/"],[2,[6,"board"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/rcm_team/unassigned_summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesRcmTeamUnassignedSummaryPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"rcm_team"],[2,[7,"/"],[2,[6,"unassigned_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/rcm_team/update_cell(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesRcmTeamUpdateCellPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"rcm_team"],[2,[7,"/"],[2,[6,"update_cell"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/rcm_teammates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesRcmTeammatePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"rcm_teammates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/rcm_teammates/:rcm_teammate_id/account_memberships/:id(.:format)
 * @param {any} rcmTeammateId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesRcmTeammateAccountMembershipPath = /*#__PURE__*/ __route({"rcm_teammate_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"rcm_teammates"],[2,[7,"/"],[2,[3,"rcm_teammate_id"],[2,[7,"/"],[2,[6,"account_memberships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/rcm_teammates/:rcm_teammate_id/account_memberships(.:format)
 * @param {any} rcmTeammateId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesRcmTeammateAccountMembershipsPath = /*#__PURE__*/ __route({"rcm_teammate_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"rcm_teammates"],[2,[7,"/"],[2,[3,"rcm_teammate_id"],[2,[7,"/"],[2,[6,"account_memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/rcm_teammates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesRcmTeammatesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"rcm_teammates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/reports
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesReportsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[6,"reports"]]]]);

/**
 * Generates rails route to
 * /rcm_services/reports/collections_report_card(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesReportsCollectionsReportCardPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"collections_report_card"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/reports/rcm_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesReportsRcmDashboardPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"rcm_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/review_notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesReviewNotePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"review_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/role_goals/:rcm_role(.:format)
 * @param {any} rcmRole
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesRoleGoalPath = /*#__PURE__*/ __route({"rcm_role":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"role_goals"],[2,[7,"/"],[2,[3,"rcm_role"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/role_goals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesRoleGoalsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"role_goals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesRootPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rcm_services/sent_faxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSentFaxesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"sent_faxes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/snail_mail
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSnailMailPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[6,"snail_mail"]]]]);

/**
 * Generates rails route to
 * /rcm_services/snail_mail/extract_address
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSnailMailExtractAddressPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"snail_mail"],[2,[7,"/"],[6,"extract_address"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/snail_mail/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSnailMailLetterPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"snail_mail"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/snail_mail/:id/pdf
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSnailMailPdfPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"snail_mail"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"pdf"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/ai_calling_carriers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSoftphoneAdminAiCallingCarriersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"ai_calling_carriers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/ai_carrier_calls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSoftphoneAdminAiCarrierCallPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"ai_carrier_calls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/ai_carrier_calls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSoftphoneAdminAiCarrierCallsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"ai_carrier_calls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/ai_claim_calls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSoftphoneAdminAiClaimCallPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"ai_claim_calls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/ai_claim_calls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSoftphoneAdminAiClaimCallsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"ai_claim_calls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/ai_numbers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSoftphoneAdminAiNumbersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"ai_numbers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSoftphoneAdminAnalyticsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/caller_ids/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSoftphoneAdminCallerIdPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"caller_ids"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/caller_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSoftphoneAdminCallerIdsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"caller_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/carrier_numbers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSoftphoneAdminCarrierNumbersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"carrier_numbers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/inbound_numbers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSoftphoneAdminInboundNumberPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"inbound_numbers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/inbound_numbers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSoftphoneAdminInboundNumbersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"inbound_numbers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin/no_call_carriers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSoftphoneAdminNoCallCarriersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[2,[7,"/"],[2,[6,"no_call_carriers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/softphone_admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesSoftphoneAdminRootPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"softphone_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/task_routing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesTaskRoutingPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"task_routing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammate_review
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesTeammateReviewPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[6,"teammate_review"]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammate_review/verification_activity
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesTeammateReviewVerificationActivityPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammate_review"],[2,[7,"/"],[6,"verification_activity"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammate_review/work
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesTeammateReviewWorkPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammate_review"],[2,[7,"/"],[6,"work"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesTeammatesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/training(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesTrainingPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"training"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/training/curricula/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesTrainingCurriculumPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"training"],[2,[7,"/"],[2,[6,"curricula"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/training/documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesTrainingDocumentPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"training"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/training/videos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesTrainingVideoPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"training"],[2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/training/videos/:id/progress(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesTrainingVideoProgressPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"training"],[2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"progress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/training/videos/:id/rating(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesTrainingVideoRatingPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"training"],[2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rating"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/voice_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rcmServicesVoiceTokenPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"voice_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/read
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const readLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"read"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/readiness_check
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const readinessCheckImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"readiness_check"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/ready(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const readyLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ready"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/clinical_photos/:id/reanalyze_pearl(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reanalyzePearlLocationApiV1ClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reanalyze_pearl"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/reapply_snapshot_errors
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reapplySnapshotErrorsImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"reapply_snapshot_errors"]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/reappointment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reappointmentDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"reappointment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/reappointment_drill_down(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reappointmentDrillDownDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"reappointment_drill_down"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/reappointment_drill_down(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reappointmentDrillDownEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"reappointment_drill_down"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/reappointment(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reappointmentEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"reappointment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/reappointment_trend(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reappointmentTrendDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"reappointment_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/reappointment_trend(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reappointmentTrendEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"reappointment_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/reason
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reasonLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"reason"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:appointment_id/operatory_wait/reassign
 * @param {any} locationId
 * @param {any} appointmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reassignLocationAppointmentOperatoryWaitPath = /*#__PURE__*/ __route({"location_id":{"r":true},"appointment_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"appointment_id"],[2,[7,"/"],[2,[6,"operatory_wait"],[2,[7,"/"],[6,"reassign"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/reassign(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reassignLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reassign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/reassign(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reassignRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reassign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_verifications/reassign
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reassignRcmServicesInsuranceVerificationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_verifications"],[2,[7,"/"],[6,"reassign"]]]]]]);

/**
 * Generates rails route to
 * /reauthenticate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reauthenticatePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reauthenticate"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/goto/reauthenticate
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reauthenticateSettingsPhoneMessagingGotoPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"goto"],[2,[7,"/"],[6,"reauthenticate"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/recalculate_estimates
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recalculateEstimatesLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"recalculate_estimates"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/recalculate_insurance
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recalculateInsuranceLocationPatientOdontogramPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[6,"recalculate_insurance"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/recall_settings
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recallSettingsLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"recall_settings"]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/applications/:id/receipts/:document_id(.:format)
 * @param {any} id
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receiptCredentialingApplicationPath = /*#__PURE__*/ __route({"id":{"r":true},"document_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"receipts"],[2,[7,"/"],[2,[3,"document_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/revenue/receipts
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receiptsInternalRevenuePath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"revenue"],[2,[7,"/"],[6,"receipts"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/receive
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receiveLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"receive"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/action_requests/:id/recheck(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recheckAiActionRequestPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"action_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"recheck"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/bank_accounts/:id/reconnected
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reconnectedEnterpriseBankAccountPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"bank_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"reconnected"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/referral_contexts/:id/record_outcome(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recordOutcomeLocationApiV1PatientReferralContextPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"referral_contexts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"record_outcome"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/outbound_records/:id/record_outcome(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recordOutcomeLocationReferralsOutboundRecordPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"outbound_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"record_outcome"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/verification_api_requests/:id/redirect_to_patient(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const redirectToPatientInternalVerificationApiRequestPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"verification_api_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"redirect_to_patient"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/referral_contexts/refer_out_defaults(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referOutDefaultsLocationApiV1PatientReferralContextsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"referral_contexts"],[2,[7,"/"],[2,[6,"refer_out_defaults"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/referral_contexts/refer_out(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referOutLocationApiV1PatientReferralContextsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"referral_contexts"],[2,[7,"/"],[2,[6,"refer_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/referrals_data(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referralsDataEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"referrals_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/referrals_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referralsDataReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"referrals_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/referrals_details(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referralsDetailsEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"referrals_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/referrals_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referralsDetailsReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"referrals_details"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/referrals(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referralsEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"referrals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/referrals_export_csv(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referralsExportCsvEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"referrals_export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/referrals_export_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referralsExportCsvReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"referrals_export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/referrals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referralsReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"referrals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai/action_requests/:id/refine(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refineAiActionRequestPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"action_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refine"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/refresh_office_phone_lines
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshOfficePhoneLinesInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"refresh_office_phone_lines"]]]]]]);

/**
 * Generates rails route to
 * /patients/:id/refresh_panel_appointments
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshPanelAppointmentsPatientPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"refresh_panel_appointments"]]]]]]);

/**
 * Generates rails route to
 * /patients/:id/refresh_panel_briefing
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshPanelBriefingPatientPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"refresh_panel_briefing"]]]]]]);

/**
 * Generates rails route to
 * /patients/:id/refresh_panel_clinical_banner
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshPanelClinicalBannerPatientPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"refresh_panel_clinical_banner"]]]]]]);

/**
 * Generates rails route to
 * /patients/:id/refresh_panel_info
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshPanelInfoPatientPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"refresh_panel_info"]]]]]]);

/**
 * Generates rails route to
 * /patients/:id/refresh_panel_messaging
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshPanelMessagingPatientPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"refresh_panel_messaging"]]]]]]);

/**
 * Generates rails route to
 * /patients/:id/refresh_panel_workflow
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshPanelWorkflowPatientPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"refresh_panel_workflow"]]]]]]);

/**
 * Generates rails route to
 * /refresh_session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshSessionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"refresh_session"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /patients/:id/refresh_verification_icons
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshVerificationIconsPatientPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"refresh_verification_icons"]]]]]]);

/**
 * Generates rails route to
 * /internal/training_videos/:id/regenerate_ai(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerateAiInternalTrainingVideoPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"regenerate_ai"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/links/:id/regenerate_code
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerateCodeInternalLinkPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"regenerate_code"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/connected_apps/:id/regenerate
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerateEnterpriseConnectedAppPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"connected_apps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"regenerate"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/provider_requests/:id/reject(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectInternalProviderRequestPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"provider_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/ambient_patient_note_candidates/:id/reject(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectLocationApiV1AmbientPatientNoteCandidatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ambient_patient_note_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_plans/:id/reject(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectLocationApiV1PatientTreatmentPlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/reject_spam_scheduling_request(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectSpamSchedulingRequestLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject_spam_scheduling_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/denticon_checkpoints/release
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const releaseImplementationImplementationDenticonCheckpointsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"denticon_checkpoints"],[2,[7,"/"],[6,"release"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/removal_credit_returns
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removalCreditReturnsLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"removal_credit_returns"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/removal_credit_returns
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removalCreditReturnsRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"removal_credit_returns"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/treatments/remove_adjustments
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeAdjustmentsLocationPatientOdontogramTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[6,"remove_adjustments"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/remove_attachment_upload
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeAttachmentUploadLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"remove_attachment_upload"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/remove_attachment_upload
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeAttachmentUploadLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"remove_attachment_upload"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/remove_attachment_upload(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeAttachmentUploadRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_attachment_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/appointments/broken/:broken_appointment_id
 * @param {any} locationId
 * @param {any} id
 * @param {any} brokenAppointmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeBrokenAppointmentLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"broken_appointment_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"broken"],[2,[7,"/"],[3,"broken_appointment_id"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/remove_browser_line
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeBrowserLineInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"remove_browser_line"]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/remove_clinician
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeClinicianInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"remove_clinician"]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/ai_receptionist/:id/remove_closure_notice(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeClosureNoticeEnterpriseAiReceptionistPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"ai_receptionist"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_closure_notice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_alerts/:kind/:alert_id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} kind
 * @param {any} alertId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeLocationPatientClinicalAlertsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"kind":{"r":true},"alert_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_alerts"],[2,[7,"/"],[2,[3,"kind"],[2,[7,"/"],[3,"alert_id"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/teams/:id/remove_member(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeMemberEnterpriseTeamPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_member"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/families/:id/remove_member
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeMemberLocationFamilyPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"families"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"remove_member"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_methods/:id/remove_payment_method
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removePaymentMethodLocationPatientPaymentMethodPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"remove_payment_method"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/goto/phone_number/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removePhoneNumberSettingsPhoneMessagingGotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"goto"],[2,[7,"/"],[2,[6,"phone_number"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/roles/:id/remove_user(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeUserEnterpriseRolePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/custom_codes/office/:id/rename
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renameEnterpriseOfficeCustomCodePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"custom_codes"],[2,[7,"/"],[2,[6,"office"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"rename"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/clinical_photos/:id/rename(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renameLocationApiV1PatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rename"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/stations/:id
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renameStationImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[2,[6,"stations"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/agent_review/findings/:finding_id/reopen
 * @param {any} implementationId
 * @param {any} findingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopenImplementationImplementationAgentReviewPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"finding_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"agent_review"],[2,[7,"/"],[2,[6,"findings"],[2,[7,"/"],[2,[3,"finding_id"],[2,[7,"/"],[6,"reopen"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/clinical_opportunities/:id/reopen(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopenLocationApiV1PatientClinicalOpportunityPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_opportunities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/reopen
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopenLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"reopen"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/medical_claims/:id/reopen
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopenLocationPatientMedicalClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"medical_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"reopen"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/inbound_records/:id/reopen(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopenLocationReferralsInboundRecordPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"inbound_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/overview/reopen_step
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopenStepImplementationImplementationOverviewPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[6,"reopen_step"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/treatment_catalogs/reorder_categories(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderCategoriesSettingsTreatmentCatalogsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"treatment_catalogs"],[2,[7,"/"],[2,[6,"reorder_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/online_scheduling/reorder_configs(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderConfigsSettingsOnlineSchedulingIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"online_scheduling"],[2,[7,"/"],[2,[6,"reorder_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/reorder_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderDocumentsInternalGoLiveConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"reorder_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_curricula/:training_curriculum_id/entries/reorder(.:format)
 * @param {any} trainingCurriculumId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderInternalTrainingCurriculumEntriesPath = /*#__PURE__*/ __route({"training_curriculum_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_curricula"],[2,[7,"/"],[2,[3,"training_curriculum_id"],[2,[7,"/"],[2,[6,"entries"],[2,[7,"/"],[2,[6,"reorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/reorder_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderItemsInternalGoLiveConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"reorder_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/treatment_catalogs/reorder_items(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderItemsSettingsTreatmentCatalogsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"treatment_catalogs"],[2,[7,"/"],[2,[6,"reorder_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/operatory_queue/reorder
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderLocationOperatoryQueuePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"operatory_queue"],[2,[7,"/"],[6,"reorder"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/letters/:letter_id/images/reorder(.:format)
 * @param {any} locationId
 * @param {any} letterId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderLocationReferralsLetterImagesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"letter_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letters"],[2,[7,"/"],[2,[3,"letter_id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[6,"reorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/reorder_operatories
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderOperatoriesImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"reorder_operatories"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/reorder_phases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderPhasesInternalGoLiveConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"reorder_phases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_photos/:id/reorder_photo
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderPhotoLocationPatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"reorder_photo"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/reorder_problem_groups(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderProblemGroupsSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"reorder_problem_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/operatories/reorder(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderSettingsLocationOperatoriesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"operatories"],[2,[7,"/"],[2,[6,"reorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/xray_mounts/:id/reorder_stack(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderStackApiV1XrayMountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"xray_mounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reorder_stack"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/clinical_photos/:id/reorder_stack(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderStackLocationApiV1PatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reorder_stack"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_visits/reorder_treatments(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderTreatmentsLocationApiV1PatientTreatmentVisitsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_visits"],[2,[7,"/"],[2,[6,"reorder_treatments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/knowledge/:id/reorder_videos(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderVideosInternalKnowledgePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reorder_videos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_status/:id/repair_task(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const repairTaskInternalEobStatusPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_status"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"repair_task"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/files_v2/:id/replace_document
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const replaceDocumentLocationPatientFilesV2Path = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"files_v2"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"replace_document"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_status/replicate_carrier_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const replicateCarrierConfigInternalEobStatusIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_status"],[2,[7,"/"],[2,[6,"replicate_carrier_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/report_rows(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportRowsEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"report_rows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /credentialing/calls/:id/representative_name(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const representativeNameCredentialingCallPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"representative_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/calls/:id/representative_name(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const representativeNameRcmServicesCallPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"representative_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/training_videos/:training_video_id/versions/:id/reprocess(.:format)
 * @param {any} trainingVideoId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reprocessInternalTrainingVideoVersionPath = /*#__PURE__*/ __route({"training_video_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"training_videos"],[2,[7,"/"],[2,[3,"training_video_id"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reprocess"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/ambient_sessions/:id/reprocess(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reprocessLocationApiV1AmbientSessionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ambient_sessions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reprocess"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/reprocess
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reprocessLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"reprocess"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/reprocess
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reprocessRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"reprocess"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/repush_clinician_roles
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const repushClinicianRolesInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"repush_clinician_roles"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/bank_deposits/request_sync
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requestSyncLocationBankDepositsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"bank_deposits"],[2,[7,"/"],[6,"request_sync"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bank_transactions/request_sync
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requestSyncRcmServicesPostingBankTransactionsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bank_transactions"],[2,[7,"/"],[6,"request_sync"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/:id/require_resignature(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requireResignatureSettingsPatientFormTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"require_resignature"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/rerun_extraction
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rerunExtractionImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"rerun_extraction"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/verification_api_requests/:id/rerun(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rerunInternalVerificationApiRequestPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"verification_api_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rerun"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/:account_id/invitations/:id/resend(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resendAccountAccountInvitationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/email/resend_confirmation(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resendConfirmationSettingsLocationEmailPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"resend_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/resend
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resendLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"resend"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/reset_balance_check
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetBalanceCheckImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"reset_balance_check"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/reset_collection_validation
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetCollectionValidationImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"reset_collection_validation"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/reset_data_model_verification
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetDataModelVerificationImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"reset_data_model_verification"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/patient_ar/sequence/reset
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetEnterprisePoliciesPatientArSequencePath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"patient_ar"],[2,[7,"/"],[2,[6,"sequence"],[2,[7,"/"],[6,"reset"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/reset_feature_setting
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetFeatureSettingImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"reset_feature_setting"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/treatments/reset_fees
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetFeesLocationPatientOdontogramTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[6,"reset_fees"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/reset_insurance_balance_check
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetInsuranceBalanceCheckImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"reset_insurance_balance_check"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/reset_item_due_date
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetItemDueDateImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"reset_item_due_date"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/reset_location_feature_setting
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetLocationFeatureSettingImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"reset_location_feature_setting"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/demos/reset_memberships(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetMembershipsInternalDemosPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[6,"reset_memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/rcm_ai_models/reset_model(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetModelRcmServicesRcmAiModelsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"rcm_ai_models"],[2,[7,"/"],[2,[6,"reset_model"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/users/:id/reset_password(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetPasswordEnterpriseUserPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/reset_production_validation
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetProductionValidationImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"reset_production_validation"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/demos/reset_referrals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetReferralsInternalDemosPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[6,"reset_referrals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/reset_setting(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetSettingInternalAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/reset_setting(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetSettingInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/feature_flags/reset_setting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetSettingInternalFeatureFlagsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[6,"reset_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/reset_unallocated_wallet_check
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetUnallocatedWalletCheckImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"reset_unallocated_wallet_check"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/resolve
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolveConversationLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[6,"resolve"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/resolve_document_upload(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolveDocumentUploadRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve_document_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_merges/resolve(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolveEnterprisePatientMergesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_merges"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/resolve_follow_up(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolveFollowUpRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve_follow_up"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/resolve_history
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolveHistoryLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[6,"resolve_history"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/faxes/:id/resolve
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolveLocationFaxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"faxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"resolve"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/resolve_send(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolveSendRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve_send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/restart_collections_review(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restartCollectionsReviewLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restart_collections_review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/credential_types/restore_defaults(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreDefaultsCredentialingCredentialTypesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"credential_types"],[2,[7,"/"],[2,[6,"restore_defaults"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/documents/:document_id/restore_scan_order
 * @param {any} locationId
 * @param {any} id
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreDocumentScanOrderLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"document_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[6,"restore_scan_order"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admins/:admin_id/account_memberships/:id/restore(.:format)
 * @param {any} adminId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreInternalAdminAccountMembershipPath = /*#__PURE__*/ __route({"admin_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"admin_id"],[2,[7,"/"],[2,[6,"account_memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/carrier_portal_configs/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreInternalCarrierPortalConfigPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"carrier_portal_configs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/ambient_patient_note_candidates/:id/restore(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreLocationApiV1AmbientPatientNoteCandidatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ambient_patient_note_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_photos/:id/restore
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreLocationPatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"restore"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/time_blocks/:id/restore(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreLocationTimeBlockPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"time_blocks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/rcm_teammates/:rcm_teammate_id/account_memberships/:id/restore(.:format)
 * @param {any} rcmTeammateId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreRcmServicesRcmTeammateAccountMembershipPath = /*#__PURE__*/ __route({"rcm_teammate_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"rcm_teammates"],[2,[7,"/"],[2,[3,"rcm_teammate_id"],[2,[7,"/"],[2,[6,"account_memberships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_verifications/replies/:message_id/restore
 * @param {any} messageId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreReplyRcmServicesInsuranceVerificationsPath = /*#__PURE__*/ __route({"message_id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_verifications"],[2,[7,"/"],[2,[6,"replies"],[2,[7,"/"],[2,[3,"message_id"],[2,[7,"/"],[6,"restore"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/migration_runs/:id/resume_automated
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resumeAutomatedImplementationImplementationMigrationRunPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"migration_runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"resume_automated"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/retention_data(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retentionDataEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"retention_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/retention(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retentionEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"retention"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/ai_memories/:id/retire(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retireInternalAiMemoryPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ai_memories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retire"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/ai_memories/retire_refinement/:refinement_id(.:format)
 * @param {any} refinementId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retireRefinementInternalAiMemoriesPath = /*#__PURE__*/ __route({"refinement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ai_memories"],[2,[7,"/"],[2,[6,"retire_refinement"],[2,[7,"/"],[2,[3,"refinement_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/insurance/retroactive_claims
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retroactiveInsuranceClaimsLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"insurance"],[2,[7,"/"],[6,"retroactive_claims"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_plans/:id/retry_charge
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryChargeLocationPatientPaymentPlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"retry_charge"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/plan_subscription/retry_charge
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryChargeLocationPatientPlanSubscriptionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"plan_subscription"],[2,[7,"/"],[6,"retry_charge"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/denticon_checkpoints/:id/retry_connection
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryConnectionImplementationImplementationDenticonCheckpointPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"denticon_checkpoints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"retry_connection"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/modento_form_exports/:id/retry_failed
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryFailedImplementationImplementationModentoFormExportPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"modento_form_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"retry_failed"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/modento_form_exports/:id/retry_failed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryFailedInternalModentoFormExportPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"modento_form_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_failed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/retry_goto_channel
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryGotoChannelImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"retry_goto_channel"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/curve_exports/:id/retry_hydrate
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryHydrateImplementationImplementationCurveExportPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"curve_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"retry_hydrate"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/imports/items/:item_id/retry(.:format)
 * @param {any} locationId
 * @param {any} itemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryItemSettingsPatientFormImportsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"item_id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/rcm_teammates/:id/retry_onboarding(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryOnboardingRcmServicesRcmTeammatePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"rcm_teammates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_onboarding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/retry_oryx_crawl
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryOryxCrawlImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"retry_oryx_crawl"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/retry_oryx_extract
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryOryxExtractImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"retry_oryx_extract"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_intents/:id/retry_payment
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryPaymentLocationPatientPaymentIntentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_intents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"retry_payment"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/migration_runs/:id/retry_run
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryRunImplementationImplementationMigrationRunPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"migration_runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"retry_run"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/retry_snapshot_table
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retrySnapshotTableImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"retry_snapshot_table"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/:id/return_to_plan
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const returnToPlanLocationPatientTreatmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"return_to_plan"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/virtual_cards/:id/returned
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const returnedLocationRcmVirtualCardPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"virtual_cards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"returned"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/credentials/:id/reveal
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revealCredentialImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"reveal"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:go_live_id/credentials/:id/reveal(.:format)
 * @param {any} goLiveId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revealInternalGoLiveCredentialPath = /*#__PURE__*/ __route({"go_live_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"go_live_id"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reveal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:id/reveal_secure_info(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revealSecureInfoInternalGoLivePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reveal_secure_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboards/revenue_cycle(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revenueCycleEnterpriseDashboardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"revenue_cycle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/revenue_cycle(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revenueCycleReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"revenue_cycle"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/uploads/:id/revert_batch(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revertBatchEnterpriseMarketingUploadPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revert_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_merges/revert_batch(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revertBatchEnterprisePatientMergesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_merges"],[2,[7,"/"],[2,[6,"revert_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/uploads/:id/revert(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revertEnterpriseMarketingUploadPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revert"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_merges/revert(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revertEnterprisePatientMergesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_merges"],[2,[7,"/"],[2,[6,"revert"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_visits/:id/review_general_supervision(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewGeneralSupervisionLocationApiV1PatientTreatmentVisitPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_visits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review_general_supervision"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/general_supervision_reviews/:id/review
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewLocationGeneralSupervisionReviewPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"general_supervision_reviews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"review"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/review_medical_lists
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewMedicalListsImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"review_medical_lists"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/review_medical_lists(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewMedicalListsSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"review_medical_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/review_medical_lists_status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewMedicalListsStatusImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"review_medical_lists_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/review_medical_lists_status(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewMedicalListsStatusSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"review_medical_lists_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/review_medication_names
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewMedicationNamesImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"review_medication_names"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/review_medication_names(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewMedicationNamesSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"review_medication_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/review_medication_names_status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewMedicationNamesStatusImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"review_medication_names_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/review_medication_names_status(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewMedicationNamesStatusSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"review_medication_names_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/otto/review
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewRcmServicesOttoRunsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"otto"],[2,[7,"/"],[6,"review"]]]]]]);

/**
 * Generates rails route to
 * /internal/knowledge/:id/revise_document(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviseDocumentInternalKnowledgePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revise_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/knowledge/:id/revise_inline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviseInlineInternalKnowledgePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revise_inline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/knowledge/:id/revise_section(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviseSectionInternalKnowledgePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revise_section"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/connected_apps/:id/revoke
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revokeEnterpriseConnectedAppPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"connected_apps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"revoke"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/links/:id/revoke
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revokeInternalLinkPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"revoke"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/letters/:id/revoke_secure_link(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revokeSecureLinkLocationReferralsLetterPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke_secure_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootPath = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/files/:file_id/pages/:page_number/rotation
 * @param {any} locationId
 * @param {any} id
 * @param {any} fileId
 * @param {any} pageNumber
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rotatePageLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"file_id":{"r":true},"page_number":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_number"],[2,[7,"/"],[6,"rotation"]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/xray_mounts/:id/rotate_photo(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rotatePhotoApiV1XrayMountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"xray_mounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rotate_photo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/clinical_photos/:id/rotate_photo(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rotatePhotoLocationApiV1PatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rotate_photo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/routing_slip(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const routingSlipLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"routing_slip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/routing_slips(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const routingSlipsLocationAppointmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"routing_slips"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/run_balance_check
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runBalanceCheckImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"run_balance_check"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eligibility_dashboard/run_batch_check
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runBatchCheckInternalEligibilityDashboardPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eligibility_dashboard"],[2,[7,"/"],[6,"run_batch_check"]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_status/run_batch_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runBatchCheckInternalEobStatusIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_status"],[2,[7,"/"],[2,[6,"run_batch_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/pre_auth_dashboard/run_batch_check
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runBatchCheckInternalPreAuthDashboardPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"pre_auth_dashboard"],[2,[7,"/"],[6,"run_batch_check"]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/run_collection_validation
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runCollectionValidationImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"run_collection_validation"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/run_data_cleanup_check
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runDataCleanupCheckImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"run_data_cleanup_check"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/run_data_model_verification
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runDataModelVerificationImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"run_data_model_verification"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/run_insurance_balance_check
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runInsuranceBalanceCheckImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"run_insurance_balance_check"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/:id/run_now(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runNowEnterpriseAgentPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run_now"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation/run_probe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runProbeInternalRcmAutomationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[2,[7,"/"],[2,[6,"run_probe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/run_production_validation
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runProductionValidationImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"run_production_validation"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/otto/run
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runRcmServicesOttoRunsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"otto"],[2,[7,"/"],[6,"run"]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/run_unallocated_wallet_check
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runUnallocatedWalletCheckImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"run_unallocated_wallet_check"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/:id/runs(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runsEnterpriseAgentPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"runs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/sales_tax(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesTaxEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"sales_tax"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/signatures/:id/save_agreement
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saveAgreementLocationSignatureLinkPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"save_agreement"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_alerts/save_all
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saveAllLocationPatientClinicalAlertsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_alerts"],[2,[7,"/"],[6,"save_all"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_alerts/save_allergies
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saveAllergiesLocationPatientClinicalAlertsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_alerts"],[2,[7,"/"],[6,"save_allergies"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/:id/save_billing
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saveBillingLocationPatientTreatmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"save_billing"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/appointments/:id/save_claim_documentation(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saveClaimDocumentationLocationApiV1AppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"save_claim_documentation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/save_coverage_category_mapping
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saveCoverageCategoryMappingImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"save_coverage_category_mapping"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/:id/save_draft(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saveDraftSettingsPatientFormTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"save_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/forms/:id/save
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saveLocationPatientFormPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"save"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/payment_plan_agreements/:id/save
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saveLocationPaymentPlanAgreementPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"payment_plan_agreements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"save"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/perio_charts/:id/save_measurements
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saveMeasurementsLocationPatientPerioChartPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"perio_charts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"save_measurements"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_alerts/notes/:kind/:alert_id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} kind
 * @param {any} alertId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saveNoteLocationPatientClinicalAlertsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"kind":{"r":true},"alert_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_alerts"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"kind"],[2,[7,"/"],[3,"alert_id"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation/save_portal_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const savePortalSetupInternalRcmAutomationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[2,[7,"/"],[2,[6,"save_portal_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/save_send_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saveSendDataRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"save_send_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/invoice_reconciliations/scan(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scanEnterpriseInvoiceReconciliationsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"invoice_reconciliations"],[2,[7,"/"],[2,[6,"scan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_merges/scan(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scanEnterprisePatientMergesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_merges"],[2,[7,"/"],[2,[6,"scan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/scan_status
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scanStatusLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"scan_status"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/suggested_actions/:id/schedule_appointment(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduleAppointmentLocationSuggestedActionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"suggested_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"schedule_appointment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/schedule(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduleLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/check_out/schedule_recall
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduleRecallCheckOutLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_out"],[2,[7,"/"],[6,"schedule_recall"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/schedule_recall
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduleRecallLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"schedule_recall"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/suggested_actions/:id/schedule
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduleSuggestedActionLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"suggested_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"schedule"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/scheduled_production(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduledProductionDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"scheduled_production"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/scheduled_production(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduledProductionEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"scheduled_production"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/scheduled_production_trend(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduledProductionTrendDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"scheduled_production_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/scheduled_production_trend(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduledProductionTrendEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"scheduled_production_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/tracking_tests/:id/screenshot(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const screenshotEnterpriseMarketingTrackingTestPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"tracking_tests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"screenshot"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/search_assign(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchAssignLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"search_assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/search_carriers
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchCarriersLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"search_carriers"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/virtual_cards/search_carriers
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchCarriersLocationRcmVirtualCardsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"virtual_cards"],[2,[7,"/"],[6,"search_carriers"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/search_carriers
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchCarriersRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"search_carriers"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/search_claims
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchClaimsLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"search_claims"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/search_claims
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchClaimsRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"search_claims"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/confirmation_add_ons/search_codes
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchCodesEnterprisePoliciesConfirmationAddOnsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"confirmation_add_ons"],[2,[7,"/"],[6,"search_codes"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/patient_ar/search_codes
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchCodesEnterprisePoliciesPatientArPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"patient_ar"],[2,[7,"/"],[6,"search_codes"]]]]]]]]]]);

/**
 * Generates rails route to
 * /dental_codes/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchDentalCodesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dental_codes"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_merges/search(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchEnterprisePatientMergesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_merges"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /search_for_dental_code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchForDentalCodePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"search_for_dental_code"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /insurance_carriers/search_for_insurance_carrier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchForInsuranceCarrierInsuranceCarriersPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[6,"search_for_insurance_carrier"]]]]);

/**
 * Generates rails route to
 * /insurance_plans/search_for_insurance_plan(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchForInsurancePlanInsurancePlansPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[6,"search_for_insurance_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/families/:id/search_for_new_member
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchForNewMemberLocationFamilyPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"families"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"search_for_new_member"]]]]]]]]]]);

/**
 * Generates rails route to
 * /icd10_codes/search
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchIcd10CodesPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"icd10_codes"],[2,[7,"/"],[6,"search"]]]]);

/**
 * Generates rails route to
 * /insurance_plans/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchInsurancePlansPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"insurance_plans"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/search.:format
 * @param {any} locationId
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchLocationPatientsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[6,"search"],[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /medical_payers/search
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchMedicalPayersPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"medical_payers"],[2,[7,"/"],[6,"search"]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/prescription_favorites/search_medications(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchMedicationsEnterprisePrescriptionFavoritesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"prescription_favorites"],[2,[7,"/"],[2,[6,"search_medications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/dosespot/search_medications
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchMedicationsLocationDosespotPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"dosespot"],[2,[7,"/"],[6,"search_medications"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eligibility_dashboard/search_patients
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchPatientsInternalEligibilityDashboardPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eligibility_dashboard"],[2,[7,"/"],[6,"search_patients"]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_status/search_patients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchPatientsInternalEobStatusIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_status"],[2,[7,"/"],[2,[6,"search_patients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/live_calls/search_patients
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchPatientsLocationLiveCallsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"live_calls"],[2,[7,"/"],[6,"search_patients"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/pre_authorizations_queue/search_patients(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchPatientsLocationRcmPreAuthorizationsQueueIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"pre_authorizations_queue"],[2,[7,"/"],[2,[6,"search_patients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/verification_queue/search_patients(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchPatientsLocationRcmVerificationQueueIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"verification_queue"],[2,[7,"/"],[2,[6,"search_patients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/search_patients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchPatientsRcmServicesInboxIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[6,"search_patients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/patient_ar/search_plans
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchPlansEnterprisePoliciesPatientArPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"patient_ar"],[2,[7,"/"],[6,"search_plans"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/pre_auth_dashboard/search_pre_auths
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchPreAuthsInternalPreAuthDashboardPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"pre_auth_dashboard"],[2,[7,"/"],[6,"search_pre_auths"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/search_wallet_sources
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchWalletSourcesLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"search_wallet_sources"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/search_wallet_sources
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchWalletSourcesRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"search_wallet_sources"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/appointments/:id/seated(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seatedLocationApiV1AppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"seated"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/seated(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seatedLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"seated"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scorecards/seed_templates
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seedTemplatesTwelveTeamScorecardsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[6,"seed_templates"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_plans/select_invoice
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selectInvoiceLocationPatientPaymentPlansPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_plans"],[2,[7,"/"],[6,"select_invoice"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_links/select_target
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selectTargetLocationPatientPaymentLinksPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_links"],[2,[7,"/"],[6,"select_target"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/send_claim
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendClaimLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"send_claim"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/send_clinician_tfa_texts
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendClinicianTfaTextsInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"send_clinician_tfa_texts"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/agreements_v2/send_default_body
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendDefaultBodyLocationPatientAgreementsV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"agreements_v2"],[2,[7,"/"],[6,"send_default_body"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/forms_v2/send_default_body
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendDefaultBodyLocationPatientFormsV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"forms_v2"],[2,[7,"/"],[6,"send_default_body"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/send_email
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendEmailLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[6,"send_email"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/faxes/send_fax
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendFaxLocationFaxesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"faxes"],[2,[7,"/"],[6,"send_fax"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/links/:id/send_installer_email
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendInstallerEmailInternalLinkPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"send_installer_email"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/check_out/send_medical_claims
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendMedicalClaimsCheckOutLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_out"],[2,[7,"/"],[6,"send_medical_claims"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/send
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendMessageLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[6,"send"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/schedule_design/send_message(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendMessageSettingsLocationScheduleDesignPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"schedule_design"],[2,[7,"/"],[2,[6,"send_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/agreements_v2/send_payment_plan
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendPaymentPlanLocationPatientAgreementsV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"agreements_v2"],[2,[7,"/"],[6,"send_payment_plan"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages/:id/send_queued_message
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendQueuedMessageLocationMessagePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"send_queued_message"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/messages/:id/send_queued
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendQueuedMessageLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"send_queued"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/letters/:id/send_secure_link(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendSecureLinkLocationReferralsLetterPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_secure_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_methods/send_setup_link
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendSetupLinkLocationPatientPaymentMethodsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[6,"send_setup_link"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/forms_v2/send_share
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendShareLocationPatientFormsV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"forms_v2"],[2,[7,"/"],[6,"send_share"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/send_slack_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendSlackReportsInternalGoLiveConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"send_slack_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:id/send_statement
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendStatementLocationPatientInvoicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"send_statement"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/phone_numbers/:id/send_test_message(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendTestMessageInternalPhoneNumberPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"phone_numbers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_test_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/email/send_test(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendTestSettingsLocationEmailPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"send_test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/send_text
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendTextLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"send_text"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/forms_v2/send_to_patient
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendToPatientLocationPatientFormsV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"forms_v2"],[2,[7,"/"],[6,"send_to_patient"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_links/:id/send_to_patient
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendToPatientLocationPatientPaymentLinkPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"send_to_patient"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/clinical_photos/:id/send_to_pearl(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendToPearlLocationApiV1ClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_to_pearl"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/send_to_vyne
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendToVyneLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"send_to_vyne"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/send_to_vyne(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendToVyneRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_to_vyne"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/agreements_v2/send_treatment
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendTreatmentLocationPatientAgreementsV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"agreements_v2"],[2,[7,"/"],[6,"send_treatment"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/schedule/send_verification
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendVerificationLocationPatientSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"schedule"],[2,[7,"/"],[6,"send_verification"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/faxes/:id/sent_document
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sentDocumentLocationFaxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"faxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"sent_document"]]]]]]]]]]);

/**
 * Generates rails route to
 * /session/otp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessionOtpPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"otp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks/:id/set_active(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setActiveLocationTaskPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_methods/:id/set_as_default
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setAsDefaultLocationPatientPaymentMethodPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"set_as_default"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/documents/:document_id/amount
 * @param {any} locationId
 * @param {any} id
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setDocumentAmountLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"document_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[6,"amount"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/documents/:document_id/kind
 * @param {any} locationId
 * @param {any} id
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setDocumentKindLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"document_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[6,"kind"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_visits/:id/set_general_supervision(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setGeneralSupervisionLocationApiV1PatientTreatmentVisitPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_visits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_general_supervision"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/set_item_due_date
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setItemDueDateImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"set_item_due_date"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatments/:id/set_office_fee
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setOfficeFeeLocationPatientTreatmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"set_office_fee"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/users/:id/set_pin(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setPinEnterpriseUserPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_pin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_visits/:id/set_priority(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setPriorityLocationApiV1PatientTreatmentVisitPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_visits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_priority"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_visits/:id/set_recommended_duration(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setRecommendedDurationLocationApiV1PatientTreatmentVisitPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_visits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_recommended_duration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/set_requirement
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setRequirementImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"set_requirement"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation/set_script_marker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setScriptMarkerInternalRcmAutomationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[2,[7,"/"],[2,[6,"set_script_marker"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_visits/set_signature_collector(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setSignatureCollectorLocationApiV1PatientTreatmentVisitsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_visits"],[2,[7,"/"],[2,[6,"set_signature_collector"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/set_station_count
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setStationCountImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"set_station_count"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/:id/set_tags(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setTagsEnterpriseAgentPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_visits/:id/set_tentative_benefit_year(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setTentativeBenefitYearLocationApiV1PatientTreatmentVisitPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_visits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_tentative_benefit_year"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/set_up_twilio_event_stream(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setUpTwilioEventStreamInternalAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_up_twilio_event_stream"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/set_visibility_rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setVisibilityRulesInternalGoLiveConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"set_visibility_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/ai_outreach(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsAiOutreachIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ai_outreach"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/appointment_templates/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsAppointmentTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"appointment_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/appointment_templates(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsAppointmentTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"appointment_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_prompts/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsClinicalNotePromptPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_prompts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_prompts(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsClinicalNotePromptsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_prompts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_templates/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsClinicalNoteTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_template_categories(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsClinicalNoteTemplateCategoriesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_template_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_templates(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsClinicalNoteTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/default_location(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsDefaultLocationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"default_location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/custom_codes/office/settings
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsEnterpriseOfficeCustomCodesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"custom_codes"],[2,[7,"/"],[2,[6,"office"],[2,[7,"/"],[6,"settings"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/location(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/adjustment_types/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationAdjustmentTypePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"adjustment_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/adjustment_types(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationAdjustmentTypesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"adjustment_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/ai_caller_settings(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationAiCallerSettingsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ai_caller_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/api_keys/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationApiKeyPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/api_keys(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationApiKeysPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/appointment_categories(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationAppointmentCategoriesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"appointment_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/appointment_colors(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationAppointmentColorsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"appointment_colors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/check_in_policy
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationCheckInPolicyPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[6,"check_in_policy"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/check_out_policy
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationCheckOutPolicyPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[6,"check_out_policy"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/claim_submission_policy
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationClaimSubmissionPolicyPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[6,"claim_submission_policy"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/custom_codes/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationCustomCodePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/custom_codes(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationCustomCodesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/default_provider_assignments/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationDefaultProviderAssignmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"default_provider_assignments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/default_provider_assignments(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationDefaultProviderAssignmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"default_provider_assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/in_appointment_policy
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationInAppointmentPolicyPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[6,"in_appointment_policy"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/insurance_history_settings(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationInsuranceHistorySettingsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"insurance_history_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/insurance_posting_policy
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationInsurancePostingPolicyPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[6,"insurance_posting_policy"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/labs/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationLabPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"labs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/labs(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationLabsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"labs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/office_hours(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationOfficeHoursPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"office_hours"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/operatories(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationOperatoriesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"operatories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/operatories/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationOperatoryPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"operatories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/patient_ar_policy
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationPatientArPolicyPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[6,"patient_ar_policy"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/patient_file_folders/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationPatientFileFolderPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"patient_file_folders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/patient_file_folders(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationPatientFileFoldersPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"patient_file_folders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/payment_terminals/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationPaymentTerminalPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payment_terminals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/payment_terminals(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationPaymentTerminalsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payment_terminals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/payment_type_settings(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationPaymentTypeSettingsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payment_type_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/periodontal_chart_preference(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationPeriodontalChartPreferencePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"periodontal_chart_preference"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/prescription_favorites/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationPrescriptionFavoritePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"prescription_favorites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/prescription_favorites(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationPrescriptionFavoritesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"prescription_favorites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/quick_treatments/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationQuickTreatmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"quick_treatments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/quick_treatments(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationQuickTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"quick_treatments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/schedule_design(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationScheduleDesignPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"schedule_design"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/teams/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationTeamPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/teams(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLocationTeamsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/mounts_devices(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsMountsDevicesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"mounts_devices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/note_abbreviations/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsNoteAbbreviationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"note_abbreviations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/note_abbreviations(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsNoteAbbreviationsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"note_abbreviations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/online_scheduling(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsOnlineSchedulingIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"online_scheduling"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/password(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPasswordPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/imports(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPatientFormImportsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPatientFormTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/automated_messages/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPhoneMessagingAutomatedMessagePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"automated_messages"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/automated_messages
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPhoneMessagingAutomatedMessagesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[6,"automated_messages"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/channel_setup
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPhoneMessagingChannelSetupPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[6,"channel_setup"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/goto
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPhoneMessagingGotoPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[6,"goto"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/mango
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPhoneMessagingMangoPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[6,"mango"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/message_config
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPhoneMessagingMessageConfigPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[6,"message_config"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/message_templates
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPhoneMessagingMessageTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[6,"message_templates"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPhoneMessagingRootPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[6,"phone_messaging"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/pin(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPinPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"pin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/providers/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsProviderPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/provider_instructions(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsProviderInstructionsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"provider_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/provider_requests/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsProviderRequestPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"provider_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/provider_requests(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsProviderRequestsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"provider_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/providers(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsProvidersPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"providers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsRootPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/treatment_catalogs(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsTreatmentCatalogsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"treatment_catalogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/billing(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsTwelveBillingPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/billing/change(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsTwelveBillingChangePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"change"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/billing/portal(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsTwelveBillingPortalPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"portal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/demos/setup_ambient_scenario(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setupAmbientScenarioInternalDemosPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[6,"setup_ambient_scenario"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/demos/setup_claim_documentation_scenario(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setupClaimDocumentationScenarioInternalDemosPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[6,"setup_claim_documentation_scenario"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_methods/setup_link
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setupLinkLocationPatientPaymentMethodsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[6,"setup_link"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/demos/setup_rcm_scenario(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setupRcmScenarioInternalDemosPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[6,"setup_rcm_scenario"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/demos/setup_record_deposit_scenario(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setupRecordDepositScenarioInternalDemosPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"demos"],[2,[7,"/"],[2,[6,"setup_record_deposit_scenario"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/email/setup(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setupSettingsLocationEmailPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/forms_v2/share_default_body
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shareDefaultBodyLocationPatientFormsV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"forms_v2"],[2,[7,"/"],[6,"share_default_body"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/share_forms.:format
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shareFormsLocationPatientOdontogramPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"share_forms"],[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/forms_v2/share
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shareLocationPatientFormsV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"forms_v2"],[2,[7,"/"],[6,"share"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_plan_agreements/:id/share
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shareLocationPatientPaymentPlanAgreementPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_plan_agreements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"share"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/treatment_agreements/share
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shareLocationTreatmentAgreementsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"treatment_agreements"],[2,[7,"/"],[6,"share"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/agreements_v2/share_payment_plan
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sharePaymentPlanLocationPatientAgreementsV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"agreements_v2"],[2,[7,"/"],[6,"share_payment_plan"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:slug
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shortLinkRedirectPath = /*#__PURE__*/ __route({"slug":{"r":true}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[3,"slug"]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/show_assign(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showAssignLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/show_break(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showBreakLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_break"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/face-finder(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showFaceFinderLocationAppointmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"face-finder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_templates/:id/show_here(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showHereSettingsClinicalNoteTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_here"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:invoice_id/adjustments/show_merchant_fee
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} invoiceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showMerchantFeeLocationPatientInvoiceAdjustmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"invoice_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[6,"show_merchant_fee"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:invoice_id/insurance_payments/:id/show_modal
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} invoiceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showModalLocationPatientInvoiceInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"invoice_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"show_modal"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:id/show_overpayment_modal
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showOverpaymentModalLocationPatientInvoicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"show_overpayment_modal"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_photos/:id/show_photo
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showPhotoLocationPatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"show_photo"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/show_waitlist(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showWaitlistLocationAppointmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"show_waitlist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/payment_plan_agreements/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signLocationPaymentPlanAgreementPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"payment_plan_agreements"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_visits/signature_collector_options(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signatureCollectorOptionsLocationApiV1PatientTreatmentVisitsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_visits"],[2,[7,"/"],[2,[6,"signature_collector_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/signature_link_message_preview
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signatureLinkMessagePreviewLocationPatientOdontogramPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[6,"signature_link_message_preview"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/signatures/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signatureLocationSignatureLinkPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/simplify_medical_lists
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const simplifyMedicalListsImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"simplify_medical_lists"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/simplify_medical_lists(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const simplifyMedicalListsSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"simplify_medical_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/simulate_call
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const simulateCallV2LocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[6,"simulate_call"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/simulate_message
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const simulateMessageV2LocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[6,"simulate_message"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/simulate_rcm_reply(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const simulateRcmReplyLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"simulate_rcm_reply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /carrier_calling/ai/assignment/skip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skipCarrierCallingAiAssignmentPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"assignment"],[2,[7,"/"],[2,[6,"skip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /carrier_calling/assignment/skip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skipCarrierCallingAssignmentPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[2,[7,"/"],[2,[6,"assignment"],[2,[7,"/"],[2,[6,"skip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /carrier_calling/verifier/assignment/skip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skipCarrierCallingVerifierAssignmentPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"carrier_calling"],[2,[7,"/"],[2,[6,"verifier"],[2,[7,"/"],[2,[6,"assignment"],[2,[7,"/"],[2,[6,"skip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/tracking_tests/:id/skip_conversion(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skipConversionEnterpriseMarketingTrackingTestPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"tracking_tests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"skip_conversion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/documents/:document_id/skip
 * @param {any} locationId
 * @param {any} id
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skipDocumentLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"document_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[6,"skip"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_ar_dashboard/:id/skip(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skipEnterprisePatientArDashboardPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_ar_dashboard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"skip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/skip_outreach_candidate(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skipOutreachCandidateLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"skip_outreach_candidate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/files/:file_id/pages/:page_number/skip
 * @param {any} locationId
 * @param {any} id
 * @param {any} fileId
 * @param {any} pageNumber
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skipPageLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"file_id":{"r":true},"page_number":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_number"],[2,[7,"/"],[6,"skip"]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /slack/oauth/:location_id(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const slackOauthPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[3,"location_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/schedule/slots
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const slotsLocationPatientSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"schedule"],[2,[7,"/"],[6,"slots"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/snapshot_detail
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const snapshotDetailImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"snapshot_detail"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/snapshot_family_preview
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const snapshotFamilyPreviewImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"snapshot_family_preview"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/snapshot_status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const snapshotStatusImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"snapshot_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/snapshot_table_apply_messages
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const snapshotTableApplyMessagesImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"snapshot_table_apply_messages"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/snapshot_table_diff
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const snapshotTableDiffImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"snapshot_table_diff"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks/:id/snooze(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const snoozeLocationTaskPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"snooze"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/carrier_portal_configs/:id/soft_delete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const softDeleteInternalCarrierPortalConfigPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"carrier_portal_configs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"soft_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/source_document(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sourceDocumentRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"source_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/documents/:document_id/split
 * @param {any} locationId
 * @param {any} id
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const splitDocumentLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"document_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[6,"split"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:id/split
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const splitLocationPatientInvoicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"split"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/split_pending_document
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const splitPendingDocumentLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"split_pending_document"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/split_pending_document
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const splitPendingDocumentRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"split_pending_document"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/split_procedures
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const splitProceduresLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"split_procedures"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/ssn_value
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ssnValueLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"ssn_value"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/dosespot/sso
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ssoLocationDosespotPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"dosespot"],[2,[7,"/"],[6,"sso"]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/chats/:public_id/transcript(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1Path = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[3,"public_id"],[2,[7,"/"],[2,[6,"transcript"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/action_schema(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ActionSchemaPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"action_schema"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/ask_user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1AskUserPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"ask_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/check_carrier_network_participation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1CheckCarrierNetworkParticipationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"check_carrier_network_participation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/check_npi_registry(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1CheckNpiRegistryPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"check_npi_registry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/count_patients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1CountPatientsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"count_patients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/create_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1CreateReportPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"create_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/events/turn_completed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1EventsTurnCompletedPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"turn_completed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/export_table(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ExportTablePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"export_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/find_actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1FindActionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"find_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/find_appointment_times(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1FindAppointmentTimesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"find_appointment_times"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/find_credentialing_payers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1FindCredentialingPayersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"find_credentialing_payers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/find_fill_candidates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1FindFillCandidatesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"find_fill_candidates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/find_open_slots(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1FindOpenSlotsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"find_open_slots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/find_patient_appointments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1FindPatientAppointmentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"find_patient_appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_add_on_setup_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetAddOnSetupStatusPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_add_on_setup_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_automated_message_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetAutomatedMessageSettingsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_automated_message_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_claim_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetClaimHistoryPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_claim_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_column_descriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetColumnDescriptionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_column_descriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_credentialing_credentials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetCredentialingCredentialsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_credentialing_credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_credentialing_roster(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetCredentialingRosterPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_credentialing_roster"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_customer_knowledge_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetCustomerKnowledgeDocumentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_customer_knowledge_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_draft_letter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetDraftLetterPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_draft_letter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_filter_operators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetFilterOperatorsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_filter_operators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_frequency_eligibility(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetFrequencyEligibilityPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_frequency_eligibility"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_implementation_setup_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetImplementationSetupConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_implementation_setup_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_implementation_setup_findings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetImplementationSetupFindingsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_implementation_setup_findings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_insurance_plan(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetInsurancePlanPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_insurance_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_invoice_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetInvoiceDetailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_invoice_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_letter_template(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetLetterTemplatePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_letter_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_location_hours(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetLocationHoursPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_location_hours"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_patient_dossier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetPatientDossierPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_patient_dossier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_patient_wallet_and_payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetPatientWalletAndPaymentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_patient_wallet_and_payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_plan_fee(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetPlanFeePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_plan_fee"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_query_examples(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetQueryExamplesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_query_examples"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_report_summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetReportSummaryPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_report_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_slot_offer_context(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetSlotOfferContextPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_slot_offer_context"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_system_knowledge_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetSystemKnowledgeDocumentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_system_knowledge_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/get_table_schema(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1GetTableSchemaPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"get_table_schema"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListActionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_add_ons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListAddOnsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_add_ons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_appointment_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListAppointmentTemplatesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_appointment_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_claim_payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListClaimPaymentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_claim_payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_clinical_note_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListClinicalNoteTemplatesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_clinical_note_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_customer_knowledge_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListCustomerKnowledgeDocumentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_customer_knowledge_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_duplicate_clinical_note_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListDuplicateClinicalNoteCategoriesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_duplicate_clinical_note_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_duplicate_clinical_note_prompts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListDuplicateClinicalNotePromptsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_duplicate_clinical_note_prompts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_duplicate_clinical_note_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListDuplicateClinicalNoteTemplatesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_duplicate_clinical_note_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_duplicate_custom_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListDuplicateCustomCodesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_duplicate_custom_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_hygiene_not_reappointed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListHygieneNotReappointedPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_hygiene_not_reappointed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_location_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListLocationConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_location_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_location_staff(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListLocationStaffPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_location_staff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListLocationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_metrics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListMetricsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_my_recent_results(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListMyRecentResultsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_my_recent_results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_patient_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListPatientFilesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_patient_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_patient_invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListPatientInvoicesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_patient_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_providers_and_operatories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListProvidersAndOperatoriesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_providers_and_operatories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_recall_due_unscheduled(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListRecallDueUnscheduledPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_recall_due_unscheduled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_recent_carrier_eobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListRecentCarrierEobsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_recent_carrier_eobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_report_schedules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListReportSchedulesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_report_schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_schedule_changes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListScheduleChangesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_schedule_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_settings_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListSettingsPagesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_settings_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_system_knowledge_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListSystemKnowledgeDocumentsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_system_knowledge_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListTasksPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_time_blocks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListTimeBlocksPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_time_blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/list_unscheduled_treatment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ListUnscheduledTreatmentPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"list_unscheduled_treatment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/load_result(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1LoadResultPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"load_result"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/match_lead_list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1MatchLeadListPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"match_lead_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/match_payment_to_claim(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1MatchPaymentToClaimPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"match_payment_to_claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/patient_contact_summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1PatientContactSummaryPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"patient_contact_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/preview_automated_message_template(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1PreviewAutomatedMessageTemplatePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"preview_automated_message_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/propose_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ProposeActionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"propose_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/propose_credentialing_changes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ProposeCredentialingChangesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"propose_credentialing_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/query_prod_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1QueryProdDataPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"query_prod_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/quick_query(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1QuickQueryPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"quick_query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/recall_memories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1RecallMemoriesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"recall_memories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/remember(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1RememberPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"remember"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/resolve_metric(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ResolveMetricPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"resolve_metric"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/resolve_procedure_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ResolveProcedureCodesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"resolve_procedure_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/run_provider_offboarding_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1RunProviderOffboardingCheckPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"run_provider_offboarding_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/search_clinical_notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1SearchClinicalNotesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"search_clinical_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/search_customer_facing_kb(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1SearchCustomerFacingKbPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"search_customer_facing_kb"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/search_dental_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1SearchDentalCodesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"search_dental_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/search_patient_notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1SearchPatientNotesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"search_patient_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/search_patients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1SearchPatientsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"search_patients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/set_credentialing_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1SetCredentialingAccountPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"set_credentialing_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/set_letter_template_draft(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1SetLetterTemplateDraftPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"set_letter_template_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /staff_chat/v1/tools/show_widget(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staffChatV1ShowWidgetPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"staff_chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"show_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/stale_ready_appointments_check
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const staleReadyAppointmentsCheckImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"stale_ready_appointments_check"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/daily/star_patient(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starPatientLocationDailyIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"daily"],[2,[7,"/"],[2,[6,"star_patient"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/migration_runs/:id/start_automated
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startAutomatedImplementationImplementationMigrationRunPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"migration_runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"start_automated"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/check_in/start
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startCheckInLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[6,"start"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/denticon_checkpoints/start_diff
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startDiffImplementationImplementationDenticonCheckpointsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"denticon_checkpoints"],[2,[7,"/"],[6,"start_diff"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/migration_runs/:id/start_diff
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startDiffImplementationImplementationMigrationRunPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"migration_runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"start_diff"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/migration_runs/:id/start_dms_reload
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startDmsReloadImplementationImplementationMigrationRunPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"migration_runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"start_dms_reload"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/claims/:id/start_follow_up
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startFollowUpRcmServicesClaimPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"start_follow_up"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/start_migration
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startMigrationImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"start_migration"]]]]]]]]]]);

/**
 * Generates rails route to
 * /my_twelve/:account_id/practice_scenarios/:id/start
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startMyTwelvePracticeScenarioPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"my_twelve"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"practice_scenarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"start"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/start_oryx_extract
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startOryxExtractImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"start_oryx_extract"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/start_overpayment_transfer
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startOverpaymentTransferLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"start_overpayment_transfer"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/migration_runs/start_run
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startRunImplementationImplementationMigrationRunsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"migration_runs"],[2,[7,"/"],[6,"start_run"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/start_snapshot
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startSnapshotImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"start_snapshot"]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/practice_scenarios/:id/start
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startTwelveTeamPracticeScenarioPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"practice_scenarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"start"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/perio_charts/:id/start_voice_session
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startVoiceSessionLocationPatientPerioChartPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"perio_charts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"start_voice_session"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/invoice_reconciliations/status(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusEnterpriseInvoiceReconciliationsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"invoice_reconciliations"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/curve_exports/status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusImplementationImplementationCurveExportsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"curve_exports"],[2,[7,"/"],[6,"status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/denticon_checkpoints/status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusImplementationImplementationDenticonCheckpointsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"denticon_checkpoints"],[2,[7,"/"],[6,"status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/migration_runs/status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusImplementationImplementationMigrationRunsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"migration_runs"],[2,[7,"/"],[6,"status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/modento_form_exports/status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusImplementationImplementationModentoFormExportsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"modento_form_exports"],[2,[7,"/"],[6,"status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/modento_form_import_runs/status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusImplementationImplementationModentoFormImportRunsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"modento_form_import_runs"],[2,[7,"/"],[6,"status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_sheet_import_runs/status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusImplementationImplementationSetupSheetImportRunsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_sheet_import_runs"],[2,[7,"/"],[6,"status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/modento_form_exports/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusInternalModentoFormExportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"modento_form_exports"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/status(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/chats/:id/stop(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stopAiChatPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"stop"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/ambient_sessions/:id/stop(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stopLocationApiV1AmbientSessionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ambient_sessions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"stop"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /stripe/checkout/create_intent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeCheckoutCreateIntentPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"create_intent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stripe/checkout/failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeCheckoutFailurePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stripe/checkout/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeCheckoutNewPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stripe/checkout/status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeCheckoutStatusPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[6,"status"]]]]]]);

/**
 * Generates rails route to
 * /stripe/checkout/success(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeCheckoutSuccessPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/stripe_onboarding_link
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeOnboardingLinkImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"stripe_onboarding_link"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/stripe_onboarding_link
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeOnboardingLinkInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"stripe_onboarding_link"]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/stripe_transactions_data(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeTransactionsDataEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"stripe_transactions_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/stripe_transactions(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeTransactionsEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"stripe_transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/stripe_transactions_export_csv(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeTransactionsExportCsvEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"stripe_transactions_export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/submit_a2p_brand(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitA2pBrandInternalAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_a2p_brand"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/a2p_brands/:brand_id/campaign(.:format)
 * @param {any} id
 * @param {any} brandId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitA2pCampaignInternalAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"brand_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"a2p_brands"],[2,[7,"/"],[2,[3,"brand_id"],[2,[7,"/"],[2,[6,"campaign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/submit_claim_follow_up(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitClaimFollowUpRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_claim_follow_up"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/submit_overpayment_transfer
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitOverpaymentTransferLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"submit_overpayment_transfer"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/submit_practice_task_update_info(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitPracticeTaskUpdateInfoLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_practice_task_update_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/submit_pre_auth_follow_up(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitPreAuthFollowUpRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_pre_auth_follow_up"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/submit_verification_outcome(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitVerificationOutcomeRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_verification_outcome"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_plans/:id/suggest_phasing(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suggestPhasingLocationApiV1PatientTreatmentPlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"suggest_phasing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /support_agent/v1/panel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const supportAgentV1PanelPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support_agent"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"panel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /support_agent/v1/turns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const supportAgentV1TurnsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support_agent"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"turns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/patient_merges/survivor(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const survivorEnterprisePatientMergesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"patient_merges"],[2,[7,"/"],[2,[6,"survivor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/plan_subscription/suspend
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suspendLocationPatientPlanSubscriptionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"plan_subscription"],[2,[7,"/"],[6,"suspend"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/xray_mounts/:id/swap_photos(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const swapPhotosApiV1XrayMountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"xray_mounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"swap_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/clinical_photos/:id/swap_photos(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const swapPhotosLocationApiV1PatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"swap_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/library/how-we-present/switch(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switchEnterprisePresentationStylePath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"how-we-present"],[2,[7,"/"],[2,[6,"switch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /switch_portal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switchPortalPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"switch_portal"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/a2p_brands/:brand_id/sync(.:format)
 * @param {any} id
 * @param {any} brandId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncA2pBrandInternalAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"brand_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"a2p_brands"],[2,[7,"/"],[2,[3,"brand_id"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/xray_mounts/sync_changes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncChangesApiV1XrayMountsPath = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"xray_mounts"],[2,[7,"/"],[2,[6,"sync_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/sync_dialstack_numbers
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncDialstackNumbersInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"sync_dialstack_numbers"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/sync_edit_wallet_merchant_fee
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncEditWalletMerchantFeeLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"sync_edit_wallet_merchant_fee"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/links/:id/sync_images
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncImagesInternalLinkPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"sync_images"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/unify/:id/sync(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncInternalUnifyPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"unify"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/unify/system/sync(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncInternalUnifySystemPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"unify"],[2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/dosespot/sync
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncLocationDosespotPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"dosespot"],[2,[7,"/"],[6,"sync"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/plan_subscription/sync
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncLocationPatientPlanSubscriptionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"plan_subscription"],[2,[7,"/"],[6,"sync"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/letters/:letter_id/images/sync(.:format)
 * @param {any} locationId
 * @param {any} letterId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncLocationReferralsLetterImagesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"letter_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letters"],[2,[7,"/"],[2,[3,"letter_id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:invoice_id/adjustments/sync_new
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} invoiceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncNewLocationPatientInvoiceAdjustmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"invoice_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[6,"sync_new"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/sync_new
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncNewLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"sync_new"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/sync_new_merchant_fee
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncNewMerchantFeeLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"sync_new_merchant_fee"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/sync_new_prepayment
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncNewPrepaymentLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"sync_new_prepayment"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/knowledge/sync_pylon_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncPylonAllInternalKnowledgeIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[6,"sync_pylon_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/knowledge/:id/sync_pylon(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncPylonInternalKnowledgePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync_pylon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/sync_swell_reviews
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncSwellReviewsImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"sync_swell_reviews"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/sync_swell_reviews(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncSwellReviewsInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync_swell_reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:id/sync_transfer_overpayment
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncTransferOverpaymentLocationPatientInvoicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"sync_transfer_overpayment"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/table_exports(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tableExportsEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"table_exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/table_exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tableExportsReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"table_exports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tag_verification/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tagVerificationPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tag_verification"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/documents/:id/tags(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tagsCredentialingDocumentPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/feature_rollouts/:id/targets
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const targetsInternalFeatureRolloutPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"feature_rollouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"targets"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/tasks
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasksLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"tasks"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/links/:id/curve_exports/:export_id/teardown
 * @param {any} id
 * @param {any} exportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teardownCurveExportInternalLinkPath = /*#__PURE__*/ __route({"id":{"r":true},"export_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"curve_exports"],[2,[7,"/"],[2,[3,"export_id"],[2,[7,"/"],[6,"teardown"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/curve_exports/:id/teardown
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teardownImplementationImplementationCurveExportPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"curve_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"teardown"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/clinical_photos/templates(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const templatesLocationApiV1PatientClinicalPhotosPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/plan_subscription/terminate
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terminateLocationPatientPlanSubscriptionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"plan_subscription"],[2,[7,"/"],[6,"terminate"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /terms_of_use(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const termsOfUsePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms_of_use"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/patient_dossiers/:id/test_agent(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const testAgentInternalPatientDossierPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"patient_dossiers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test_agent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/duration_predictions/:id/test_prediction(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const testPredictionInternalDurationPredictionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"duration_predictions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test_prediction"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/test_source_connection
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const testSourceConnectionImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"test_source_connection"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/text_preview
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const textPreviewLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"text_preview"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/:id/text_receipt
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const textReceiptLocationPatientPatientPaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"text_receipt"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/text_signature_link
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const textSignatureLinkLocationPatientOdontogramPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[6,"text_signature_link"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/role_goals/thresholds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thresholdsRcmServicesRoleGoalsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"role_goals"],[2,[7,"/"],[2,[6,"thresholds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/tidy_medication_names
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tidyMedicationNamesImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"tidy_medication_names"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/tidy_medication_names(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tidyMedicationNamesSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"tidy_medication_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /time_clock/clock_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeClockClockInPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"time_clock"],[2,[7,"/"],[2,[6,"clock_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /time_clock/clock_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeClockClockOutPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"time_clock"],[2,[7,"/"],[2,[6,"clock_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /time_clock/dismiss_prompt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeClockDismissPromptPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"time_clock"],[2,[7,"/"],[2,[6,"dismiss_prompt"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/today_performance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const todayPerformanceDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"today_performance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/today_performance(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const todayPerformanceEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"today_performance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:insurance_claim_id/insurance_claim_procedures/:id/toggle_bill_to_insurance
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} insuranceClaimId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleBillToInsuranceLocationPatientInsuranceClaimInsuranceClaimProcedurePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"insurance_claim_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"insurance_claim_id"],[2,[7,"/"],[2,[6,"insurance_claim_procedures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"toggle_bill_to_insurance"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/operatories/toggle_billing_by_operatory(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleBillingByOperatorySettingsLocationOperatoriesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"operatories"],[2,[7,"/"],[2,[6,"toggle_billing_by_operatory"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/marketing/whatconverts/toggle(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleEnterpriseMarketingWhatconvertsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"whatconverts"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/security/toggle_inactivity_timeout
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleInactivityTimeoutEnterpriseSecurityPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[6,"toggle_inactivity_timeout"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/unify/:id/toggle_inbox(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleInboxInternalUnifyPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"unify"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_inbox"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/recall/toggle_location
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleLocationEnterprisePoliciesRecallPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"recall"],[2,[7,"/"],[6,"toggle_location"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/membership_plans/toggle_memberships_managed_by(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleMembershipsManagedByEnterpriseMembershipPlansPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"membership_plans"],[2,[7,"/"],[2,[6,"toggle_memberships_managed_by"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/automated_messages/:id/toggle
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleSettingsPhoneMessagingAutomatedMessagePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"automated_messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"toggle"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/toggle_stripe_auto_save_card
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleStripeAutoSaveCardImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"toggle_stripe_auto_save_card"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/toggle_stripe_auto_save_card(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleStripeAutoSaveCardInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_stripe_auto_save_card"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/overview/toggle_todo
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleTodoImplementationImplementationOverviewPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[6,"toggle_todo"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/perio_charts/tooth_history
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toothHistoryLocationPatientPerioChartsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"perio_charts"],[2,[7,"/"],[6,"tooth_history"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/applications/:id/track(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trackCredentialingApplicationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"track"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/agent_review/findings/:finding_id/track
 * @param {any} implementationId
 * @param {any} findingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trackImplementationImplementationAgentReviewPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"finding_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"agent_review"],[2,[7,"/"],[2,[6,"findings"],[2,[7,"/"],[2,[3,"finding_id"],[2,[7,"/"],[6,"track"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/schedule/tracking_test/conversion
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trackingTestConversionLocationPatientSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"schedule"],[2,[7,"/"],[2,[6,"tracking_test"],[2,[7,"/"],[6,"conversion"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/schedule/tracking_test/visit
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trackingTestVisitLocationPatientSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"schedule"],[2,[7,"/"],[2,[6,"tracking_test"],[2,[7,"/"],[6,"visit"]]]]]]]]]]);

/**
 * Generates rails route to
 * /training/watch/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trainingWatchRedirectPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"training"],[2,[7,"/"],[2,[6,"watch"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/ambient_sessions/:id/transcript(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transcriptLocationApiV1AmbientSessionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ambient_sessions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"transcript"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:id/transfer_overpayment
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transferOverpaymentLocationPatientInvoicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"transfer_overpayment"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/xray_mounts/:id/transform_photo(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformPhotoApiV1XrayMountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"xray_mounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"transform_photo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/translate
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const translateLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"translate"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/translation_draft
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const translationDraftLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[6,"translation_draft"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/ai_receptionist/:id/translation_drafts(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const translationDraftsEnterpriseAiReceptionistPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"ai_receptionist"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"translation_drafts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/patient_ar/sequence/translation_drafts
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const translationDraftsEnterprisePoliciesPatientArSequencePath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"patient_ar"],[2,[7,"/"],[2,[6,"sequence"],[2,[7,"/"],[6,"translation_drafts"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/patient_intake/translation_drafts
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const translationDraftsEnterprisePoliciesPatientIntakePath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"patient_intake"],[2,[7,"/"],[6,"translation_drafts"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/custom_codes/translation_drafts(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const translationDraftsSettingsLocationCustomCodesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_codes"],[2,[7,"/"],[2,[6,"translation_drafts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/translation_drafts(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const translationDraftsSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"translation_drafts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/automated_messages/translation_drafts
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const translationDraftsSettingsPhoneMessagingAutomatedMessagesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"automated_messages"],[2,[7,"/"],[6,"translation_drafts"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/mango/translation_drafts
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const translationDraftsSettingsPhoneMessagingMangoPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"mango"],[2,[7,"/"],[6,"translation_drafts"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/message_templates/translation_drafts
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const translationDraftsSettingsPhoneMessagingMessageTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"message_templates"],[2,[7,"/"],[6,"translation_drafts"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/treatments/catalog_codes
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const treatmentCatalogCodesLocationPatientOdontogramTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[6,"catalog_codes"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/lab_cases/treatment_options(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const treatmentOptionsLocationLabCasesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"lab_cases"],[2,[7,"/"],[2,[6,"treatment_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/treatment_plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const treatmentPlansDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"treatment_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/treatment_plans(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const treatmentPlansEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"treatment_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard_cards/treatment_plans_trend(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const treatmentPlansTrendDashboardCardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"treatment_plans_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/dashboard_cards/treatment_plans_trend(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const treatmentPlansTrendEnterpriseDashboardCardsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dashboard_cards"],[2,[7,"/"],[2,[6,"treatment_plans_trend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/ai_outreach/trigger(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const triggerInternalAiOutreachIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ai_outreach"],[2,[7,"/"],[2,[6,"trigger"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/ai_outreach/trigger_send(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const triggerSendInternalAiOutreachIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ai_outreach"],[2,[7,"/"],[2,[6,"trigger_send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /turbo/android/path_configuration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turboAndroidPathConfigurationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"turbo"],[2,[7,"/"],[2,[6,"android"],[2,[7,"/"],[2,[6,"path_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /turbo/ios/path_configuration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turboIosPathConfigurationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"turbo"],[2,[7,"/"],[2,[6,"ios"],[2,[7,"/"],[2,[6,"path_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turboRecedeHistoricalLocationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turboRefreshHistoricalLocationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turboResumeHistoricalLocationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/assistants/people/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamAssistantPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"assistants"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/assistants
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamAssistantsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"assistants"]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/assistants/people
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamAssistantsPeoplePath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"assistants"],[2,[7,"/"],[6,"people"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/assistants/training
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamAssistantsTrainingPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"assistants"],[2,[7,"/"],[6,"training"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/calls/:call_id/attribution
 * @param {any} accountId
 * @param {any} callId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamCallAttributionPath = /*#__PURE__*/ __route({"account_id":{"r":true},"call_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[3,"call_id"],[2,[7,"/"],[6,"attribution"]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/calls
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamCallsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"calls"]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/dentists
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamDentistsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"dentists"]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/dentists/people
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamDentistsPeoplePath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dentists"],[2,[7,"/"],[6,"people"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/dentists/training
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamDentistsTrainingPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"dentists"],[2,[7,"/"],[6,"training"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/employees/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamEmployeePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/goals_metrics/chat
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamGoalsMetricsChatPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"goals_metrics"],[2,[7,"/"],[6,"chat"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/goals_metrics/chat/:chat_id/replies
 * @param {any} accountId
 * @param {any} chatId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamGoalsMetricsChatRepliesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"chat_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"goals_metrics"],[2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[3,"chat_id"],[2,[7,"/"],[6,"replies"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/goals_metrics/dashboards/:role
 * @param {any} accountId
 * @param {any} role
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamGoalsMetricsDashboardPath = /*#__PURE__*/ __route({"account_id":{"r":true},"role":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"goals_metrics"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[3,"role"]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/goals_metrics/dashboards/:role/board
 * @param {any} accountId
 * @param {any} role
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamGoalsMetricsDashboardBoardPath = /*#__PURE__*/ __route({"account_id":{"r":true},"role":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"goals_metrics"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[3,"role"],[2,[7,"/"],[6,"board"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/goals_metrics/draft/read
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamGoalsMetricsDraftReadPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"goals_metrics"],[2,[7,"/"],[2,[6,"draft"],[2,[7,"/"],[6,"read"]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/hygiene
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamHygienePath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"hygiene"]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/hygiene/people
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamHygienePeoplePath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"hygiene"],[2,[7,"/"],[6,"people"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/hygiene/training
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamHygieneTrainingPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"hygiene"],[2,[7,"/"],[6,"training"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/practice_attempts/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamPracticeAttemptPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"practice_attempts"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/practice_scenarios/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamPracticeScenarioPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"practice_scenarios"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/reviews
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamReviewsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"reviews"]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamRootPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[3,"account_id"]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/roster
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamRosterPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"roster"]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scenarios/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamScenarioPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scenarios/:scenario_id/example
 * @param {any} accountId
 * @param {any} scenarioId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamScenarioExamplePath = /*#__PURE__*/ __route({"account_id":{"r":true},"scenario_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[6,"example"]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scenarios
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamScenariosPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"scenarios"]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scorecards/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamScorecardPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scorecards
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamScorecardsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"scorecards"]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/settings
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamSettingsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"settings"]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/settings/role_mappings/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamSettingsRoleMappingPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"role_mappings"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/teasers/:key
 * @param {any} accountId
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamTeaserPath = /*#__PURE__*/ __route({"account_id":{"r":true},"key":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"teasers"],[2,[7,"/"],[3,"key"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/time_attendance
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamTimeAttendancePath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"time_attendance"]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/time_attendance/activity
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamTimeAttendanceActivityPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"time_attendance"],[2,[7,"/"],[6,"activity"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/time_attendance/export_csv
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamTimeAttendanceExportCsvPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"time_attendance"],[2,[7,"/"],[6,"export_csv"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/time_attendance/print
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamTimeAttendancePrintPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"time_attendance"],[2,[7,"/"],[6,"print"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/time_attendance/punches/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamTimeAttendancePunchPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"time_attendance"],[2,[7,"/"],[2,[6,"punches"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/time_attendance/punches/:id/history
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamTimeAttendancePunchHistoryPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"time_attendance"],[2,[7,"/"],[2,[6,"punches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"history"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/time_attendance/punches/:id/times
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamTimeAttendancePunchTimesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"time_attendance"],[2,[7,"/"],[2,[6,"punches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"times"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/time_attendance/punches
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamTimeAttendancePunchesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"time_attendance"],[2,[7,"/"],[6,"punches"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/training
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamTrainingPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"training"]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/treatment_coordinators/people/:id
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamTreatmentCoordinatorPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"treatment_coordinators"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/treatment_coordinators
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamTreatmentCoordinatorsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[6,"treatment_coordinators"]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/treatment_coordinators/people
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamTreatmentCoordinatorsPeoplePath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"treatment_coordinators"],[2,[7,"/"],[6,"people"]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/treatment_coordinators/training
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twelveTeamTreatmentCoordinatorsTrainingPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"treatment_coordinators"],[2,[7,"/"],[6,"training"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/unallocated_wallet_check_mismatches
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unallocatedWalletCheckMismatchesImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"unallocated_wallet_check_mismatches"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/unallocated_wallet_check_status
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unallocatedWalletCheckStatusImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"unallocated_wallet_check_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/unapprove_outreach_candidate(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unapproveOutreachCandidateLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unapprove_outreach_candidate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/credential_types/:id/unarchive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveCredentialingCredentialTypePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"credential_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/payers/:id/unarchive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveCredentialingPayerPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"payers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/payer_application_forms/:id/unarchive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveCredentialingPayerApplicationFormPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"payer_application_forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/practices/:id/unarchive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveCredentialingPracticePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"practices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/profiles/:id/unarchive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveCredentialingProfilePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/agents/:id/unarchive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveEnterpriseAgentPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/custom_codes/:id/unarchive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveEnterpriseCustomCodePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"custom_codes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/library/presentations/:id/unarchive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveEnterpriseLibraryPagePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/membership_plans/:id/unarchive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveEnterpriseMembershipPlanPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"membership_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_prompts/:id/unarchive
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveEnterprisePoliciesClinicalNotePromptPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"clinical_note_prompts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unarchive"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_templates/:id/unarchive
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveEnterprisePoliciesClinicalNoteTemplatePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unarchive"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/prescription_favorites/:id/unarchive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveEnterprisePrescriptionFavoritePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"prescription_favorites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/categories/:id/unarchive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveEnterpriseReferralsCategoryPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/letter_template/unarchive(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveEnterpriseReferralsLetterTemplatePath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letter_template"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/practices/:id/unarchive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveEnterpriseReferralsPracticePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"practices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/referrals/providers/:id/unarchive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveEnterpriseReferralsProviderPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/users/:id/unarchive(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveEnterpriseUserPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:id/unarchive
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveInternalImplementationPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unarchive"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/fee_schedules/:id/unarchive
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveLocationFeeSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"fee_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unarchive"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/unarchive
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unarchive"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/categories/:id/unarchive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveLocationReferralsCategoryPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/letter_template/unarchive(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveLocationReferralsLetterTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letter_template"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/practices/:id/unarchive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveLocationReferralsPracticePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"practices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/providers/:id/unarchive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveLocationReferralsProviderPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/unarchive_outreach_candidate_patient(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveOutreachCandidatePatientLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive_outreach_candidate_patient"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_prompts/:id/unarchive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveSettingsClinicalNotePromptPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_prompts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_templates/:id/unarchive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveSettingsClinicalNoteTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/adjustment_types/:id/unarchive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveSettingsLocationAdjustmentTypePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"adjustment_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/custom_codes/:id/unarchive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveSettingsLocationCustomCodePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_codes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/labs/:id/unarchive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveSettingsLocationLabPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"labs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/operatories/:id/unarchive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveSettingsLocationOperatoryPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"operatories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/prescription_favorites/:id/unarchive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveSettingsLocationPrescriptionFavoritePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"prescription_favorites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/providers/:id/unarchive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveSettingsProviderPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"providers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scenarios/:id/unarchive
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveTwelveTeamScenarioPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unarchive"]]]]]]]]]]);

/**
 * Generates rails route to
 * /twelve_team/:account_id/scorecards/:id/unarchive
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveTwelveTeamScorecardPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"twelve_team"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unarchive"]]]]]]]]]]);

/**
 * Generates rails route to
 * /central/:account_id/rcm/dashboard/uncollected_balance_rows
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uncollectedBalanceRowsCentralRcmDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"uncollected_balance_rows"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/dashboard/uncollected_balance_rows
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uncollectedBalanceRowsLocationRcmDashboardIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"uncollected_balance_rows"]]]]]]]]]]);

/**
 * Generates rails route to
 * /central/:account_id/rcm/dashboard/uncollected_balances
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uncollectedBalancesCentralRcmDashboardIndexPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"central"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"uncollected_balances"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/uncollected_balances(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uncollectedBalancesEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"uncollected_balances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/dashboard/uncollected_balances
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uncollectedBalancesLocationRcmDashboardIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[6,"uncollected_balances"]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/uncollected_balances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uncollectedBalancesReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"uncollected_balances"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/uncreated_claims_export_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uncreatedClaimsExportCsvReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"uncreated_claims_export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/uncreated_claims(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uncreatedClaimsReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"uncreated_claims"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/documents/:document_id/undismiss_check
 * @param {any} locationId
 * @param {any} id
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const undismissDocumentCheckLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"document_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[6,"undismiss_check"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/time_blocks/:id/undo_exception(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const undoExceptionLocationTimeBlockPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"time_blocks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"undo_exception"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/time_blocks/:id/undo_split(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const undoSplitLocationTimeBlockPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"time_blocks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"undo_split"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/unfinalize
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unfinalizeLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unfinalize"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/unfinalize_preview
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unfinalizePreviewLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unfinalize_preview"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/unfinalize_preview
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unfinalizePreviewRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unfinalize_preview"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/unfinalize
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unfinalizeRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unfinalize"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/accounts/:id/unignore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unignoreInternalBillingAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unignore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/inbound_records/:id/unlink_appointment(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkAppointmentLocationReferralsInboundRecordPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"inbound_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unlink_appointment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/unlink_bank_deposit
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkBankDepositLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unlink_bank_deposit"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/unlink_bank_deposit
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkBankDepositLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unlink_bank_deposit"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/unlink_bank_deposit
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkBankDepositRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unlink_bank_deposit"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/unlink_bank_deposit
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkBankDepositRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unlink_bank_deposit"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/unlink_dialstack
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkDialstackInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"unlink_dialstack"]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/unlink_go_live_location
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkGoLiveLocationImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"unlink_go_live_location"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/:id/unlink_implementation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkImplementationInternalGoLivePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unlink_implementation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/documents/:id/unlink_patient
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkPatientLocationRcmDocumentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unlink_patient"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/unlink_virtual_card_charge
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkVirtualCardChargeLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unlink_virtual_card_charge"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/unlink_virtual_card_charge
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkVirtualCardChargeRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unlink_virtual_card_charge"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/unpin(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unpinLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unpin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_notes/:id/unpin
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unpinLocationPatientPatientNotePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unpin"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_premedications/:id/unpin
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unpinLocationPatientPatientPremedicationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_premedications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unpin"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/knowledge/:id/unpublish_pylon(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unpublishPylonInternalKnowledgePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"knowledge"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unpublish_pylon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/treatment_plans/:id/unreject(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unrejectLocationApiV1PatientTreatmentPlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unreject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/unresolve
 * @param {any} locationId
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unresolveConversationLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[6,"unresolve"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_lives/unschedule_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unscheduleAccountInternalGoLivesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_lives"],[2,[7,"/"],[2,[6,"unschedule_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/unschedule(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unscheduleLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unschedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/unscheduled_patients_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unscheduledPatientsDataReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"unscheduled_patients_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/unscheduled_patients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unscheduledPatientsReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"unscheduled_patients"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/unscheduled_treatments_data(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unscheduledTreatmentsDataEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"unscheduled_treatments_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/reports/unscheduled_treatments(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unscheduledTreatmentsEnterpriseReportsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"unscheduled_treatments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/clinical_notes/unseal(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsealLocationApiV1ClinicalNotesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clinical_notes"],[2,[7,"/"],[2,[6,"unseal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/unsend
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsendLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unsend"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/eob_uploads/:id/documents/:document_id/unskip
 * @param {any} locationId
 * @param {any} id
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unskipDocumentLocationRcmEobUploadPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"document_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"eob_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[6,"unskip"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/unskip_outreach_candidate(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unskipOutreachCandidateLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unskip_outreach_candidate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/plan_subscription/unsuspend
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsuspendLocationPatientPlanSubscriptionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"plan_subscription"],[2,[7,"/"],[6,"unsuspend"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_account_appointment_category
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateAccountAppointmentCategoryImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_account_appointment_category"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_account_default_appointment_category
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateAccountDefaultAppointmentCategoryImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_account_default_appointment_category"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/confirmation_add_ons/update_add_on
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateAddOnEnterprisePoliciesConfirmationAddOnsPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"confirmation_add_ons"],[2,[7,"/"],[6,"update_add_on"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_ai_outreach_settings
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateAiOutreachSettingsImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_ai_outreach_settings"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/fee_schedules/:id/update_all_treatments
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateAllTreatmentsLocationFeeSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"fee_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_all_treatments"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_alerts/update_allergies_form
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateAllergiesFormLocationPatientClinicalAlertsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_alerts"],[2,[7,"/"],[6,"update_allergies_form"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/update_allergy(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateAllergySettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"update_allergy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/users/:id/update_allowed_ips(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateAllowedIpsEnterpriseUserPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_allowed_ips"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_appointment_colors
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateAppointmentColorsImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_appointment_colors"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/areas/:area_key(.:format)
 * @param {any} areaKey
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateAreaInternalGoLiveConfigPath = /*#__PURE__*/ __route({"area_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/tasks/:id/update_assignee(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateAssigneeLocationTaskPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_assignee"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/plan_subscription/update_auto_renew
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateAutoRenewLocationPatientPlanSubscriptionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"plan_subscription"],[2,[7,"/"],[6,"update_auto_renew"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/update_billing_notes
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateBillingNotesLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_billing_notes"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/preferences/update_blur_sensitive(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateBlurSensitiveInternalPreferencesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"preferences"],[2,[7,"/"],[2,[6,"update_blur_sensitive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/devices/:id/update_calibration
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCalibrationLocationApiV1DevicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"devices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_calibration"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/eob_status/update_carrier_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCarrierConfigInternalEobStatusIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"eob_status"],[2,[7,"/"],[2,[6,"update_carrier_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/claim_completeness/:id/update_carrier_override(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCarrierOverrideRcmServicesClaimCompletenessPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"claim_completeness"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_carrier_override"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/appointment_categories/update_category
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCategoryEnterprisePoliciesAppointmentCategoriesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"appointment_categories"],[2,[7,"/"],[6,"update_category"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/claim_completeness/:id/update_category(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCategoryRcmServicesClaimCompletenessPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"claim_completeness"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_plan_settings/:id/update_category(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCategoryRcmServicesInsurancePlanSettingPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_plan_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/appointment_categories/update_category(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCategorySettingsLocationAppointmentCategoriesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"appointment_categories"],[2,[7,"/"],[2,[6,"update_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/treatment_catalogs/update_category(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCategorySettingsTreatmentCatalogsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"treatment_catalogs"],[2,[7,"/"],[2,[6,"update_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/automated_messages/:id/update_channel
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateChannelSettingsPhoneMessagingAutomatedMessagePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"automated_messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_channel"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/check_in/update_config
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCheckInConfigLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[6,"update_config"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/forms/update_check_in_config
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCheckInConfigLocationPatientFormsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[6,"update_check_in_config"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/check_in/update_notes
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCheckInNotesLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[6,"update_notes"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_check_in_policy
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCheckInPolicyImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_check_in_policy"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/check_out/update_notes
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCheckOutNotesLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_out"],[2,[7,"/"],[6,"update_notes"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_check_out_policy
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCheckOutPolicyImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_check_out_policy"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/update_claim_denial_reasons(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateClaimDenialReasonsRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_claim_denial_reasons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_claim_submission_policy
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateClaimSubmissionPolicyImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_claim_submission_policy"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/integrations/update_clinician_roles
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateClinicianRolesInternalIntegrationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[6,"update_clinician_roles"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_plan_settings/:id/update_code_group(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCodeGroupRcmServicesInsurancePlanSettingPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_plan_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_code_group"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/update_color(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateColorLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_color"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/pin/update_color(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateColorSettingsPinPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"pin"],[2,[7,"/"],[2,[6,"update_color"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/messages_v2/conversation/:conversation_id/comm_logs/:id
 * @param {any} locationId
 * @param {any} conversationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCommLogLocationMessagesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"conversation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"messages_v2"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"comm_logs"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/ai_outreach/configs/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateConfigSettingsAiOutreachIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ai_outreach"],[2,[7,"/"],[2,[6,"configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/online_scheduling/configs/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateConfigSettingsOnlineSchedulingIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"online_scheduling"],[2,[7,"/"],[2,[6,"configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_contact_numbers
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateContactNumbersImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_contact_numbers"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/ai_outreach/update_context(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateContextSettingsAiOutreachIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ai_outreach"],[2,[7,"/"],[2,[6,"update_context"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/clinical_photos/:id/update_coordinate_name(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCoordinateNameLocationApiV1PatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_coordinate_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/credentials/:id
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCredentialImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/update_daily_migration_run_schedule
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDailyMigrationRunScheduleImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"update_daily_migration_run_schedule"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:id/update_date
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDateLocationPatientInvoicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_date"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/appointment_categories/update_default_category
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDefaultCategoryEnterprisePoliciesAppointmentCategoriesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"appointment_categories"],[2,[7,"/"],[6,"update_default_category"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/appointment_categories/update_default_category(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDefaultCategorySettingsLocationAppointmentCategoriesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"appointment_categories"],[2,[7,"/"],[2,[6,"update_default_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_denticon_sync
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDenticonSyncImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_denticon_sync"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/mounts_devices/devices/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDeviceSettingsMountsDevicesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"mounts_devices"],[2,[7,"/"],[2,[6,"devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_document
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDocumentImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_document"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/billing/accounts/:id/update_dosespot_assignments(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDosespotAssignmentsInternalBillingAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_dosespot_assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_dosespot_config
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDosespotConfigImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_dosespot_config"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/update_dosespot_config(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDosespotConfigInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_dosespot_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/preferences/update_env_warning_border(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateEnvWarningBorderInternalPreferencesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"preferences"],[2,[7,"/"],[2,[6,"update_env_warning_border"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/update_eob
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateEobLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_eob"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/update_eob
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateEobRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_eob"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/calendar/update_event/:id
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateEventImplementationImplementationCalendarPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"calendar"],[2,[7,"/"],[2,[6,"update_event"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/update_excluded_tables
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateExcludedTablesImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"update_excluded_tables"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_feature_setting
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateFeatureSettingImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_feature_setting"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/insurance_plan_settings/:id/update_field_requirement(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateFieldRequirementRcmServicesInsurancePlanSettingPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"insurance_plan_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_field_requirement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/preferences/update_force_windows_hotkeys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateForceWindowsHotkeysInternalPreferencesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"preferences"],[2,[7,"/"],[2,[6,"update_force_windows_hotkeys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_alerts/update_form
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateFormLocationPatientClinicalAlertsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_alerts"],[2,[7,"/"],[6,"update_form"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/go_live_options/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateGoLiveOptionInternalGoLiveConfigPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"go_live_options"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammates/:id/update_goals(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateGoalsRcmServicesTeammatePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_goals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/families/:id/update_guarantor
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateGuarantorLocationFamilyPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"families"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_guarantor"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/snapshots/update_hoh_override
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateHohOverrideImplementationImplementationSnapshotsPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"snapshots"],[2,[7,"/"],[6,"update_hoh_override"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/online_scheduling/update_hours(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateHoursSettingsOnlineSchedulingIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"online_scheduling"],[2,[7,"/"],[2,[6,"update_hours"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/update_ignored_adjustment_codes
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateIgnoredAdjustmentCodesImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"update_ignored_adjustment_codes"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/update_ignored_payment_codes
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateIgnoredPaymentCodesImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"update_ignored_payment_codes"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_in_appointment_policy
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateInAppointmentPolicyImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_in_appointment_policy"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/update_insurance_coverage_ordinal
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateInsuranceCoverageOrdinalLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_insurance_coverage_ordinal"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_insurance_posting_policy
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateInsurancePostingPolicyImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_insurance_posting_policy"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/insurance/request_submissions/:submission_id
 * @param {any} locationId
 * @param {any} id
 * @param {any} submissionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateInsuranceRequestSubmissionLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"submission_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"insurance"],[2,[7,"/"],[2,[6,"request_submissions"],[2,[7,"/"],[3,"submission_id"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup/items/:id
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateItemImplementationImplementationSetupPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/treatment_catalogs/update_item(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateItemSettingsTreatmentCatalogsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"treatment_catalogs"],[2,[7,"/"],[2,[6,"update_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_lab
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateLabImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_lab"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_legal_pages
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateLegalPagesImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_legal_pages"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/update_legal_pages(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateLegalPagesInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_legal_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_location_feature_setting
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateLocationFeatureSettingImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_location_feature_setting"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_location_identity
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateLocationIdentityImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_location_identity"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/location_todos/:id
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateLocationTodoImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[2,[6,"location_todos"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation/update_login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateLoginInternalRcmAutomationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[2,[7,"/"],[2,[6,"update_login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_mango_messages
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateMangoMessagesImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_mango_messages"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/dosespot/update_manual
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateManualLocationDosespotPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"dosespot"],[2,[7,"/"],[6,"update_manual"]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_merge_target
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateMergeTargetImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_merge_target"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/rcm_ai_models/update_model(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateModelRcmServicesRcmAiModelsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"rcm_ai_models"],[2,[7,"/"],[2,[6,"update_model"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/invoices/:id/update_notes
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateNotesLocationPatientInvoicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_notes"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/pre_authorizations/:id/update_notes
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateNotesLocationPatientPreAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"pre_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_notes"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_office_hours
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateOfficeHoursImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_office_hours"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_operatory
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateOperatoryImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_operatory"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/data/update_oryx_credential
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateOryxCredentialImplementationImplementationDataPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[6,"update_oryx_credential"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/update_outreach_candidate_comment(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateOutreachCandidateCommentLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_outreach_candidate_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/update_outreach_candidate_message(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateOutreachCandidateMessageLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_outreach_candidate_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/claim_completeness/:id/update_override(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateOverrideRcmServicesClaimCompletenessPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"claim_completeness"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_override"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/connected_apps/partners/:partner
 * @param {any} accountId
 * @param {any} partner
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePartnerEnterpriseConnectedAppsPath = /*#__PURE__*/ __route({"account_id":{"r":true},"partner":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"connected_apps"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[3,"partner"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_patient_ar_policy
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePatientArPolicyImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_patient_ar_policy"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_plans/:id/update_payment_method
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePaymentMethodLocationPatientPaymentPlanPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_payment_method"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/plan_subscription/update_payment_method
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePaymentMethodLocationPatientPlanSubscriptionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"plan_subscription"],[2,[7,"/"],[6,"update_payment_method"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_payment_settings
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePaymentSettingsImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_payment_settings"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_payment_types
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePaymentTypesImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_payment_types"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_pearl_config
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePearlConfigImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_pearl_config"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/update_pearl_config(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePearlConfigInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_pearl_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/phases/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePhaseInternalGoLiveConfigPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"phases"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/insurance_carriers/:id/update_phone_line
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePhoneLineInternalInsuranceCarrierPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_phone_line"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/claim_completeness/update_pre_auth_rule(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePreAuthRuleRcmServicesClaimCompletenessIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"claim_completeness"],[2,[7,"/"],[2,[6,"update_pre_auth_rule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/update_preview_chief_complaint(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePreviewChiefComplaintLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_preview_chief_complaint"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/update_preview_custom_field(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePreviewCustomFieldLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_preview_custom_field"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/update_preview(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePreviewLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/update_preview_notes(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePreviewNotesLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_preview_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/update_problem_group(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateProblemGroupSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"update_problem_group"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/forms/update_problem(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateProblemSettingsPatientFormTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"update_problem"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_production_goals
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateProductionGoalsImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_production_goals"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammates/:id/update_profile(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateProfileRcmServicesTeammatePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_templates/update_prompt
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePromptEnterprisePoliciesClinicalNoteTemplatesPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[6,"update_prompt"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_templates/update_prompt(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePromptSettingsClinicalNoteTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[2,[6,"update_prompt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/treatments/update_provider
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateProviderLocationPatientOdontogramTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[6,"update_provider"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_provider_login
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateProviderLoginImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_provider_login"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/verification_api_requests/update_provider_mode(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateProviderModeInternalVerificationApiRequestsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"verification_api_requests"],[2,[7,"/"],[2,[6,"update_provider_mode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_pylon_config
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePylonConfigImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_pylon_config"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/update_pylon_config(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePylonConfigInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_pylon_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encodedToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRailsDiskServicePath = /*#__PURE__*/ __route({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/families/:id/update_relationship
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRelationshipLocationFamilyPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"families"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_relationship"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_retell_config
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRetellConfigImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_retell_config"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/update_retell_config(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRetellConfigInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_retell_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/users/:id/update_roles(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRolesEnterpriseUserPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammates/:id/update_schedule(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateScheduleRcmServicesTeammatePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/appointment_categories/update_scope(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateScopeSettingsLocationAppointmentCategoriesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"appointment_categories"],[2,[7,"/"],[2,[6,"update_scope"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/insurance_carriers/:id/update_script(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateScriptInternalInsuranceCarrierPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"insurance_carriers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_script"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /update_session_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateSessionLocationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"update_session_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:id/update_setting(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateSettingInternalAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/update_setting(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateSettingInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/feature_flags/update_setting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateSettingInternalFeatureFlagsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[6,"update_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/phone_messaging/message_templates/:id
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateSettingsPhoneMessagingMessageTemplatesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"phone_messaging"],[2,[7,"/"],[2,[6,"message_templates"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/ai_outreach/update_settings(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateSettingsSettingsAiOutreachIndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ai_outreach"],[2,[7,"/"],[2,[6,"update_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_setup_contacts
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateSetupContactsImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_setup_contacts"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/update_slack_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateSlackReportsInternalGoLiveConfigPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"update_slack_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_station_task_cell
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateStationTaskCellImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_station_task_cell"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/station_tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateStationTaskInternalGoLiveConfigPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"station_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/bank_deposits/:id/update_status
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateStatusLocationBankDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"bank_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/inbound_records/:id/update_status(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateStatusLocationReferralsInboundRecordPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"inbound_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/outbound_records/:id/update_status(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateStatusLocationReferralsOutboundRecordPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"outbound_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bank_transactions/:id/update_status
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateStatusRcmServicesPostingBankTransactionPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bank_transactions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_swell_config
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateSwellConfigImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_swell_config"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/update_swell_config(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateSwellConfigInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_swell_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/patients/:patient_id/clinical_photos/:id/update_taken_at(.:format)
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateTakenAtLocationApiV1PatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_taken_at"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/inbox/:id/update_task_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateTaskStatusRcmServicesInboxPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_task_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_team
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateTeamImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_team"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/mounts_devices/templates/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateTemplateSettingsMountsDevicesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"mounts_devices"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/go_live_config/todos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateTodoInternalGoLiveConfigPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"go_live_config"],[2,[7,"/"],[2,[6,"todos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/overview/update_todo_state
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateTodoStateImplementationImplementationOverviewPath = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[6,"update_todo_state"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/treatments/:treatment_id/code_and_site
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} treatmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateTreatmentCodeAndSiteLocationPatientOdontogramTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"treatment_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[2,[3,"treatment_id"],[2,[7,"/"],[6,"code_and_site"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/odontogram/treatments/:treatment_id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} treatmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateTreatmentLocationPatientOdontogramTreatmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"treatment_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"treatments"],[2,[7,"/"],[3,"treatment_id"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_twilio_config
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateTwilioConfigImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_twilio_config"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/update_twilio_config(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateTwilioConfigInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_twilio_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/recall/update_type
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateTypeEnterprisePoliciesRecallPath = /*#__PURE__*/ __route({"account_id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"recall"],[2,[7,"/"],[6,"update_type"]]]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/policies/clinical_note_templates/:id/update_visibility
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateVisibilityEnterprisePoliciesClinicalNoteTemplatePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"update_visibility"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/settings/clinical_note_templates/:id/update_visibility(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateVisibilitySettingsClinicalNoteTemplatePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"clinical_note_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_visibility"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/update_vyne_config
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateVyneConfigImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"update_vyne_config"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/accounts/:account_id/locations/:id/update_vyne_config(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateVyneConfigInternalAccountLocationPath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_vyne_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/update_waitlist_notes(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateWaitlistNotesLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_waitlist_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/:id/update_waitlist_preference(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateWaitlistPreferenceLocationAppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_waitlist_preference"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/patient_payments/update_wallet_merchant_fee
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateWalletMerchantFeeLocationPatientPatientPaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"patient_payments"],[2,[7,"/"],[6,"update_wallet_merchant_fee"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/patient_files/upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadApiV1PatientFilesPath = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patient_files"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/upload_batch
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadBatchLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"upload_batch"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/upload_batch
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadBatchRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"upload_batch"]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/payer_application_forms/:id/upload(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadCredentialingPayerApplicationFormPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"payer_application_forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/upload_eob_file
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadEobFileLocationInsurancePaymentsPath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[6,"upload_eob_file"]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/upload_eob_file
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadEobFileRcmServicesPostingPaymentsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[6,"upload_eob_file"]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/medical_claims/:id/upload_eob
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadEobLocationPatientMedicalClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"medical_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"upload_eob"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/deposit_triage/:id/upload_eop
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadEopRcmServicesDepositTriagePath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"deposit_triage"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"upload_eop"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/files_v2/upload
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadLocationPatientFilesV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"files_v2"],[2,[7,"/"],[6,"upload"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/payment_plan_agreements/:id/upload
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadLocationPatientPaymentPlanAgreementPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"payment_plan_agreements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"upload"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/referrals/letters/:letter_id/images/upload(.:format)
 * @param {any} locationId
 * @param {any} letterId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadLocationReferralsLetterImagesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"letter_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"letters"],[2,[7,"/"],[2,[3,"letter_id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/upload_medical_eob
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadMedicalEobLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"upload_medical_eob"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/agreements_v2/upload_payment_plan
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadPaymentPlanLocationPatientAgreementsV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"agreements_v2"],[2,[7,"/"],[6,"upload_payment_plan"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/rcm/bulk_deposits/:id/upload_pending_document
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadPendingDocumentLocationRcmBulkDepositPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"rcm"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"upload_pending_document"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/bulk_deposits/:id/upload_pending_document
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadPendingDocumentRcmServicesPostingBulkDepositPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"bulk_deposits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"upload_pending_document"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/xray_mounts/:id/upload_photo(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadPhotoApiV1XrayMountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"xray_mounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload_photo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/clinical_photos/:id/upload_photos
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadPhotosLocationPatientClinicalPhotoPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"clinical_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"upload_photos"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/upload_picture
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadPictureLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"upload_picture"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/upload_profile_picture
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadProfilePictureLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"upload_profile_picture"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/upload_profile_picture_modal
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadProfilePictureModalLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"upload_profile_picture_modal"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/perio_charts/:id/upload_voice_debug_log
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadVoiceDebugLogLocationPatientPerioChartPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"perio_charts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"upload_voice_debug_log"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/curve_exports/:id/use_as_source
 * @param {any} implementationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const useAsSourceImplementationImplementationCurveExportPath = /*#__PURE__*/ __route({"implementation_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"curve_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"use_as_source"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/insurance_claims/:id/use_medical_claim_eob
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const useMedicalClaimEobLocationPatientInsuranceClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"insurance_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"use_medical_claim_eob"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userConfirmationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/roles/user_explorer(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userExplorerEnterpriseRolesPath = /*#__PURE__*/ __route({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"user_explorer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPasswordPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userRegistrationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userRootPath = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSessionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/validate_sms_number
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validateSmsNumberLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"validate_sms_number"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/forms/:id/verify
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verifyLocationPatientFormPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"verify"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/payment_plan_agreements/:id/verify
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verifyLocationPaymentPlanAgreementPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"payment_plan_agreements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"verify"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/signatures/:id/verify
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verifyLocationSignatureLinkPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"verify"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/schedule/verify_phone
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verifyPhoneLocationPatientSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"schedule"],[2,[7,"/"],[6,"verify_phone"]]]]]]]]);

/**
 * Generates rails route to
 * /enterprise/:account_id/library/presentations/:id/video(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const videoEnterpriseLibraryPagePath = /*#__PURE__*/ __route({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"video"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentation_snapshots/:id/videos/:page_id
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {any} pageId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const videoLocationPatientTreatmentPresentationSnapshotPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true},"page_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentation_snapshots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[3,"page_id"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/applications/:id/view(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const viewCredentialingApplicationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /credentialing/documents/:id/view(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const viewCredentialingDocumentPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credentialing"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/implementations/:implementation_id/setup_v1/view_document
 * @param {any} implementationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const viewDocumentImplementationImplementationSetupV1Path = /*#__PURE__*/ __route({"implementation_id":{"r":true}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"implementations"],[2,[7,"/"],[2,[3,"implementation_id"],[2,[7,"/"],[2,[6,"setup_v1"],[2,[7,"/"],[6,"view_document"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/perio_charts/:id/view
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const viewLocationPatientPerioChartPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"perio_charts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"view"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/view_profile_picture_modal
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const viewProfilePictureModalLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"view_profile_picture_modal"]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/insurance_payments/:id/virtual_card_charges
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const virtualCardChargesLocationInsurancePaymentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"insurance_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"virtual_card_charges"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/posting/payments/:id/virtual_card_charges
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const virtualCardChargesRcmServicesPostingPaymentPath = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"posting"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"virtual_card_charges"]]]]]]]]]]);

/**
 * Generates rails route to
 * /v/:token
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visitHubPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"v"],[2,[7,"/"],[3,"token"]]]]);

/**
 * Generates rails route to
 * /v/:token/add_ons/:add_on_id
 * @param {any} token
 * @param {any} addOnId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visitHubAddOnPath = /*#__PURE__*/ __route({"token":{"r":true},"add_on_id":{"r":true}}, [2,[7,"/"],[2,[6,"v"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"add_ons"],[2,[7,"/"],[3,"add_on_id"]]]]]]]]);

/**
 * Generates rails route to
 * /v/:token/forms
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visitHubFormsPath = /*#__PURE__*/ __route({"token":{"r":true}}, [2,[7,"/"],[2,[6,"v"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[6,"forms"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/medical_claims/:id/void
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const voidLocationPatientMedicalClaimPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"medical_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"void"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/inbox/:id/wait(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const waitLocationInboxPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"wait"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/check_in/items/:key/waive
 * @param {any} locationId
 * @param {any} id
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const waiveCheckInItemLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"key":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_in"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"key"],[2,[7,"/"],[6,"waive"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:id/check_out/items/:key/waive
 * @param {any} locationId
 * @param {any} id
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const waiveCheckOutItemLocationPatientPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"key":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_out"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"key"],[2,[7,"/"],[6,"waive"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/appointments/:id/checklist_items/:key/waive(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const waiveChecklistItemLocationApiV1AppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"key":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"checklist_items"],[2,[7,"/"],[2,[3,"key"],[2,[7,"/"],[2,[6,"waive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/api/v1/appointments/:id/walked_out(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const walkedOutLocationApiV1AppointmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"walked_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/patients/:patient_id/odontogram/web_redirect(.:format)
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webRedirectApiV1PatientOdontogramPath = /*#__PURE__*/ __route({"patient_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"odontogram"],[2,[7,"/"],[2,[6,"web_redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/goto/:scope_id/call_events
 * @param {any} scopeId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksPath = /*#__PURE__*/ __route({"scope_id":{"r":true}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"goto"],[2,[7,"/"],[2,[3,"scope_id"],[2,[7,"/"],[6,"call_events"]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/dialstack
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksDialstackPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[6,"dialstack"]]]]);

/**
 * Generates rails route to
 * /webhooks/dialstack/voice_app
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksDialstackVoiceAppPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"dialstack"],[2,[7,"/"],[6,"voice_app"]]]]]]);

/**
 * Generates rails route to
 * /webhooks/dosespot/notification_count
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksDosespotNotificationCountPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"dosespot"],[2,[7,"/"],[6,"notification_count"]]]]]]);

/**
 * Generates rails route to
 * /webhooks/email/insurance
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksEmailInsurancePath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[6,"insurance"]]]]]]);

/**
 * Generates rails route to
 * /webhooks/goto/:scope_id/call_events
 * @param {any} scopeId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksGotoCallEventsPath = /*#__PURE__*/ __route({"scope_id":{"r":true}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"goto"],[2,[7,"/"],[2,[3,"scope_id"],[2,[7,"/"],[6,"call_events"]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/mango/switchboard/app_request
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksMangoSwitchboardAppRequestPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"mango"],[2,[7,"/"],[2,[6,"switchboard"],[2,[7,"/"],[6,"app_request"]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/mango/switchboard/missed_call
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksMangoSwitchboardMissedCallPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"mango"],[2,[7,"/"],[2,[6,"switchboard"],[2,[7,"/"],[6,"missed_call"]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/mango/switchboard/webhooks_v2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksMangoSwitchboardWebhooksV2Path = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"mango"],[2,[7,"/"],[2,[6,"switchboard"],[2,[7,"/"],[6,"webhooks_v2"]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/plaid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksPlaidPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[6,"plaid"]]]]);

/**
 * Generates rails route to
 * /webhooks/retell/tool_call
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksRetellToolCallPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"retell"],[2,[7,"/"],[6,"tool_call"]]]]]]);

/**
 * Generates rails route to
 * /webhooks/retell/webhook
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksRetellWebhookPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"retell"],[2,[7,"/"],[6,"webhook"]]]]]]);

/**
 * Generates rails route to
 * /webhooks/ses/inbound
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksSesInboundPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"ses"],[2,[7,"/"],[6,"inbound"]]]]]]);

/**
 * Generates rails route to
 * /webhooks/ses/notifications
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksSesNotificationsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"ses"],[2,[7,"/"],[6,"notifications"]]]]]]);

/**
 * Generates rails route to
 * /webhooks/sinch/delivery_report
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksSinchDeliveryReportPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"sinch"],[2,[7,"/"],[6,"delivery_report"]]]]]]);

/**
 * Generates rails route to
 * /webhooks/sinch/inbound_message
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksSinchInboundMessagePath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"sinch"],[2,[7,"/"],[6,"inbound_message"]]]]]]);

/**
 * Generates rails route to
 * /webhooks/stannp
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksStannpPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[6,"stannp"]]]]);

/**
 * Generates rails route to
 * /webhooks/stripe
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksStripePath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[6,"stripe"]]]]);

/**
 * Generates rails route to
 * /webhooks/stripe_connect
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksStripeConnectPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[6,"stripe_connect"]]]]);

/**
 * Generates rails route to
 * /webhooks/twilio/delivery_status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksTwilioDeliveryStatusPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"twilio"],[2,[7,"/"],[6,"delivery_status"]]]]]]);

/**
 * Generates rails route to
 * /webhooks/twilio/inbound_sms
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksTwilioInboundSmsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"twilio"],[2,[7,"/"],[6,"inbound_sms"]]]]]]);

/**
 * Generates rails route to
 * /webhooks/twilio/media_stream_status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksTwilioMediaStreamStatusPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"twilio"],[2,[7,"/"],[6,"media_stream_status"]]]]]]);

/**
 * Generates rails route to
 * /webhooks/twilio/recording
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksTwilioRecordingPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"twilio"],[2,[7,"/"],[6,"recording"]]]]]]);

/**
 * Generates rails route to
 * /webhooks/twilio/registration/:subaccount_id/events
 * @param {any} subaccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksTwilioRegistrationEventsPath = /*#__PURE__*/ __route({"subaccount_id":{"r":true}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"twilio"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[3,"subaccount_id"],[2,[7,"/"],[6,"events"]]]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/twilio/registration/:subaccount_id/profile_status
 * @param {any} subaccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksTwilioRegistrationProfileStatusPath = /*#__PURE__*/ __route({"subaccount_id":{"r":true}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"twilio"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[3,"subaccount_id"],[2,[7,"/"],[6,"profile_status"]]]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/twilio/voice
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksTwilioVoicePath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"twilio"],[2,[7,"/"],[6,"voice"]]]]]]);

/**
 * Generates rails route to
 * /webhooks/twilio/voice_inbound
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksTwilioVoiceInboundPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"twilio"],[2,[7,"/"],[6,"voice_inbound"]]]]]]);

/**
 * Generates rails route to
 * /webhooks/twilio/voice_inbound_status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksTwilioVoiceInboundStatusPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"twilio"],[2,[7,"/"],[6,"voice_inbound_status"]]]]]]);

/**
 * Generates rails route to
 * /webhooks/twilio/voice_status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksTwilioVoiceStatusPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"twilio"],[2,[7,"/"],[6,"voice_status"]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/appointments/weekly_production(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weeklyProductionLocationAppointmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"weekly_production"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /welcome
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcomePath = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"welcome"]]);

/**
 * Generates rails route to
 * /whats_new/posts
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const whatsNewPostsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"whats_new"],[2,[7,"/"],[6,"posts"]]]]);

/**
 * Generates rails route to
 * /whats_new/seen
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const whatsNewSeenPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"whats_new"],[2,[7,"/"],[6,"seen"]]]]);

/**
 * Generates rails route to
 * /rcm_services/reports/wide_reach_changes
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wideReachChangesRcmServicesReportsPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[6,"wide_reach_changes"]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/stats/wide_reach_changes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wideReachChangesRcmServicesStatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"wide_reach_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentation_snapshots/:id/window
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const windowLocationPatientTreatmentPresentationSnapshotPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentation_snapshots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"window"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/treatment_presentations/:id/wording
 * @param {any} locationId
 * @param {any} patientId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wordingLocationPatientTreatmentPresentationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"treatment_presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"wording"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/rcm_automation/worklist(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const worklistInternalRcmAutomationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"rcm_automation"],[2,[7,"/"],[2,[6,"worklist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rcm_services/teammates/:id/workload_projection(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workloadProjectionRcmServicesTeammatePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rcm_services"],[2,[7,"/"],[2,[6,"teammates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"workload_projection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locations/:location_id/patients/:patient_id/forms_v2/write_back
 * @param {any} locationId
 * @param {any} patientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const writeBackLocationPatientFormsV2IndexPath = /*#__PURE__*/ __route({"location_id":{"r":true},"patient_id":{"r":true}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"patients"],[2,[7,"/"],[2,[3,"patient_id"],[2,[7,"/"],[2,[6,"forms_v2"],[2,[7,"/"],[6,"write_back"]]]]]]]]]]]]);

